// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eClubProgrammeForm {
  padding: 10px;
}

/* card */
.eCpfCard {
  max-width: 720px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
  overflow: visible;
}

/* header */

.eCpfHeader {
  padding: 16px 18px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0));
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.eCpfTitleRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.eCpfTitle {
  font-weight: 700;
  font-size: 18px;
  line-height: 1.25;
  margin-bottom: 4px;
}

.eCpfSubtitle {
  color: rgba(0, 0, 0, 0.55);
  font-size: 13px;
}

.eCpfMeta {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  margin-top: 2px;
}

.eCpfRequiredPill {
  border: 1px solid rgba(0, 0, 0, 0.14);
  background: rgba(0, 0, 0, 0.02);
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 600;
}

.eCpfRequiredNote {
  white-space: nowrap;
}

.eCpfAsterisk {
  color: #c62828;
  font-weight: 700;
}

/* body */
.eCpfBody {
  padding: 14px 18px;
}

.eCpfField {
  margin-top: 2px;
}

.eCpfLabel {
  display: block;
  font-weight: 700;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.82);
}

/* input */
.eCpfInputWrap {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  background: #fff;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.eCpfInputWrap:focus-within {
  border-color: rgba(0, 0, 0, 0.38);
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.06);
}

.eCpfInputWrap.is-invalid {
  border-color: rgba(198, 40, 40, 0.65);
  box-shadow: 0 0 0 4px rgba(198, 40, 40, 0.1);
}

.eCpfInput {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  padding: 11px 12px;
  font-size: 14px;
}

.eCpfInput::placeholder {
  color: rgba(0, 0, 0, 0.35);
}

/* hint + error */
.eCpfHint {
  margin-top: 5px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  line-height: 1.3;
}

/* alerts */
.eCpfAlert {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.eCpfAlertTitle {
  font-weight: 800;
  margin-bottom: 4px;
}

.eCpfAlertText {
  color: rgba(0, 0, 0, 0.68);
  font-size: 13px;
}

.eCpfAlertDanger {
  background: rgba(198, 40, 40, 0.08);
  border-color: rgba(198, 40, 40, 0.2);
}

/* footer */
.eCpfGrid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 14px;
}

.eCpfFooter {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 18px;
  background: rgba(0, 0, 0, 0.015);
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.eCpfColSpan2 {
  grid-column: 1 / span 2;
}

.eCpfDate {
  width: 100%;
}

@media (max-width: 720px) {
  .eCpfGrid2 {
    grid-template-columns: 1fr;
  }
  .eCpfColSpan2 {
    grid-column: 1 / span 1;
  }
}

.eCpfCard {
  margin: 0 auto;
}

.eCpfTitleLeft {
  min-width: 0;
}

.eCpfTitleLine {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* badge */
.eCpfStatusBadge {
  font-size: 12px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 999px;
  letter-spacing: 0.3px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.7);
}

/* DRAFT */
.eCpfStatus-draft {
  background: rgba(96, 125, 139, 0.1);
  border-color: rgba(96, 125, 139, 0.28);
  color: rgba(55, 71, 79, 0.95);
}

/* ACTIVE */
.eCpfStatus-active {
  background: rgba(46, 125, 50, 0.12);
  border-color: rgba(46, 125, 50, 0.28);
  color: rgba(27, 94, 32, 0.95);
}

/* ARCHIVED */
.eCpfStatus-archived {
  background: rgba(94, 53, 177, 0.12);
  border-color: rgba(94, 53, 177, 0.28);
  color: rgba(69, 39, 160, 0.95);
}

.eCpfStatus-active {
  background: rgba(46, 125, 50, 0.1);
  border-color: rgba(46, 125, 50, 0.25);
}
.eCpfStatus-archived {
  background: rgba(94, 53, 177, 0.1);
  border-color: rgba(94, 53, 177, 0.25);
}

/* select styling */
.eCpfSelect {
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  padding-right: 38px;
}

.eCpfInputWrap:has(.eCpfSelect) {
  position: relative;
}

.eCpfInputWrap:has(.eCpfSelect)::after {
  content: '';
  position: absolute;
  right: 14px;
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-40%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid rgba(0, 0, 0, 0.45);
  pointer-events: none;
}

.eCpfRowHeader {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.eCpfTwoCols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
  align-items: start;
}

.eCpfDateWrap {
  max-width: 320px;
}

.eCpfLabelSmall {
  display: block;
  font-weight: 700;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 13px;
}

.eCpfError {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(198, 40, 40, 0.08);
  border: 1px solid rgba(198, 40, 40, 0.22);
  color: rgba(198, 40, 40, 0.95);
  font-size: 13px;
  max-width: 320px;
}

.eCpfHeader {
  position: relative;
}

.eCpfClose {
  position: absolute;
  top: 10px;
  right: 12px;

  width: 34px;
  height: 34px;
  border-radius: 10px;

  border: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.02);

  font-size: 22px;
  line-height: 30px;
  text-align: center;

  color: rgba(0, 0, 0, 0.55);
  cursor: pointer;
}

.eCpfClose:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.75);
}

.eCpfLabelInline {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
}

.eCpfHintInline {
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

.cpFooter {
  margin-top: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.cpDetailTabsWrap .GenericSummary {
  flex: 1 1 auto;
  min-height: 0;
}

.cpDetailTabsWrap .GenericSummary__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

/* Body paddings */
.cpFooterBody {
  padding: 14px 16px 12px 16px;
}

/* Header */
.cpFooterHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.cpTitle {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  color: #1f2937; /* neutral dark */
}

.cpBadges {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cpBadge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.02);
  color: #374151;
}

.cpBadge--muted {
  background: rgba(0, 0, 0, 0.03);
}

/* Status coloring (subtle) */
.cpBadge--status {
  background: rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.22);
  color: #1d4ed8;
}

.cpStatus--draft {
  background: rgba(107, 114, 128, 0.1);
  border-color: rgba(107, 114, 128, 0.22);
  color: #374151;
}

.cpStatus--published {
  background: rgba(16, 185, 129, 0.1);
  border-color: rgba(16, 185, 129, 0.22);
  color: #047857;
}

.cpBadge--danger {
  color: #721c24;
  background: #f8d7da;
  border-color: #f5c6cb;
}

.cpBadge--warn {
  color: #856404;
  background: #fff3cd;
  border-color: #ffeeba;
}

.cpBadge--info {
  color: #0c5460;
  background: #d1ecf1;
  border-color: #bee5eb;
}

.cpBadge--ok {
  color: #155724;
  background: #d4edda;
  border-color: #c3e6cb;
}

/* Layout grid */
.cpFooterGrid {
  display: grid;
  grid-template-columns: 1fr 220px;
  gap: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

@media (max-width: 900px) {
  .cpFooterGrid {
    grid-template-columns: 1fr;
  }
}

.cpFooterGrid--clubs {
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
}

@media (max-width: 900px) {
  .cpFooterGrid--clubs {
    grid-template-columns: 1fr;
  }
}

.cpBlock {
  background: rgba(0, 0, 0, 0.015);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 10px 12px;
}

.cpLabel {
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.cpValue {
  font-size: 13px;
  color: #111827;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.cpMono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 12.5px;
  color: #111827;
}

.cpArrow {
  color: #9ca3af;
  font-weight: 700;
}

.cpBig {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}

.cpSubtle {
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.cpHint {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  font-size: 12.5px;
  color: #6b7280;
}

.cpMiniCard {
  background: rgba(0, 0, 0, 0.015);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 160px;
}

.cpMiniCard--wide {
  flex: 1 1 320px;
  min-width: 260px;
}

.cpMiniLabel {
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.cpMiniValue {
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  line-height: 1.1;
  margin-top: 4px;
}

.cpMiniText {
  margin-top: 6px;
  font-size: 13.5px;
  color: #374151;
}

.cpReadOnlyNote {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(107, 114, 128, 0.08);
  border: 1px solid rgba(107, 114, 128, 0.18);
  color: #4b5563;
  font-size: 13px;
}

.cpFooterBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}

.cpFooterLeft {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.cpFooterRight {
  flex: 0 0 auto;
}

.cpMuted {
  color: #6c757d;
}

/* Small controls (inputs/select-like divs) */
.cpInputSm {
  height: 32px;
  padding: 4px 8px;
  font-size: 13px;
}

/* "Fake select" control (div styled like input) */
.cpControlSm {
  height: 32px;
  padding: 4px 8px;
  font-size: 13px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Single-line ellipsis */
.cpEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Add-modal table row hover + selection */
.cpRowClickable {
  cursor: pointer;
}

.cpRowClickable:hover {
  background: rgba(0, 0, 0, 0.03);
}

.cpRowSelected {
  background: rgba(13, 110, 253, 0.06);
}

.cpRowSelected:hover {
  background: rgba(13, 110, 253, 0.09);
}

/* === Activity Programme Modals layout === */
.cpModalShell {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
}

/* Top area (Filters toggle + optional meta text) */
.cpToolbar {
  padding-bottom: 8px;
}

.cpToolbarRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* Right-aligned small meta text inside toolbar row */
.cpToolbarMeta {
  margin-left: auto;
  color: #6c757d;
  font-size: 13px;
  white-space: nowrap;
}

.cpMenu .btn-link {
  color: #1f2937;
  text-decoration: none;
}

.cpMenu .btn-link:hover {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
}

.cpDataTable {
  width: 100%;
  table-layout: fixed;
  margin-bottom: 0;
  background: #fff;
}

.cpDataTable thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8fafc;
  border-bottom: 1px solid #e6e9ee;
  color: #495057;
  font-weight: 600;
  font-size: 13px;
  vertical-align: middle;
}

.cpDataTable td {
  vertical-align: middle;
  border-top: 1px solid #eef1f4;
}

.cpDataTable tbody tr:hover {
  background: #fafbfc;
}

.cpDataTable tbody tr.cpRowSelected {
  background: #eef6ff;
}

.cpDataTable tbody tr.cpRowSelected:hover {
  background: #e8f2ff;
}

.cpFilterLabel {
  font-size: 12px;
  line-height: 1.2;
  color: #6c757d;
  margin-bottom: 4px;
  padding-left: 2px;
}

.cpProgrammeFieldCard {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-top: 10px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.cpFieldsHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.cpFieldsHeaderMain {
  min-width: 0;
}

.cpFieldsTitleRow {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cpFieldsSubtitle {
  margin-top: 6px;
  font-size: 13px;
  color: #6b7280;
}

.cpFieldsHeaderActions {
  flex: 0 0 auto;
}

.cpFieldsEmptyState {
  margin-top: 6px;
  padding: 18px 16px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.015);
}

.cpFieldsEmptyTitle {
  font-size: 14px;
  font-weight: 700;
  color: #374151;
}

.cpFieldsEmptyText {
  margin-top: 6px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
}

.cpProgrammeFieldCardBody {
  padding: 0 14px;
}

.cpProgrammeFieldCardTitle {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.35;
  color: #111827;
  white-space: normal;
  word-break: break-word;
}

.cpProgrammeFieldCardBadges {
  margin-top: 8px;
}

.cpFieldsManageHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.cpFieldsManageHeaderMain {
  min-width: 0;
}

.cpFieldsManageTitleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.cpFieldsManageTitle {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
}

.cpFieldsManageSubtitle {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
}

.cpFieldsManageHeaderActions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 0 0 auto;
}

.cpFieldsManageSearch {
  margin-bottom: 14px;
}

.cpFieldsManageRow {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  margin-bottom: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.cpFieldsManageRowMain {
  min-width: 0;
  flex: 1 1 auto;
}

.cpFieldsManageRowTitle {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  color: #111827;
  word-break: break-word;
}

.cpFieldsManageRowDrag {
  cursor: grab;
  padding: 2px 6px;
  color: #9ca3af;
  user-select: none;
  font-size: 16px;
  line-height: 1;
}

.cpBadgeButton {
  border: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

.cpBadgeButton:disabled {
  cursor: default;
  opacity: 0.75;
}

/* =========================
   Activity Programme Bookings Board
   ========================= */

.cpBookingsCard {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: #ffffff;
  padding: 12px;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.cpBookingsCard + .cpBookingsCard {
  margin-top: 10px;
}

.cpBookingsCard:hover {
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

.cpBookingsCard--conflict {
  border-color: rgba(220, 53, 69, 0.35);
  background: #fffafb;
}

.cpBookingsCard--selectedClub {
  background: rgba(23, 162, 184, 0.07);
  border-color: rgba(23, 162, 184, 0.18);
}

.cpBookingsCard--selectedWaiting {
  background: rgba(255, 193, 7, 0.14);
  border-color: rgba(255, 193, 7, 0.24);
}

.cpBookingsCard--confirmedClub {
  background: rgba(40, 167, 69, 0.08);
  border-color: rgba(40, 167, 69, 0.2);
}

.cpBookingsCard--confirmedWaiting {
  background: rgba(255, 193, 7, 0.16);
  border-color: rgba(255, 193, 7, 0.26);
}

.cpBookingsCardTop {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.cpBookingsCardMain {
  min-width: 0;
  flex: 1 1 auto;
}

.cpBookingsStudentName {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cpBookingsMeta {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.45;
  color: #6b7280;
}

.cpBookingsMetaStrong {
  font-weight: 700;
  color: #374151;
}

.cpBookingsSide {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.cpBookingsActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
}

.cpBookingsConflictNote {
  margin-top: 10px;
  padding: 9px 10px;
  border-radius: 10px;
  background: rgba(220, 53, 69, 0.08);
  border: 1px solid rgba(220, 53, 69, 0.16);
  color: #c24141;
  font-size: 13px;
  line-height: 1.4;
}

.cpBookingsMutedNote {
  margin-top: 10px;
  font-size: 12.5px;
  line-height: 1.4;
  color: #6b7280;
}

.cpBookingsModalCard {
  margin-bottom: 10px;
}

.cpBookingsStats {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.02);
}

.cpBookingsStatsRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12.5px;
  color: #6b7280;
}

.cpBookingsStatsRow + .cpBookingsStatsRow {
  margin-top: 6px;
}

.cpBookingsActions--modal {
  margin-top: 12px;
}

.cpClubColumnHeader {
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);
}

.cpClubColumnTitle {
  font-size: 15px;
  line-height: 1.3;
  font-weight: 700;
  color: #334155;
  margin: 0;
}

.cpClubColumnSubtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
}

.cpClubListsSummary {
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.02);
}

.cpClubListsSummaryRow {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 13px;
  color: #4b5563;
}

.cpClubListsSummaryRow + .cpClubListsSummaryRow {
  margin-top: 8px;
}

.cpClubListsGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 900px) {
  .cpClubListsGrid {
    grid-template-columns: 1fr;
  }
}

.cpClubListBlock {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #fff;
  padding: 12px;
}

.cpClubListTitle {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.cpClubListItems {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cpClubListItem {
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fafafa;
}

.cpClubListItem--club {
  background: rgba(40, 167, 69, 0.08);
  border-color: rgba(40, 167, 69, 0.18);
}

.cpClubListItem--selectedClub {
  background: rgba(23, 162, 184, 0.08);
  border-color: rgba(23, 162, 184, 0.18);
}

.cpClubListItem--waiting {
  background: rgba(255, 193, 7, 0.14);
  border-color: rgba(255, 193, 7, 0.28);
}

.cpClubListItem--selectedWaiting {
  background: rgba(255, 193, 7, 0.08);
  border-color: rgba(255, 193, 7, 0.2);
}

.cpClubListName {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
}

.cpClubListMeta {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 12px;
  color: #6b7280;
}

.cpClubListEmpty {
  font-size: 13px;
  color: #6b7280;
  padding: 8px 0;
}

.cpClubListsFooterActions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.cpClubListsHero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.025), rgba(0, 0, 0, 0.01));
  margin-bottom: 14px;
}

.cpClubListsHeroMain {
  min-width: 0;
  flex: 1 1 320px;
}

.cpClubListsHeroTitle {
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
  color: #111827;
}

.cpClubListsHeroSubtitle {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.45;
  color: #6b7280;
}

.cpClubListsHeroStats {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.cpClubListsHeroStat {
  min-width: 92px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.07);
  text-align: center;
}

.cpClubListsHeroStatLabel {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b7280;
}

.cpClubListsHeroStatValue {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}

.cpClubListsKpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

@media (max-width: 900px) {
  .cpClubListsKpis {
    grid-template-columns: 1fr 1fr;
  }
}

.cpClubListsKpi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
}

.cpClubListsKpiLabel {
  font-size: 12px;
  font-weight: 700;
  color: #4b5563;
}

.cpClubListsKpiValue {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}

.cpClubListsKpi--club {
  background: rgba(40, 167, 69, 0.06);
  border-color: rgba(40, 167, 69, 0.18);
}

.cpClubListsKpi--selectedClub {
  background: rgba(23, 162, 184, 0.06);
  border-color: rgba(23, 162, 184, 0.18);
}

.cpClubListsKpi--waiting {
  background: rgba(255, 193, 7, 0.12);
  border-color: rgba(255, 193, 7, 0.26);
}

.cpClubListsKpi--selectedWaiting {
  background: rgba(255, 193, 7, 0.07);
  border-color: rgba(255, 193, 7, 0.18);
}

.cpClubListBlock {
  border-radius: 14px;
  padding: 14px;
}

.cpClubListTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 12px;
}

.cpClubListItems {
  gap: 10px;
}

.cpClubListItem {
  border-radius: 12px;
  padding: 11px 12px;
  background: #fff;
}

.cpClubListName {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.cpClubListMeta {
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #6b7280;
}

.cpClubListMeta span {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.04);
}

.cpClubListsFooterActions {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: flex-end;
}

.cpBookingsTopActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 10px 12px;
  margin-bottom: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  background: #fafafa;
}

.cpBookingsPendingGroup {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cpBookingsPendingBadge {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 13px;
  color: #6b7280;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.cpBookingsPendingBadge--strong {
  color: #1f2937;
  font-weight: 700;
  background: rgba(40, 167, 69, 0.08);
  border-color: rgba(40, 167, 69, 0.18);
}

.cpBookingsTopButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cpBookingsQuickActions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.cpIconBtn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.cpIconBtn:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
  color: #374151;
}

.cpIconBtn:disabled {
  opacity: 0.45;
  cursor: default;
}

.cpIconBtn--danger {
  color: #c05621;
}

.cpIconBtn--danger:hover:not(:disabled) {
  color: #9b2c2c;
  background: rgba(220, 53, 69, 0.06);
  border-color: rgba(220, 53, 69, 0.2);
}

.cpAnswersHero {
  background: linear-gradient(135deg, #f8fbff 0%, #f7fcf8 100%);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 14px;
}

.cpAnswersHeroTitle {
  font-size: 20px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 4px;
}

.cpAnswersHeroText {
  font-size: 13px;
  color: #6c757d;
  line-height: 1.45;
}

.cpAnswerCard {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 14px 16px;
}

.cpAnswerCardHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
}

.cpAnswerHeading {
  font-size: 15px;
  font-weight: 600;
  color: #223047;
  line-height: 1.35;
}

.cpAnswerMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.cpAnswerValue {
  background: rgba(0, 0, 0, 0.025);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 10px 12px;
  white-space: pre-wrap;
  word-break: break-word;
  color: #223047;
  font-size: 14px;
  line-height: 1.5;
}

.cpAnswerHint {
  margin-top: 8px;
  font-size: 12px;
  color: #6c757d;
}

.eCpfSectionCard {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 10px 12px;
  background: #fff;
}

.eCpfSectionTitle {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.eCpfReadOnlyHint {
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
  font-size: 13px;
  background: #f9fafb;
}

.eCpfSubLabel {
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 11.5px;
  line-height: 1.3;
}

.cpManageDetailArea {
  flex: 0 0 34%;
  min-height: 240px;
  display: flex;
  flex-direction: column;
}

.cpDetailPlaceholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 180px;
}

.cpDetailHeader {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.cpDetailHeaderMain {
  min-width: 0;
}

.cpDetailTabsWrap {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.eCpfSectionDisabled {
  opacity: 0.65;
  pointer-events: none;
}

.eCpfSelect:disabled,
.eCpfInput:disabled,
.form-control:disabled {
  background: #f4f6f8 !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
}

.eCpfAlert {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #d9e2ec;
}

.eCpfAlertTitle {
  font-weight: 700;
  margin-bottom: 4px;
}

.eCpfAlertText {
  color: #5b6875;
}

/* Design-system Club programmes list */
.cpDsPage {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
  min-height: calc(100vh - 88px);
  padding: 18px 22px 32px;
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #243244);
  font-family: var(--font-body, inherit);
}

.cpDsPage.hasSummary {
  grid-template-columns: minmax(0, 1fr) 508px;
  align-items: start;
}

.cpDsMain {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cpDsHeader,
.cpDsToolbar,
.cpDsSelectionBar,
.cpDsFilters,
.cpDsTableCard {
  border: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--surface-card, #fff);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.cpDsHeader {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
}

.cpDsHeader h1 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0;
}

.cpDsHeader p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 14px;
}

.cpDsHeaderActions,
.cpDsToolbar,
.cpDsSelectionBar,
.cpDsFooter {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.cpDsToolbar {
  padding: 12px 14px;
}

.cpDsToolbarTitle {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex: 0 0 auto;
}

.cpDsToolbarTitle strong {
  color: var(--text-strong, #142033);
  font-size: 15px;
  font-weight: 750;
}

.cpDsToolbarTitle span,
.cpDsFooter span {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 600;
}

.cpDsSearch {
  position: relative;
  flex: 0 1 320px;
  width: min(320px, 100%);
  margin: 0;
  color: var(--text-subtle, #8a96a8);
}

.cpDsSearch input,
.cpDsFilterField input {
  width: 100%;
  height: 40px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 10px;
  background: #fff;
  color: var(--text-strong, #142033);
  font: inherit;
  font-size: 13.5px;
  outline: none;
}

.cpDsSearch input {
  padding: 0 12px;
}

.cpDsFilterField input {
  padding: 0 10px;
}

.cpDsSearch input:focus,
.cpDsFilterField input:focus {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);
}

.cpDsBtn,
.cpDsIconTextBtn,
.cpDsIconBtn,
.cpDsSort,
.cpDsPageBtn,
.cpDsPagerBtn,
.cpDsFilterChip {
  font: inherit;
  cursor: pointer;
}

.cpDsBtn,
.cpDsIconTextBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-size: 13.5px;
  font-weight: 700;
  white-space: nowrap;
}

.cpDsBtn:disabled {
  opacity: 0.48;
  cursor: default;
}

.cpDsBtnPrimary {
  background: var(--blue-600, #227ebd);
  color: #fff;
  box-shadow: 0 8px 18px rgba(34, 126, 189, 0.22);
}

.cpDsBtnSecondary,
.cpDsIconTextBtn {
  background: #fff;
  color: var(--text-strong, #142033);
  border-color: var(--border-default, #cfd8e3);
}

.cpDsBtnGhost {
  background: transparent;
  color: var(--text-muted, #69778a);
  border-color: transparent;
}

.cpDsBtnDanger {
  background: var(--red-600, #dc2626);
  color: #fff;
  border-color: var(--red-600, #dc2626);
}

.cpDsIconTextBtn.isActive {
  border-color: var(--action-primary, #227ebd);
  color: var(--blue-700, #155d8c);
  background: var(--blue-50, #eef7fd);
}

.cpDsIconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 10px;
  background: #fff;
  color: var(--blue-700, #164170);
  font-weight: 800;
}

.cpDsSelectionBar {
  padding: 10px 12px;
}

.cpDsSelectionCount {
  margin-right: 4px;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
}

.cpDsFilters {
  display: grid;
  grid-template-columns: repeat(6, minmax(120px, 1fr)) auto;
  gap: 12px;
  padding: 14px;
}

.cpDsFilterField span {
  display: block;
  margin-bottom: 6px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
  font-weight: 700;
}

.cpDsFilterFieldWide {
  grid-column: span 2;
}

.cpDsFilterChips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 40px;
  padding: 3px;
}

.cpDsFilterChip {
  min-height: 32px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  padding: 0 11px;
  font-size: 13px;
  font-weight: 700;
}

.cpDsFilterChip:hover {
  border-color: var(--border-brand, #6fb1df);
  color: var(--blue-700, #155d8c);
}

.cpDsFilterChip.isSelected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpDsFilterActions {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.cpDsFilterControl {
  position: relative;
  height: 40px;
  display: flex;
  align-items: flex-start;
  align-self: center;
}

.cpDsFilterControl > .cpDsIconTextBtn {
  height: 40px;
}

.cpDsColumnsControl {
  position: relative;
  height: 40px;
  display: flex;
  align-items: flex-start;
  align-self: center;
}

.cpDsColumnsControl > .cpDsIconTextBtn {
  height: 40px;
}

.cpDsColumnsScrim {
  position: fixed;
  inset: 0;
  z-index: 1039;
  border: 0;
  background: transparent;
  cursor: default;
}

.cpDsColumnsMenu {
  position: absolute;
  z-index: 1040;
  top: calc(100% + 8px);
  right: 0;
  width: 250px;
  padding: 7px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.16);
}

.cpDsColumnsMenu header {
  padding: 7px 9px 10px;
  color: #69778a;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cpDsColumnsMenu label {
  min-height: 36px;
  margin: 0;
  padding: 7px 9px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.cpDsColumnsMenu label:hover {
  background: #f8fafc;
}

.cpDsColumnsMenu input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #227ebd;
}

.cpDsColumnsMenu input:disabled {
  opacity: 0.55;
}

.cpDsColumnsMenu label:has(input:disabled) {
  color: #69778a;
  cursor: default;
}

.cpDsIconTextBtn svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.cpDsFilterCount {
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 11px;
  line-height: 1;
}

.cpDsFilterScrim {
  position: fixed;
  inset: 0;
  z-index: 1039;
  border: 0;
  background: rgba(15, 23, 42, 0.24);
  cursor: default;
}

.cpDsFilterDrawer {
  position: fixed;
  z-index: 1040;
  top: 0;
  right: 0;
  bottom: 0;
  width: 392px;
  max-width: calc(100vw - 24px);
  border: 0;
  border-left: 1px solid #dbe3ec;
  background: #fff;
  box-shadow: -12px 0 42px rgba(15, 23, 42, 0.2);
  display: flex;
  flex-direction: column;
  animation: cpDsFilterDrawerIn 0.18s ease-out;
}

.cpDsFilterDrawer > header {
  flex: 0 0 auto;
  min-height: 64px;
  padding: 0 20px;
  border-bottom: 1px solid #e7edf3;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cpDsFilterDrawer > header strong {
  color: #142033;
  font-size: 18px;
  font-weight: 800;
}

.cpDsFilterDrawer > header button {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #69778a;
  font: inherit;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.cpDsFilterDrawer > header button:hover {
  background: #f1f5f9;
  color: #142033;
}

.cpDsFilterFields {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
  overflow-x: visible;
  overflow-y: auto;
  padding: 20px;
}

.cpDsFilterFields .cpDsFilterFieldWide {
  grid-column: auto;
  min-width: 0;
}

.cpDsFilterFields .cpDsFilterField > span {
  display: block;
  margin-bottom: 7px;
  color: #344054;
  font-size: 12px;
  font-weight: 750;
  line-height: 18px;
}

.cpDsFilterFields .cpDsFilterChips {
  min-height: 0;
  padding: 0;
  gap: 6px;
}

.cpDsFilterFields .cpDsFilterChip {
  min-height: 32px;
  padding: 0 10px;
  border-color: #d0d5dd;
  border-radius: 999px;
  color: #344054;
  font-size: 12px;
  font-weight: 650;
}

.cpDsFilterFields .cpDsFilterChip.isSelected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpDsFilterFields .sit-dp__label {
  margin-bottom: 7px;
  color: #344054;
  font-size: 12px;
  font-weight: 750;
  line-height: 18px;
  text-align: left;
}

.cpDsFilterFields .sit-dp__trigger {
  min-height: 40px;
  border-color: #d0d5dd;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}

.cpDsFilterFields .cpDsDateRange,
.cpDsFilterFields .cpDsDateRange .sit-dp__pop {
  z-index: 1060;
}

.cpDsFilterFields .cpDsDateRange .sit-dp__pop {
  position: fixed;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: hidden;
  align-items: stretch;
  animation: none;
  overscroll-behavior: contain;
}

.cpDsFilterFields .cpDsDateRange .sit-dp__pop > div:last-child {
  min-width: 0;
  min-height: 0;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.cpDsFilterFields .cpDsDateRange .sit-dp__pop > div:last-child > div:first-child {
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

.cpDsFilterFields .cpDsDateRange .sit-dp__pop > div:last-child > div:last-child {
  flex: 0 0 auto;
  padding: 0 14px 14px !important;
  border-top: 1px solid #e7edf3;
  background: #fff;
  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);
}

.cpDsFilterFields .cpDsDateRange .sit-cal__foot {
  position: static;
  margin: 0;
  padding-top: 12px;
}

.cpDsFilterDrawer > footer {
  flex: 0 0 auto;
  min-height: 68px;
  padding: 12px 20px;
  border-top: 1px solid #e7edf3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cpDsFilterDrawer > footer > div {
  display: flex;
  gap: 8px;
}

.cpDsFilterDrawer > footer button {
  height: 38px;
  padding: 0 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.cpDsFilterDrawer > footer button.isClear {
  padding-left: 0;
  border-color: transparent;
  color: #69778a;
}

.cpDsFilterDrawer > footer button.isApply {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

@keyframes cpDsFilterDrawerIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.cpDsActiveFilters {
  min-height: 44px;
  padding: 7px 10px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  background: #fff;
}

.cpDsActiveFilters > button {
  min-height: 28px;
  padding: 4px 9px;
  border: 1px solid #b9d8eb;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #eef7fd;
  color: #155d8c;
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.cpDsActiveFilters > button span:last-child {
  font-size: 16px;
  font-weight: 500;
  line-height: 12px;
}

.cpDsActiveFilters > button.cpDsClearFilters {
  margin-left: auto;
  border-color: transparent;
  background: transparent;
  color: #69778a;
  font-weight: 700;
}

.cpDsTableCard {
  overflow: hidden;
}

.cpDsTableScroll {
  overflow: auto;
}

.cpDsTable {
  width: 100%;
  min-width: 1120px;
  border-collapse: separate;
  border-spacing: 0;
}

.cpDsTable th {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 44px;
  background: var(--slate-25, #f8fafc);
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  color: var(--text-muted, #69778a);
  padding: 0 12px;
  text-align: left;
  font-size: 11.5px;
  font-weight: 800;
  text-transform: uppercase;
  white-space: nowrap;
}

.cpDsTable td {
  height: 58px;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
  color: var(--text-body, #243244);
  padding: 8px 12px;
  font-size: 13px;
  vertical-align: middle;
}

.cpDsTable tbody tr {
  cursor: pointer;
}

.cpDsTable tbody tr:hover,
.cpDsTable tbody tr.isSelected {
  background: var(--blue-50, #eaf5fc);
}

.cpDsCheckCell {
  width: 44px;
  text-align: center !important;
}

.cpDsCheckCell input {
  width: 16px;
  height: 16px;
  accent-color: var(--blue-600, #227ebd);
}

.cpDsSort {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: inherit;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
  text-transform: inherit;
}

.cpDsSortMark {
  color: var(--blue-700, #155d8c);
  font-size: 10px;
}

.cpDsNameCell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 280px;
}

.cpDsProgrammeIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #164170);
  font-size: 11px;
  font-weight: 800;
}

.cpDsNameCell strong,
.cpDsNameCell small {
  display: block;
}

.cpDsNameCell strong {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
}

.cpDsNameCell small {
  max-width: 360px;
  margin-top: 2px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpDsChip {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 9px;
  border-radius: 6px;
  background: var(--slate-100, #edf2f7);
  color: var(--text-body, #243244);
  font-size: 11.5px;
  font-weight: 800;
}

.cpDsBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.cpDsBadge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.cpDsBadge.isSuccess {
  background: #eaf7ed;
  color: #217a3a;
}
.cpDsBadge.isWarning {
  background: #fff4d8;
  color: #9a6500;
}
.cpDsBadge.isInfo {
  background: #eaf5fc;
  color: #155d8c;
}
.cpDsBadge.isNeutral {
  background: #edf2f7;
  color: #536173;
}

.cpDsEmpty {
  height: 120px !important;
  text-align: center;
  color: var(--text-muted, #69778a) !important;
}

.cpDsFooter {
  justify-content: flex-end;
  margin-top: 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.cpDsPaginationSummary {
  margin-right: 4px;
}

.cpDsPaginationEllipsis {
  min-width: 18px;
  text-align: center;
  color: var(--text-subtle, #94a3b8);
}

.cpDsPageBtn,
.cpDsPagerBtn {
  min-width: 34px;
  height: 34px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
}

.cpDsPageBtn:hover,
.cpDsPagerBtn:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
  color: var(--blue-700, #155d8c);
}

.cpDsPageBtn.isActive {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpDsPagerBtn:disabled {
  cursor: default;
  color: var(--text-subtle, #94a3b8);
}

.cpDsSummary {
  position: sticky;
  top: 12px;
  max-height: calc(100vh - 96px);
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.cpDsSummary .cpFooter {
  margin: 0;
  max-height: calc(100vh - 96px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1180px) {
  .cpDsPage.hasSummary {
    grid-template-columns: 1fr;
  }

  .cpDsSummary {
    position: relative;
    top: 0;
    max-height: none;
  }

  .cpDsSummary .cpFooter {
    max-height: none;
  }

  .cpDsFilters {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
}

@media (max-width: 720px) {
  .cpDsPage {
    padding: 12px;
  }

  .cpDsHeader,
  .cpDsToolbar,
  .cpDsSelectionBar,
  .cpDsFooter {
    align-items: stretch;
    flex-direction: column;
  }

  .cpDsSearch {
    width: 100%;
  }

  .cpDsFilters {
    grid-template-columns: 1fr;
  }

  .cpDsFilterFieldWide {
    grid-column: auto;
  }

  .cpDsFilterControl {
    width: 100%;
  }

  .cpDsFilterControl > .cpDsIconTextBtn,
  .cpDsColumnsControl > .cpDsIconTextBtn {
    width: 100%;
  }

  .cpDsColumnsControl {
    width: 100%;
  }

  .cpDsColumnsMenu {
    right: auto;
    left: 0;
    width: min(280px, calc(100vw - 24px));
  }

  .cpDsFilterScrim {
    background: rgba(15, 23, 42, 0.32);
  }

  .cpDsFilterDrawer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: none;
    max-height: none;
    border: 0;
    border-radius: 0;
  }

  .cpDsFilterFields {
    max-height: none;
  }

  .cpDsActiveFilters > button.cpDsClearFilters {
    margin-left: 0;
  }
}

/* DS programme preview drawer */
.cpDsTable tbody tr.isPreview {
  background: var(--blue-50, #eaf5fc);
}

.cpDsSummary {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  width: 464px;
  max-width: 96vw;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface-card, #fff);
  box-shadow: -10px 0 40px rgba(15, 23, 42, 0.18);
}

.cpDrawer {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface-card, #fff);
}

.cpDrawerHead {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 22px 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.cpDrawerLead {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #164170);
  font-size: 13px;
  font-weight: 800;
}

.cpDrawerTitles {
  flex: 1 1 auto;
  min-width: 0;
}

.cpDrawerTitle {
  font-family: var(--font-display, inherit);
  font-size: 20px;
  font-weight: 800;
  color: var(--text-strong, #142033);
  line-height: 1.2;
  word-break: break-word;
}

.cpDrawerMeta {
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--text-muted, #69778a);
  font-size: 12px;
  font-weight: 650;
}

.cpDrawerMeta > i {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: var(--slate-300, #cbd5e1);
  display: inline-block;
}

.cpDrawerClose {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #69778a);
  cursor: pointer;
}

.cpDrawerClose:hover {
  background: var(--surface-hover, #f8fafc);
  color: var(--text-strong, #142033);
}

.cpDrawerClose svg {
  width: 16px;
  height: 16px;
}

.cpDrawerTabs {
  flex: 0 0 auto;
  display: flex;
  gap: 4px;
  overflow-x: auto;
  padding: 8px 22px 0;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.cpDrawerTabs button {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-muted, #69778a);
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
  cursor: pointer;
}

.cpDrawerTabs button.isActive {
  color: var(--blue-700, #164170);
  border-bottom-color: var(--blue-600, #227ebd);
}

.cpDrawerTabDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--amber-500, #f0ad4e);
  box-shadow: 0 0 0 2px rgba(240, 173, 78, 0.18);
}

.cpDrawerBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 22px 22px;
  color: var(--text-body, #243244);
  font-size: 14px;
}

.cpDrawer .cpFooterBody {
  padding: 0;
}

.cpDrawer .cpFooterHeader {
  margin-bottom: 14px;
}

.cpDrawer .cpFooterGrid,
.cpDrawer .cpFooterGrid--clubs {
  grid-template-columns: 1fr;
}

.cpDrawer .cpBlock {
  border-radius: 12px;
  padding: 12px 14px;
}

@media (max-width: 720px) {
  .cpDsSummary {
    width: 100vw;
    max-width: 100vw;
  }
}

/* DS shared programme sub-pages */
.cpPageHeader {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 24px 18px;
  margin: 18px 22px 0;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.cpPageHeaderMain {
  min-width: 0;
  flex: 1 1 auto;
}

.cpBackLink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 10px;
  border: 0;
  background: transparent;
  color: var(--blue-700, #164170);
  padding: 0;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.cpBackLink span {
  font-size: 18px;
  line-height: 1;
}

.cpPageTitleRow {
  display: flex;
  align-items: center;
  gap: 11px;
  flex-wrap: wrap;
}

.cpPageTitleRow h1 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
  font-size: 23px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0;
}

.cpPageHeaderSlot {
  flex: 0 0 auto;
}

.cpPageMeta {
  margin-top: 5px;
  color: var(--text-muted, #69778a);
  font-size: 13.5px;
}

.cpPageMeta strong {
  color: var(--text-strong, #142033);
  font-weight: 750;
}

.cpPageHeader p {
  max-width: 720px;
  margin: 8px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 14px;
  line-height: 1.45;
}

.cpPageHeaderActions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.cpPageBody {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin: 14px 22px 24px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.cpDataTableShell {
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  overflow: hidden;
  background: var(--surface-card, #fff);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
}

.cpDataTableShellScroll {
  overflow-x: auto;
  overflow-y: auto;
}

@media (max-width: 720px) {
  .cpPageHeader {
    margin: 12px 12px 0;
    padding: 16px;
    align-items: stretch;
    flex-direction: column;
  }

  .cpPageBody {
    margin: 12px;
    padding: 12px;
  }
}

.cpToolbar {
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
  padding: 12px 14px;
}

.cpToolbarRowDs {
  min-height: 38px;
}

.cpToolbarState,
.cpToolbarMeta {
  font-size: 13px;
  color: var(--text-muted, #69778a);
}

.cpDataTable {
  width: 100%;
  table-layout: fixed;
  margin-bottom: 0;
  background: var(--surface-card, #fff);
}

.cpDataTable thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 44px;
  background: var(--slate-25, #f8fafc);
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  font-weight: 800;
  text-transform: uppercase;
  vertical-align: middle;
  white-space: nowrap;
}

.cpDataTable td {
  height: 52px;
  border-top: 1px solid var(--border-subtle, #edf1f5);
  color: var(--text-body, #243244);
  font-size: 13px;
  vertical-align: middle;
}

.cpDataTable tbody tr:hover {
  background: var(--blue-50, #eaf5fc);
}

.cpDataTable tbody tr.cpRowSelected {
  background: var(--blue-50, #eaf5fc);
}

.cpInputSm,
.cpControlSm {
  height: 38px;
  border-color: var(--border-default, #cfd8e3);
  border-radius: 9px;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
}

.cpInputSm:focus,
.cpControlSm:focus-within {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);
}

.cpFilterLabel {
  margin-bottom: 6px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
  font-weight: 700;
}
/* Pixel-aligned DS programme preview drawer */
.cpDsSummaryScrim {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal, 1040);
  background: rgba(15, 23, 42, 0.34);
  animation: cpDrawerFade var(--dur-base, 160ms) var(--ease-out, ease-out);
}

@keyframes cpDrawerFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.cpDsSummary.sit-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: calc(var(--z-modal, 1040) + 1);
  width: 464px;
  max-width: 96vw;
  min-width: 0;
  max-height: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface-card, #ffffff);
  box-shadow: -10px 0 40px rgba(15, 23, 42, 0.18);
  animation: cpDrawerSlideRight var(--dur-slow, 260ms) cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes cpDrawerSlideRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: none;
  }
}

.cpDsSummary.sit-drawer .cpDrawer {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface-card, #ffffff);
}

.cpDsSummary.sit-drawer .cpDrawerHead {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 22px 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.cpDsSummary.sit-drawer .cpDrawerLead {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md, 8px);
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #164170);
  font-size: 12px;
  font-weight: var(--weight-bold, 700);
}

.cpDsSummary.sit-drawer .cpDrawerTitles {
  flex: 1 1 auto;
  min-width: 0;
}

.cpDsSummary.sit-drawer .cpDrawerTitle {
  margin: 0;
  font-family: var(--font-display, inherit);
  font-size: var(--text-xl, 20px);
  font-weight: var(--weight-bold, 700);
  color: var(--text-strong, #142033);
  line-height: 1.2;
  word-break: break-word;
}

.cpDsSummary.sit-drawer .cpDrawerMeta {
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--text-muted, #69778a);
  font-size: var(--text-xs, 12px);
  font-weight: 500;
}

.cpDsSummary.sit-drawer .cpDrawerMeta > i {
  width: 3px;
  height: 3px;
  display: inline-block;
  border-radius: 50%;
  background: var(--slate-300, #cbd5e1);
}

.cpDsSummary.sit-drawer .cpDrawerClose {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #ffffff);
  color: var(--text-muted, #69778a);
  cursor: pointer;
  transition: background var(--dur-fast, 120ms), color var(--dur-fast, 120ms);
}

.cpDsSummary.sit-drawer .cpDrawerClose:hover {
  background: var(--surface-hover, #f8fafc);
  color: var(--text-strong, #142033);
}

.cpDsSummary.sit-drawer .cpDrawerClose svg {
  width: 16px;
  height: 16px;
}

.cpDsSummary.sit-drawer .cpDrawerTabs {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  padding: 8px 22px 0;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: auto;
  padding: 10px 14px;
  border: 0;
  background: transparent;
  color: var(--text-muted, #69778a);
  font-family: var(--font-body, inherit);
  font-size: var(--text-md, 14px);
  font-weight: var(--weight-semibold, 600);
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: color var(--dur-base, 160ms) var(--ease-out, ease-out);
}

.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab::after {
  content: '';
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: -1px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: var(--action-primary, #227ebd);
  transform: scaleX(0);
  transition: transform var(--dur-base, 160ms) var(--ease-out, ease-out);
}

.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab:hover {
  color: var(--text-body, #243244);
}

.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.isActive,
.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.sit-tab--active {
  color: var(--text-strong, #142033);
}

.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.isActive::after,
.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.sit-tab--active::after {
  transform: scaleX(1);
}

.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
  border-radius: var(--radius-sm, 6px);
}

.cpDsSummary.sit-drawer .cpDrawerTabDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--amber-500, #f0ad4e);
  box-shadow: 0 0 0 2px rgba(240, 173, 78, 0.18);
}

.cpDsSummary.sit-drawer .cpDrawerBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 22px 22px;
  color: var(--text-body, #243244);
  font-size: var(--text-md, 14px);
  scrollbar-width: thin;
  scrollbar-color: var(--slate-300, #cbd5e1) transparent;
}

.cpDsSummary.sit-drawer .cpDrawerBody::-webkit-scrollbar {
  width: 10px;
}

.cpDsSummary.sit-drawer .cpDrawerBody::-webkit-scrollbar-thumb {
  background: var(--slate-300, #cbd5e1);
  border: 3px solid transparent;
  border-radius: 999px;
  background-clip: content-box;
}

.cpDsSummary.sit-drawer .cpDrawer .cpFooterBody {
  padding: 0;
}

.cpDsSummary.sit-drawer .cpDrawer .cpFooterHeader {
  margin-bottom: 14px;
}

.cpDsSummary.sit-drawer .cpDrawer .cpFooterGrid,
.cpDsSummary.sit-drawer .cpDrawer .cpFooterGrid--clubs {
  grid-template-columns: 1fr;
}

.cpDsSummary.sit-drawer .cpDrawer .cpBlock {
  border-radius: var(--radius-md, 8px);
  padding: 12px 14px;
}

.cpFieldsSummary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cpFieldsSummaryHeader {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.cpFieldsSummaryIcon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #155d8c);
}

.cpFieldsSummaryIcon svg {
  width: 21px;
  height: 21px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.cpFieldsSummaryHeading {
  min-width: 0;
}

.cpFieldsSummaryTitleRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.cpFieldsSummaryTitleRow h2,
.cpFieldsListHeader h3 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
}

.cpFieldsSummaryTitleRow h2 {
  font-size: 18px;
  font-weight: 800;
}

.cpFieldsSummaryHeading p,
.cpFieldsListHeader p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.45;
}

.cpFieldsState {
  min-height: 22px;
  padding: 2px 8px;
  border: 1px solid;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 750;
}

.cpFieldsState.isDraft {
  border-color: #b9d8eb;
  background: #eef7fd;
  color: #155d8c;
}

.cpFieldsState.isLocked {
  border-color: #d0d5dd;
  background: #f2f4f7;
  color: #475467;
}

.cpFieldsSummaryStats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: #fff;
}

.cpFieldsSummaryStats > div {
  min-width: 0;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cpFieldsSummaryStats > div + div {
  border-left: 1px solid var(--border-subtle, #dbe3ec);
}

.cpFieldsSummaryStats strong {
  color: var(--text-strong, #142033);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.cpFieldsSummaryStats span {
  overflow: hidden;
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpFieldsTemplate {
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  background: var(--slate-25, #f8fafc);
}

.cpFieldsTemplate span {
  color: var(--text-muted, #69778a);
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cpFieldsTemplate strong {
  color: var(--text-strong, #142033);
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
}

.cpFieldsLockedNotice {
  padding: 11px 12px;
  border: 1px solid #fedf89;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  background: #fffaeb;
  color: #93370d;
}

.cpFieldsLockedNotice > span {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  border: 1.5px solid currentColor;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
}

.cpFieldsLockedNotice p {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.cpFieldsListHeader {
  padding-top: 2px;
}

.cpFieldsListHeader h3 {
  font-size: 14px;
  font-weight: 800;
}

.cpFieldsSummaryList > .mt-3 {
  margin-top: 0 !important;
  counter-reset: cp-field;
}

.cpFieldsSummaryList .cpProgrammeFieldCard {
  counter-increment: cp-field;
  min-height: 0;
  margin-top: 8px;
  padding: 12px;
  border-color: var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  box-shadow: none;
}

.cpFieldsSummaryList .cpProgrammeFieldCard:first-child {
  margin-top: 0;
}

.cpFieldsSummaryList .cpProgrammeFieldCardBody {
  position: relative;
  padding: 0 0 0 34px;
}

.cpFieldsSummaryList .cpProgrammeFieldCardBody::before {
  content: counter(cp-field);
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef2f6;
  color: #475467;
  font-size: 11px;
  font-weight: 800;
}

.cpFieldsSummaryList .cpProgrammeFieldCardTitle {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 750;
}

.cpFieldsSummaryList .cpProgrammeFieldCardBadges {
  margin-top: 7px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.cpFieldsSummaryList .cpBadge {
  margin: 0;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
}

.cpFieldsSummaryList .text-muted {
  margin-top: 7px !important;
  color: var(--text-muted, #69778a) !important;
  font-size: 11.5px !important;
  line-height: 1.4 !important;
}

.cpFieldsSummaryList .cpFieldsEmptyState {
  margin-top: 0;
  padding: 24px 18px;
  border-color: #cfd8e3;
  background: var(--slate-25, #f8fafc);
  text-align: center;
}

.cpFieldsEditorButton {
  width: 100%;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
}

.cpFieldsEditorButton:hover:not(:disabled) {
  border-color: #17699e;
  background: #17699e;
}

.cpFieldsEditorButton:disabled {
  cursor: default;
  opacity: 0.5;
}

.cpFieldsEditorButton svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.cpProgrammeBooking {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cpProgrammeBookingHeader {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.cpProgrammeBookingIcon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #155d8c);
}

.cpProgrammeBookingIcon svg,
.cpProgrammeBookingArrow svg,
.cpProgrammeBookingButton svg {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.75;
}

.cpProgrammeBookingIcon svg {
  width: 21px;
  height: 21px;
}

.cpProgrammeBookingTitleRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.cpProgrammeBookingTitleRow h2,
.cpProgrammeBookingWorkflow h3 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
}

.cpProgrammeBookingTitleRow h2 {
  font-size: 18px;
  font-weight: 800;
}

.cpProgrammeBookingHeader p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.45;
}

.cpProgrammeBookingState {
  min-height: 22px;
  padding: 2px 8px;
  border: 1px solid;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 750;
}

.cpProgrammeBookingState.isDraft {
  border-color: #d0d5dd;
  background: #f2f4f7;
  color: #475467;
}

.cpProgrammeBookingState.isActive {
  border-color: #b9d8eb;
  background: #eef7fd;
  color: #155d8c;
}

.cpProgrammeBookingState.isCompleted {
  border-color: #abefc6;
  background: #ecfdf3;
  color: #067647;
}

.cpProgrammeBookingWindow {
  padding: 14px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 11px;
  background: var(--slate-25, #f8fafc);
}

.cpProgrammeBookingWindowTitle {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.cpProgrammeBookingWindowTitle > span {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 800;
}

.cpProgrammeBookingWindowTitle > strong {
  color: var(--text-muted, #69778a);
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cpProgrammeBookingDates {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 22px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.cpProgrammeBookingDates > div {
  min-width: 0;
}

.cpProgrammeBookingDates > div > span {
  display: block;
  margin-bottom: 3px;
  color: var(--text-muted, #69778a);
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
}

.cpProgrammeBookingDates > div > strong {
  display: block;
  color: var(--text-strong, #142033);
  font-size: 12px;
  font-weight: 750;
  line-height: 1.4;
}

.cpProgrammeBookingArrow {
  color: var(--text-subtle, #8a96a8);
}

.cpProgrammeBookingArrow svg {
  width: 18px;
  height: 18px;
}

.cpProgrammeBookingConfig {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 11px;
  background: #fff;
}

.cpProgrammeBookingConfig > div {
  min-height: 48px;
  padding: 10px 13px;
  display: grid;
  grid-template-columns: minmax(120px, 0.8fr) minmax(0, 1.2fr);
  align-items: center;
  gap: 12px;
}

.cpProgrammeBookingConfig > div + div {
  border-top: 1px solid var(--border-subtle, #e7edf3);
}

.cpProgrammeBookingConfig span {
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  font-weight: 650;
}

.cpProgrammeBookingConfig strong {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
  font-weight: 750;
  line-height: 1.35;
  text-align: right;
}

.cpProgrammeBookingWorkflow {
  padding-top: 2px;
}

.cpProgrammeBookingWorkflow h3 {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 800;
}

.cpProgrammeBookingWorkflow > div {
  position: relative;
  min-height: 48px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.cpProgrammeBookingWorkflow > div:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 27px;
  bottom: 3px;
  left: 11px;
  width: 1px;
  background: #dbe3ec;
}

.cpProgrammeBookingWorkflow > div > span {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  width: 23px;
  height: 23px;
  border: 1px solid #b9d8eb;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef7fd;
  color: #155d8c;
  font-size: 10.5px;
  font-weight: 800;
}

.cpProgrammeBookingWorkflow p {
  margin: 1px 0 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cpProgrammeBookingWorkflow p strong {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
  font-weight: 750;
}

.cpProgrammeBookingWorkflow p small {
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  line-height: 1.35;
}

.cpProgrammeBookingButton {
  width: 100%;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
}

.cpProgrammeBookingButton:hover {
  border-color: #17699e;
  background: #17699e;
}

.cpProgrammeBookingButton svg {
  width: 17px;
  height: 17px;
}

.cpProgrammeClubsSummary {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cpProgrammeClubsSummaryHeader h2 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
  font-size: 18px;
  font-weight: 800;
}

.cpProgrammeClubsSummaryHeader p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}

.cpProgrammeClubsNotice {
  padding: 11px 12px;
  border: 1px solid #fedf89;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  background: #fffaeb;
  color: #93370d;
}

.cpProgrammeClubsNotice > span {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  border: 1.5px solid currentColor;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
}

.cpProgrammeClubsNotice p {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.cpProgrammeClubsList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cpProgrammeClubCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 11px;
  background: #fff;
}

.cpProgrammeClubCardTop {
  min-height: 60px;
  padding: 11px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.cpProgrammeClubIcon {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #155d8c);
}

.cpProgrammeClubIcon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.75;
}

.cpProgrammeClubIdentity {
  flex: 1 1 auto;
  min-width: 0;
}

.cpProgrammeClubIdentity h3 {
  margin: 0;
  overflow: hidden;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeClubIdentity p {
  margin: 2px 0 0;
  overflow: hidden;
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeClubState {
  flex: 0 0 auto;
  min-height: 22px;
  padding: 2px 8px;
  border: 1px solid;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 750;
}

.cpProgrammeClubState.isEnabled {
  border-color: #abefc6;
  background: #ecfdf3;
  color: #067647;
}

.cpProgrammeClubState.isDisabled {
  border-color: #d0d5dd;
  background: #f2f4f7;
  color: #475467;
}

.cpProgrammeClubDetails {
  border-top: 1px solid var(--border-subtle, #e7edf3);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.cpProgrammeClubDetails > div {
  min-width: 0;
  padding: 10px 12px;
}

.cpProgrammeClubDetails > div:nth-child(even) {
  border-left: 1px solid var(--border-subtle, #e7edf3);
}

.cpProgrammeClubDetails > div:nth-child(n + 3) {
  border-top: 1px solid var(--border-subtle, #e7edf3);
}

.cpProgrammeClubDetails span,
.cpProgrammeClubDetails strong {
  display: block;
}

.cpProgrammeClubDetails span {
  margin-bottom: 3px;
  color: var(--text-muted, #69778a);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.cpProgrammeClubDetails strong {
  overflow: hidden;
  color: var(--text-strong, #142033);
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
}

.cpProgrammeClubsEmpty {
  padding: 28px 20px;
  border: 1px dashed #cfd8e3;
  border-radius: 11px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: var(--slate-25, #f8fafc);
  text-align: center;
}

.cpProgrammeClubsEmpty strong {
  color: var(--text-strong, #142033);
  font-size: 13px;
}

.cpProgrammeClubsEmpty span {
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  line-height: 1.4;
}

.cpInvitePickerModal {
  height: calc(100vh - 48px);
}

.cpInvitePickerModal .modal-content {
  height: 100%;
  max-height: none !important;
  border-color: var(--border-subtle, #dbe3ec) !important;
  border-radius: 16px !important;
}

.cpInvitePickerModal .modal-header {
  flex: 0 0 auto;
  min-height: 68px;
  padding: 14px 20px !important;
  background: #fff !important;
  border-bottom-color: var(--border-subtle, #e7edf3) !important;
}

.cpInvitePickerModal .modal-body {
  min-height: 0;
  padding: 0 !important;
  overflow: hidden !important;
}

.cpInvitePickerTitle {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.cpInvitePickerTitle > span:first-child {
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
  font-size: 19px;
  font-weight: 800;
}

.cpInvitePickerTitle > span:last-child:not(:first-child) {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 500;
}

.cpInvitePicker {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.cpInvitePickerBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 16px 20px 0;
}

.cpInvitePickerNotice,
.cpInvitePickerError {
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid;
  border-radius: 9px;
  font-size: 12.5px;
  line-height: 1.45;
}

.cpInvitePickerNotice {
  border-color: #fedf89;
  background: #fffaeb;
  color: #93370d;
}

.cpInvitePickerError {
  border-color: #fecdca;
  background: #fef3f2;
  color: #b42318;
}

.cpInvitePickerEditor {
  height: 100%;
  min-height: 0;
}

.cpInvitePickerBody:has(.cpInvitePickerNotice) .cpInvitePickerEditor,
.cpInvitePickerBody:has(.cpInvitePickerError) .cpInvitePickerEditor {
  height: calc(100% - 64px);
}

.cpInvitePickerEditor .twoPanelEditor {
  height: 100%;
}

.cpInvitePickerEditor .twoPanelEditor__desktopLayout,
.cpInvitePickerEditor .twoPanelEditor__row {
  height: 100%;
}

.cpInvitePickerEditor .twoPanelEditor--sourceFirst .twoPanelEditor__panelCol {
  height: 100%;
  min-height: 0;
}

.cpInvitePickerFooter {
  flex: 0 0 auto;
  min-height: 66px;
  padding: 12px 20px;
  border-top: 1px solid var(--border-subtle, #e7edf3);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
}

.cpInvitePickerFooter .sit-btn {
  min-width: 104px;
}

.cpInvitePickerFooter .sit-btn--primary {
  min-width: 148px;
}

.cpInvitePickerEditor .twoPanelEditor--sourceFirst .twoPanelEditorPanel__footer {
  padding: 0;
  border-top: 0;
}

.cpInvitePickerEditor .twoPanelEditor--sourceFirst .bPagination--modern {
  min-height: 56px;
  padding: 10px 14px;
  border-width: 1px 0 0;
  border-radius: 0;
}

.cpInvitePickerEditor .bPagination__pages button {
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

.cpInvitePickerDiscardModal .modal-footer .btn {
  min-height: var(--control-h-md, 40px);
  padding: 0 16px;
  border-radius: var(--radius-md, 8px);
  font-size: var(--text-md, 14px);
  font-weight: var(--weight-semibold, 600);
}

.cpInvitePickerDiscardModal .modal-footer .btn-primary {
  border-color: var(--red-600, #c4313f);
  background: var(--red-600, #c4313f);
}

.cpInvitePickerDiscardModal .modal-footer .btn-secondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--slate-0, #fff);
  color: var(--text-body, #334155);
}

@media (max-width: 767px) {
  .cpInvitePickerModal {
    width: 100vw !important;
    height: 100vh;
    max-width: none !important;
  }

  .cpInvitePickerModal .modal-content {
    border-radius: 0 !important;
  }

  .cpInvitePickerBody {
    padding: 12px 14px 0;
    overflow: auto;
  }

  .cpInvitePickerEditor {
    min-height: 520px;
  }

  .cpInvitePickerFooter {
    padding: 12px 14px;
  }

  .cpInvitePickerFooter .sit-btn {
    flex: 1 1 0;
    min-width: 0;
  }

  .cpInvitePickerEditor .bPagination--modern {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
}

@media (max-width: 720px) {
  .cpDsSummary.sit-drawer {
    width: 100vw;
    max-width: 100vw;
  }
}
/* Activity programme drawer content */
.cpDsSummary.sit-drawer {
  width: 520px;
}

.cpDsSummary.sit-drawer .cpDrawerLead {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #164170);
}

.cpDrawerStatus {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
}

.cpDrawerStatus::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.cpDrawerStatus--draft {
  background: var(--slate-100, #edf2f7);
  border-color: var(--border-subtle, #dbe3ec);
  color: var(--text-muted, #64748b);
}

.cpDrawerStatus--active {
  background: var(--green-50, #e7f3ec);
  border-color: #bfe6cd;
  color: var(--green-700, #1f7a45);
}

.cpDrawerStatus--completed {
  background: var(--blue-50, #eaf5fc);
  border-color: #cfe6f5;
  color: var(--blue-700, #155d8c);
}

.cpDrawerStatus--archived {
  background: #f1effa;
  border-color: #ddd6fe;
  color: #5b4b9a;
}

.cpDrawerSummary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cpDrawerBookingWindow {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 15px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--slate-25, #f8fafc);
}

.cpDrawerBookingIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--blue-700, #164170);
}

.cpDrawerBookingContent {
  flex: 1 1 auto;
  min-width: 0;
}

.cpDrawerBookingLabel {
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.03em;
  line-height: 1.2;
  text-transform: uppercase;
}

.cpDrawerBookingDates {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 3px;
  color: var(--text-strong, #142033);
  font-family: var(--font-body, inherit);
  font-size: 14px;
  font-weight: 650;
  line-height: 1.35;
  font-variant-numeric: tabular-nums;
  flex-wrap: wrap;
}

.cpDrawerBookingArrow {
  display: inline-flex;
  color: var(--text-subtle, #94a3b8);
}

.cpDrawerFieldList {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--surface-card, #ffffff);
  overflow: hidden;
}

.cpDrawerFieldRow {
  display: grid;
  grid-template-columns: minmax(138px, 0.78fr) minmax(0, 1fr);
  gap: 14px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
}

.cpDrawerFieldRow:last-child {
  border-bottom: 0;
}

.cpDrawerFieldLabel {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 650;
  line-height: 1.35;
}

.cpDrawerFieldValue {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 650;
  line-height: 1.4;
  min-width: 0;
  overflow-wrap: anywhere;
}

.cpDrawerLockNote {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.5;
}

.cpDrawerInfoNote {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 11px;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #155d8c);
  font-size: 13px;
  font-weight: 600;
}

.cpDrawerInfoNote > span:first-child {
  display: inline-flex;
  flex: 0 0 auto;
}

.cpDsSummary.sit-drawer .cpDrawerFoot {
  flex: 0 0 auto;
  display: flex;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--slate-25, #f8fafc);
}

.cpDrawerActionBtn {
  flex: 1 1 auto;
  height: 40px;
  gap: 8px;
  border-radius: var(--radius-md, 8px);
  font-size: 13.5px;
  font-weight: 700;
}

.cpDrawerActionBtn svg {
  flex: 0 0 auto;
}

@media (max-width: 720px) {
  .cpDrawerFieldRow {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .cpDsSummary.sit-drawer .cpDrawerFoot {
    flex-direction: column;
  }
}

/* DS add-clubs page controls */
.cpToolbarActions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.cpAddClubsColumnsMenu {
  z-index: 10;
}

.sit-cols {
  position: relative;
  display: inline-flex;
}

.sit-cols__btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #243244);
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease;
}

.sit-cols__btn:hover {
  border-color: var(--border-strong, #aab7c6);
  background: var(--surface-hover, #f5f8fb);
}

.sit-cols__btn--open {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef7fd);
  color: var(--blue-700, #155d8c);
}

.sit-cols__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--blue-100, #dceffc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  font-weight: 800;
}

.sit-cols__pop {
  position: absolute;
  top: calc(100% + 6px);
  z-index: 1200;
  width: 244px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.16);
  animation: sit-cols-in 0.16s ease-out;
}

.sit-cols__pop--right {
  right: 0;
}

@keyframes sit-cols-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

.sit-cols__hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px 8px;
}

.sit-cols__title {
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.sit-cols__reset {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #227ebd);
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.sit-cols__reset:hover {
  text-decoration: underline;
}

.sit-cols__list {
  max-height: 320px;
  overflow-y: auto;
}

.sit-cols__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-body, #243244);
  font: inherit;
  font-size: 13.5px;
  text-align: left;
  cursor: pointer;
  user-select: none;
}

.sit-cols__item:hover {
  background: var(--surface-hover, #f5f8fb);
}

.sit-cols__item--locked {
  color: var(--text-subtle, #8896a8);
  cursor: default;
}

.sit-cols__item--locked:hover {
  background: transparent;
}

.sit-cols__lock {
  margin-left: auto;
  color: var(--text-subtle, #8896a8);
}

.sit-cols__cb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  border: 1.5px solid var(--border-strong, #aab7c6);
  border-radius: 4px;
  background: var(--surface-card, #fff);
  transition: background 0.16s ease, border-color 0.16s ease;
}

.sit-cols__cb svg {
  width: 12px;
  height: 12px;
  fill: none;
  stroke: #fff;
  stroke-width: 3;
  opacity: 0;
}

.sit-cols__item[data-on='true'] .sit-cols__cb {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

.sit-cols__item[data-on='true'] .sit-cols__cb svg {
  opacity: 1;
}

.cpAddClubsSelectWrap {
  position: relative;
}

.cpAddClubsSelectionBtn {
  height: 38px;
}

.cpAddClubsSelectionBtn input {
  pointer-events: none;
}

.cpAddClubsChevron {
  margin-left: 2px;
  color: var(--text-muted, #69778a);
}

.cpAddClubsSelectMenu {
  min-width: 260px;
}

.cpAddClubsMenuItem {
  display: block;
  width: 100%;
  padding: 7px 9px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-body, #243244);
  font: inherit;
  font-size: 13.5px;
  font-weight: 650;
  text-align: left;
}

.cpAddClubsMenuItem:hover:not(:disabled) {
  background: var(--surface-hover, #f5f8fb);
}

.cpAddClubsMenuItem:disabled {
  opacity: 0.48;
}

.cpAddClubsMenuDivider {
  height: 1px;
  margin: 6px 0;
  background: var(--border-subtle, #dbe3ec);
}

.cpAddClubsPrimaryBtn {
  min-width: 178px;
}

.cpAddClubsRange {
  font-size: 13px;
  white-space: nowrap;
}

.cpAddClubsSelectCol {
  width: 42px;
  min-width: 42px;
  max-width: 42px;
  text-align: center;
}

.cpAddClubsTable th,
.cpAddClubsTable td {
  padding-right: 12px;
  padding-left: 12px;
}

.cpAddClubsTable .cpAddClubsSelectCol {
  padding-right: 8px;
  padding-left: 8px;
}

.cpAddClubsClubName {
  display: block;
  overflow: hidden;
  color: var(--text-strong, #142033);
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpAddClubsBadges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cpAddClubsLoader {
  padding: 16px;
}

.cpAddClubsEmpty {
  padding: 14px 12px;
}

@media (max-width: 820px) {
  .cpToolbarRowDs {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .cpToolbarActions {
    order: 3;
    width: 100%;
    margin-left: 0;
  }

  .sit-cols,
  .sit-cols__btn {
    width: 100%;
  }

  .sit-cols__btn {
    justify-content: center;
  }
}

/* Manage clubs add-clubs modal */
.cpAddClubsModalBody {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  padding: 18px 20px !important;
  font-weight: 400 !important;
}

.cpAddClubsModalBody > .cpModalShell {
  flex: 1 1 auto;
  min-height: 0;
}

.cpAddClubsModalIntro {
  margin-bottom: 12px;
  color: var(--text-muted, #69778a);
  font-size: 13.5px;
  line-height: 1.45;
}

.cpManageAddClubsBtn {
  min-width: 104px;
}

/* Manage clubs page layout */
.cpManageClubsLayout {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);
  gap: 14px;
  align-items: start;
  overflow: hidden;
}

.cpManageClubsMainPane,
.cpManageClubsSummaryPane {
  min-width: 0;
  min-height: 0;
}

.cpManageClubsMainPane {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cpManageClubsMainPane .cpDataTableShell {
  flex: 1 1 auto;
  min-height: 260px;
}

.cpManageClubsSummaryPane {
  max-height: 100%;
  overflow: auto;
}

.cpManageClubsLoading {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
}

@media (max-width: 1180px) {
  .cpManageClubsLayout {
    grid-template-columns: 1fr;
    overflow: visible;
  }

  .cpManageClubsMainPane,
  .cpManageClubsSummaryPane {
    overflow: visible;
  }
}

/* Programme clubs manage screen (ProgrammeClubs.dc.html) */
.pc-scroll {
  scrollbar-color: rgba(105, 119, 138, 0.45) transparent;
}

.pcProgrammeClubsPage {
  min-height: 100vh;
  overflow: auto;
  background: var(--surface-page, #f4f7fb);
  color: var(--text-body, #243244);
  font-family: var(--font-body, Inter, Arial, sans-serif);
}

.pcProgrammeClubsHeader {
  padding: 22px 28px 18px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--surface-card, #fff);
}

.pcBackLink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 10px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--brand-600, #227ebd);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.pcProgrammeClubsHeaderMain {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.pcProgrammeClubsTitleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pcProgrammeClubsTitle {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, Inter, Arial, sans-serif);
  font-size: 28px;
  font-weight: 800;
  line-height: 1.15;
}

.pcProgrammeClubsSubtitle {
  margin-top: 6px;
  color: var(--text-muted, #69778a);
  font-size: 14px;
  line-height: 1.45;
}

.pcProgrammeClubsBody {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 18px 24px 60px;
}

.pcToolbar,
.pcFilterBar,
.pcSelectionBar,
.pcCard {
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--surface-card, #fff);
}

.pcToolbar {
  padding: 14px 16px;
}

.pcToolbarTop,
.pcToolbarControls,
.pcSelectionBar,
.pcSelectionActions,
.pcPagination,
.pcClubCell,
.pcStatusToggle,
.pcDrawerMeta,
.pcMetricStrip,
.pcInviteSwitchRow {
  display: flex;
  align-items: center;
}

.pcToolbarTop {
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.pcToolbarTitle {
  color: var(--text-strong, #142033);
  font-size: 15px;
  font-weight: 800;
}

.pcToolbarCount {
  margin-top: 2px;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 600;
}

.pcToolbarControls {
  gap: 10px;
}

.pcSearchBox {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 1 1 auto;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 9px;
  background: var(--slate-50, #f5f8fb);
}

.pcSearchBox input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #142033);
  font: inherit;
  font-size: 13.5px;
}

.pcFilterBar {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 12px 16px;
}

.pcFilterBar label {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  color: var(--text-body, #243244);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
}

.pcFilterBar input,
.pcCheckbox {
  width: 16px;
  height: 16px;
  accent-color: var(--brand-600, #227ebd);
}

.pcSelectionBar {
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: var(--brand-25, #f5f9fd);
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 700;
}

.pcSelectionActions,
.pcPagination {
  gap: 8px;
}

.pcButton,
.pcIconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 9px;
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
}

.pcButton {
  gap: 8px;
  min-height: 38px;
  padding: 0 13px;
}

.pcButton:disabled,
.pcIconBtn:disabled {
  cursor: default;
  opacity: 0.48;
}

.pcButton--primary {
  border-color: var(--brand-600, #227ebd);
  background: var(--brand-600, #227ebd);
  color: #fff;
}

.pcButton--secondary {
  border-color: var(--border-default, #cfd8e3);
  background: var(--surface-card, #fff);
  color: var(--text-body, #243244);
}

.pcButton--ghost {
  border-color: transparent;
  background: transparent;
  color: var(--text-muted, #69778a);
}

.pcButton--danger {
  border-color: var(--red-200, #f3c3c3);
  background: var(--red-50, #fff1f1);
  color: var(--red-700, #b42318);
}

.pcIconBtn {
  width: 34px;
  height: 34px;
  padding: 0;
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--surface-card, #fff);
  color: var(--text-muted, #69778a);
}

.pcCard--flush {
  overflow: hidden;
}

.pcDataTable {
  width: 100%;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  color: var(--text-body, #243244);
  font-size: 13.5px;
}

.pcDataTable th {
  height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--slate-25, #f8fafc);
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-align: left;
  text-transform: uppercase;
}

.pcDataTable td {
  height: 58px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  vertical-align: middle;
}

.pcDataTable tbody tr:last-child td {
  border-bottom: 0;
}

.pcDataTableRow {
  cursor: pointer;
}

.pcDataTableRow:hover,
.pcDataTableRow--selected {
  background: var(--brand-25, #f5f9fd);
}

.pcTableSelectCol {
  width: 44px;
  min-width: 44px;
  text-align: center !important;
}

.pcClubCell {
  gap: 11px;
  min-width: 0;
}

.pcClubIcon,
.pcDrawerLead {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--blue-50, #eef7fd);
  color: var(--brand-600, #227ebd);
}

.pcClubText {
  min-width: 0;
}

.pcClubName,
.pcClubSport {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pcClubName {
  color: var(--text-strong, #142033);
  font-weight: 700;
}

.pcClubSport,
.pcWhenCell small,
.pcDrawerHint,
.pcDrawerMutedNote {
  color: var(--text-muted, #69778a);
  font-size: 12px;
}

.pcWhenCell {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.pcWhenCell span,
.pcNumberCell {
  color: var(--text-strong, #142033);
  font-weight: 600;
}

.pcSearchIcon,
.pcRunIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #69778a);
}

.pcRunIcon {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  border-radius: 9px;
  background: var(--blue-50, #eef7fd);
  color: var(--brand-600, #227ebd);
}

.pcTablePlainText,
.pcTableMutedText {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 600;
}

.pcDsChip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 22px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.pcDsChip--info {
  background: var(--blue-50, #eef7fd);
  color: var(--brand-600, #227ebd);
}

.pcDsChip--warning {
  background: var(--amber-50, #fdf6e3);
  color: var(--amber-700, #9a6a00);
}

.pcInvitesCell {
  display: inline-flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.pcBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 22px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.pcBadge--success {
  background: var(--green-50, #eaf8ef);
  color: var(--green-700, #147a3d);
}

.pcBadge--neutral {
  background: var(--slate-100, #eef2f6);
  color: var(--text-muted, #69778a);
}

.pcBadge--dot::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.pcStatusToggle {
  margin: 0;
  cursor: pointer;
}

.pcStatusToggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.pcDataTableEmpty,
.pcProgrammeClubsLoading,
.pcProgrammeClubsEmptyState {
  padding: 30px;
  color: var(--text-muted, #69778a);
  font-size: 13.5px;
  text-align: center;
}

.pcPagination {
  justify-content: flex-end;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 600;
}

.pcReadonly,
.pcErrorText {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  font-weight: 700;
}

.pcReadonly {
  color: var(--text-muted, #69778a);
}

.pcReadonlyIcon {
  display: inline-flex;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.pcReadonlyIcon svg {
  width: 100%;
  height: 100%;
}

.pcErrorText {
  color: var(--red-700, #b42318);
}

.pcDrawerOverlay {
  position: fixed;
  inset: 0;
  z-index: 160;
  display: flex;
  justify-content: flex-end;
  background: rgba(15, 23, 42, 0.32);
}

.pcDrawerSheet {
  display: flex;
  flex-direction: column;
  width: min(520px, 100vw);
  height: 100vh;
  background: var(--surface-card, #fff);
  box-shadow: -24px 0 60px rgba(15, 23, 42, 0.2);
}

.pcDrawerHead {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px 15px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.pcDrawerLead {
  width: 46px;
  height: 46px;
  border-radius: 12px;
}

.pcDrawerTitles {
  flex: 1;
  min-width: 0;
}

.pcDrawerTitle {
  overflow: hidden;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, Inter, Arial, sans-serif);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pcDrawerMeta {
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 7px;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}

.pcDrawerMeta i {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: var(--border-strong, #aab7c6);
}

.pcDrawerClose {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 9px;
  background: var(--slate-50, #f5f8fb);
  color: var(--text-muted, #69778a);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.pcDrawerTabs {
  display: flex;
  gap: 18px;
  padding: 0 20px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.pcDrawerTabs button {
  position: relative;
  height: 46px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-muted, #69778a);
  font: inherit;
  font-size: 13.5px;
  font-weight: 750;
  cursor: pointer;
}

.pcDrawerTabs button.isActive {
  color: var(--brand-600, #227ebd);
}

.pcDrawerTabs button.isActive::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: var(--brand-600, #227ebd);
}

.pcDrawerBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 16px 20px;
}

.pcDrawerFoot {
  flex: 0 0 auto;
  display: flex;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--slate-25, #f8fafc);
}

.pcDrawerFoot > * {
  flex: 1 1 auto;
}
.pcDrawerPanel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.pcRunCard,
.pcInviteSwitchRow,
.pcMetricStrip,
.pcMetricGrid > div,
.pcSegment {
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--slate-25, #f8fafc);
}

.pcRunCard {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 15px;
}

.pcRunLabel,
.pcDrawerKicker,
.pcDrawerFieldRow span,
.pcMetricGrid small {
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.pcRunValue,
.pcDrawerStrong {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 700;
}

.pcDrawerFieldList {
  display: flex;
  flex-direction: column;
}

.pcDrawerFieldRow {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 11px 0;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.pcDrawerFieldRow:last-child {
  border-bottom: 0;
}

.pcDrawerFieldRow b {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 550;
}

.pcDrawerWarnNote,
.pcDrawerInfoNote,
.pcDrawerMutedNote {
  padding: 11px 14px;
  border-radius: 11px;
  font-size: 12.5px;
  line-height: 1.5;
}

.pcDrawerWarnNote {
  background: var(--amber-50, #fdf6e3);
  color: var(--amber-700, #9a6a00);
  font-weight: 600;
}

.pcDrawerInfoNote,
.pcDrawerMutedNote {
  border: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--slate-50, #f5f8fb);
}

.pcSegmentGroup {
  display: flex;
  gap: 10px;
}

.pcSegment {
  flex: 1;
  padding: 12px 14px;
  text-align: left;
}

.pcSegment--active {
  border-color: var(--brand-400, #7db4e0);
  background: var(--brand-25, #f5f9fd);
}

.pcSegment span,
.pcSegment small {
  display: block;
}

.pcSegment span {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 700;
}

.pcSegment small {
  margin-top: 5px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
}

.pcMetricStrip {
  gap: 16px;
  padding: 12px 15px;
}

.pcMetricGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.pcMetricGrid > div {
  padding: 13px 15px;
}

.pcMetricGrid b {
  display: block;
  margin-top: 4px;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, Inter, Arial, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.pcInviteSwitchRow {
  justify-content: space-between;
  gap: 12px;
  padding: 14px 15px;
  background: var(--surface-card, #fff);
}

.pcSwitch {
  width: 38px;
  height: 22px;
  accent-color: var(--brand-600, #227ebd);
}

.pcIcon::before {
  display: inline-block;
  width: 1em;
  text-align: center;
}

.pcIcon--back::before {
  content: '‹';
  font-size: 18px;
  line-height: 0;
}
.pcIcon--plus::before {
  content: '+';
  font-size: 18px;
  font-weight: 800;
}
.pcIcon--filter::before {
  content: '≡';
  transform: rotate(90deg);
}
.pcIcon--search::before {
  content: '⌕';
}
.pcIcon--lock::before {
  content: '▣';
}
.pcIcon--calendar::before {
  content: '□';
}
.pcIcon--list::before {
  content: '☷';
}
.pcIcon--mail::before {
  content: '✉';
}
.pcIcon--whistle::before {
  content: '◌';
}

@media (max-width: 760px) {
  .pcProgrammeClubsHeaderMain,
  .pcToolbarControls,
  .pcFilterBar,
  .pcSelectionBar {
    align-items: stretch;
    flex-direction: column;
  }

  .pcProgrammeClubsBody {
    padding: 14px 12px 48px;
  }

  .pcDataTable {
    min-width: 980px;
  }

  .pcCard--flush {
    overflow-x: auto;
  }
}

/* Add clubs compact modal (ProgrammeClubs.dc.html) */
.pcAddModalOverlay {
  position: fixed;
  inset: 0;
  z-index: 180;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.42);
}

.pcAddModalPanel {
  display: flex;
  flex-direction: column;
  width: min(620px, 94vw);
  max-height: 86vh;
  overflow: hidden;
  border-radius: 16px;
  background: var(--surface-card, #fff);
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.28);
}

.pcAddModalHead {
  padding: 18px 22px 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.pcAddModalTitleRow,
.pcAddModalSearch,
.pcAddClubRow,
.pcAddModalFoot,
.pcAddModalActions {
  display: flex;
  align-items: center;
}

.pcAddModalTitleRow,
.pcAddModalFoot {
  justify-content: space-between;
  gap: 12px;
}

.pcAddModalTitle {
  color: var(--text-strong, #142033);
  font-family: var(--font-display, Inter, Arial, sans-serif);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}

.pcAddModalClose {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 9px;
  background: var(--slate-50, #f5f8fb);
  color: var(--text-muted, #69778a);
  font: inherit;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.pcAddModalSearch {
  gap: 9px;
  height: 38px;
  margin-top: 12px;
  padding: 0 12px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 9px;
  background: var(--slate-50, #f5f8fb);
}

.pcAddModalSearchIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #69778a);
}
.pcAddModalSearch input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #142033);
  font: inherit;
  font-size: 13.5px;
}

.pcAddModalList {
  flex: 1 1 auto;
  min-height: 180px;
  overflow-y: auto;
  padding: 14px 22px;
}

.pcAddClubRow {
  gap: 12px;
  margin: 0 0 8px;
  padding: 11px 13px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 11px;
  background: var(--surface-card, #fff);
  cursor: pointer;
}

.pcAddClubRow--selected {
  border-color: var(--brand-300, #a9cdea);
  background: var(--brand-25, #f5f9fd);
}

.pcAddClubRow input {
  flex: 0 0 auto;
  width: 17px;
  height: 17px;
  accent-color: var(--brand-600, #227ebd);
}

.pcAddClubIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--blue-50, #eef7fd);
  color: var(--brand-600, #227ebd);
}

.pcAddClubText {
  flex: 1;
  min-width: 0;
}

.pcAddClubName,
.pcAddClubMeta {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pcAddClubName {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 650;
}

.pcAddClubMeta {
  margin-top: 1px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
}

.pcAddModalFoot {
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
}

.pcAddModalSelected {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}

.pcAddModalActions {
  gap: 10px;
}

.pcAddModalEmpty,
.pcAddModalError {
  padding: 30px;
  color: var(--text-muted, #69778a);
  font-size: 13.5px;
  text-align: center;
}

.pcAddModalError {
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--red-50, #fff1f1);
  color: var(--red-700, #b42318);
  text-align: left;
}

@media (max-width: 560px) {
  .pcAddModalOverlay {
    align-items: stretch;
    padding: 0;
  }

  .pcAddModalPanel {
    width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }

  .pcAddModalFoot {
    align-items: stretch;
    flex-direction: column;
  }

  .pcAddModalActions {
    justify-content: flex-end;
  }
}

.pcToolbar--inline {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
}

.pcToolbarTitleWrap {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  flex: 0 0 auto;
  min-width: 0;
}

.pcToolbarCountChip,
.pcButtonBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--slate-100, #eef2f6);
  color: var(--text-muted, #69778a);
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
}

.pcSearchBox--inline {
  flex: 1 1 320px;
  max-width: 430px;
}

.pcIconAction {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #69778a);
  cursor: pointer;
}

.pcIconAction:hover,
.pcIconAction--on {
  border-color: var(--brand-300, #a9cdea);
  color: var(--brand-600, #227ebd);
}

.pcColumnsMenuWrap {
  position: relative;
  flex: 0 0 auto;
}

.pcButton--columns {
  min-width: 118px;
}

.pcColumnsMenu {
  position: absolute;
  top: calc(100% + 2px);
  right: 0;
  z-index: 35;
  min-width: 248px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.pcColumnsMenuHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 8px 9px;
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.pcColumnsMenuHead button {
  border: 0;
  background: transparent;
  color: var(--brand-600, #227ebd);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  text-transform: none;
  letter-spacing: 0;
}

.pcColumnsMenuItem {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 34px;
  padding: 7px 8px;
  border-radius: 6px;
  color: var(--text-body, #243244);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pcColumnsMenuItem:hover {
  background: var(--slate-50, #f5f8fb);
}

.pcColumnsMenuItem--locked {
  color: var(--text-subtle, #94a3b8);
  cursor: default;
}

.pcColumnsMenuItem input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--brand-600, #227ebd);
}

.pcPagination--pages {
  margin-top: 14px;
}

.pcPaginationSummary {
  margin-right: 4px;
}

.pcPaginationEllipsis {
  min-width: 18px;
  text-align: center;
  color: var(--text-subtle, #94a3b8);
}

.pcPageBtn {
  min-width: 34px;
  height: 34px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #243244);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.pcPageBtn:hover {
  border-color: var(--brand-300, #a9cdea);
  color: var(--brand-700, #155d8c);
}

.pcPageBtn--active {
  border-color: var(--brand-600, #227ebd);
  background: var(--brand-600, #227ebd);
  color: #fff;
}

.pcDrawerDisableButton {
  min-width: 132px;
  height: 38px;
  border-radius: 9px;
  border-color: var(--border-default, #cfd8e3);
  background: var(--surface-card, #fff);
  color: var(--text-body, #243244);
}

@media (max-width: 900px) {
  .pcToolbar--inline {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .pcToolbarTitleWrap {
    width: 100%;
  }

  .pcSearchBox--inline {
    max-width: none;
  }
}

.pcDrawerButton {
  --_h: var(--control-h-md, 38px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: var(--_h);
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 8px);
  font-family: var(--font-body, 'Public Sans', Inter, Arial, sans-serif);
  font-size: var(--text-md, 14px);
  font-weight: var(--weight-semibold, 600);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition: background var(--dur-base, 160ms) var(--ease-out, ease-out),
    border-color var(--dur-base, 160ms) var(--ease-out, ease-out),
    color var(--dur-base, 160ms) var(--ease-out, ease-out), box-shadow var(--dur-base, 160ms) var(--ease-out, ease-out),
    transform var(--dur-fast, 100ms) var(--ease-out, ease-out);
}

.pcDrawerButton:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.22));
}

.pcDrawerButton:active {
  transform: translateY(0.5px);
}

.pcDrawerButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.pcDrawerButtonIcon {
  display: inline-flex;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.pcDrawerButtonIcon svg {
  width: 100%;
  height: 100%;
}

.pcDrawerButton--primary {
  background: var(--action-primary, #227ebd);
  color: var(--text-on-brand, #fff);
}

.pcDrawerButton--primary:hover {
  background: var(--action-primary-hover, #1d6fa8);
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);
}

.pcDrawerButton--primary:active {
  background: var(--action-primary-active, #155d8c);
  box-shadow: none;
}

.pcDrawerButton--secondary {
  background: var(--slate-0, #fff);
  color: var(--text-body, #243244);
  border-color: var(--border-default, #cfd8e3);
}

.pcDrawerButton--secondary:hover {
  background: var(--surface-hover, #eef2f6);
  border-color: var(--border-strong, #aab7c6);
}

.pcDrawerButton--secondary:active {
  background: var(--surface-active, #e2e8f0);
}
.pcBookingFormTab {
  gap: 16px;
}

.pcBookingFormTab .pcSegment {
  appearance: none;
  display: block;
  border: 1.5px solid var(--border-default, #cfd8e3);
  background: var(--surface-card, #fff);
  color: inherit;
  cursor: pointer;
  font: inherit;
}

.pcBookingFormTab .pcSegment:disabled {
  cursor: default;
}

.pcBookingFormTab .pcSegment--active {
  border-color: var(--brand-400, #7db4e0);
  background: var(--brand-25, #f5f9fd);
}

.pcSegmentHead {
  display: flex !important;
  align-items: center;
  gap: 8px;
}

.pcSegmentHead i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 2px solid var(--border-default, #cfd8e3);
  border-radius: 50%;
  flex: 0 0 16px;
}

.pcSegment--active .pcSegmentHead i {
  border-color: var(--brand-600, #227ebd);
}

.pcSegment--active .pcSegmentHead i::after {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--brand-600, #227ebd);
  content: '';
}

.pcSegmentHead b {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.25;
}

.pcBookingFormTab .pcSegment small {
  margin-left: 24px;
  line-height: 1.4;
}

.pcBookingFormHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: -7px;
}

.pcBookingFormHeader > div {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
  font-weight: 700;
}

.pcGhostMiniButton,
.pcMiniButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: var(--control-h-sm, 30px);
  border: 1px solid transparent;
  border-radius: var(--radius-md, 8px);
  padding: 0 12px;
  font-family: var(--font-body, 'Public Sans', Inter, Arial, sans-serif);
  font-size: var(--text-sm, 12.5px);
  font-weight: var(--weight-semibold, 600);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.pcGhostMiniButton,
.pcMiniButton--ghost {
  background: transparent;
  color: var(--text-body, #243244);
}

.pcGhostMiniButton:hover,
.pcMiniButton--ghost:hover {
  background: var(--surface-hover, #eef2f6);
}

.pcMiniButton--secondary {
  border-color: var(--border-default, #cfd8e3);
  background: var(--slate-0, #fff);
  color: var(--text-body, #243244);
}

.pcMiniButton--secondary:hover {
  border-color: var(--border-strong, #aab7c6);
  background: var(--surface-hover, #eef2f6);
}

.pcBookingMetrics {
  display: flex;
  align-items: center;
  margin-bottom: -4px;
}

.pcBookingMetrics span {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.35;
}

.pcBookingMetrics b {
  color: var(--text-strong, #142033);
  font-weight: 800;
}

.pcFormElementList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pcFormQuestionRow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--surface-card, #fff);
}

.pcFormQuestionIndex {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  flex: 0 0 26px;
  background: var(--slate-100, #eef2f6);
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 800;
}

.pcFormQuestionRow > .pcFormQuestionTitle {
  flex: 1 1 auto;
  min-width: 0;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.35;
}

.pcFormQuestionRow em,
.pcFormQuestionRow i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-height: 22px;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 11.5px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.pcFormQuestionRow em {
  background: var(--blue-50, #eaf4fb);
  color: var(--brand-700, #1b668f);
}

.pcFormQuestionRow i {
  background: var(--amber-50, #fdf6e3);
  color: var(--amber-700, #9a6a00);
}

.pcFormPageBreak {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

.pcFormPageBreak span {
  flex: 1 1 auto;
  border-top: 2px dashed var(--border-default, #cfd8e3);
}

.pcFormPageBreak b,
.pcFormContentRow {
  color: var(--text-subtle, #8a97a8);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.pcFormContentRow {
  padding-top: 4px;
}

.pcFormEmptyState {
  padding: 26px 20px;
  text-align: center;
  border: 1px dashed var(--border-default, #cfd8e3);
  border-radius: 12px;
  background: var(--surface-card, #fff);
}

.pcFormEmptyIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 11px;
  border-radius: 12px;
  background: var(--slate-100, #e9eef5);
  color: var(--text-subtle, #8a97a8);
}

.pcFormEmptyTitle {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 700;
}

.pcFormEmptyText {
  max-width: 320px;
  margin: 4px auto 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.5;
}

.pcFormEmptyActions {
  display: flex;
  justify-content: center;
  gap: 9px;
  margin-top: 14px;
}

/* Programme bookings allocation board - design system */
.pbPageHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 28px 16px;
  background: var(--surface-card, #ffffff);
  border-bottom: 1px solid var(--border-subtle, #e5e7eb);
}

.pbBackLink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 10px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--brand-600, #227ebd);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pbPageTitleRow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pbPageTitleRow h1 {
  margin: 0;
  font-family: var(--font-display, inherit);
  font-size: 23px;
  font-weight: 800;
  line-height: 1.18;
  color: var(--text-strong, #0f172a);
}

.pbHeaderStatus {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #e7f3ec;
  color: #1f7a45;
  font-size: 12px;
  font-weight: 700;
}

.pbPageMeta {
  margin-top: 4px;
  color: var(--text-muted, #64748b);
  font-size: 13.5px;
}

.pbHeaderPrimaryButton,
.pbConfirmProgrammeButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: var(--brand-600, #227ebd);
  color: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.pbHeaderPrimaryButton:disabled,
.pbConfirmProgrammeButton:disabled {
  background: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
}

.pbBoardPage {
  min-height: 100vh;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
}

.pbControlBar {
  position: sticky;
  top: 0;
  z-index: 30;
  padding: 12px 28px;
  background: var(--surface-card, #ffffff);
  border-bottom: 1px solid var(--border-subtle, #e5e7eb);
}

.pbControlBarInner {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pbControlDivider {
  width: 1px;
  height: 24px;
  background: var(--border-subtle, #e5e7eb);
}

.pbControlLabel {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.pbControlHint {
  margin-left: auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
}

.pbHelpButton {
  width: 34px;
  height: 34px;
  border: 1px solid #cfe4f5;
  border-radius: 50%;
  background: #eaf4fb;
  color: var(--brand-600, #227ebd);
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.pbConfirmDayButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 13px;
  border: 1px solid #9dd3b0;
  border-radius: 8px;
  background: #e7f3ec;
  color: #1f7a45;
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}

.pbConfirmDayButton:disabled {
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}

.pbMenuWrap {
  position: relative;
  display: inline-block;
}
.pbMenuButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #ffffff);
  color: var(--text-body, #334155);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.pbMenuButton:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.pbMenuDropdown {
  position: absolute;
  top: 38px;
  right: 0;
  z-index: 50;
  min-width: 220px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);
}
.pbMenuItem {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-body, #334155);
  text-align: left;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
.pbMenuItem:hover:not(:disabled) {
  background: #f1f5f9;
}
.pbMenuItem:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pbDayTabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 14px 28px 4px;
}
.pbDayTab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 15px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 10px;
  background: #ffffff;
  color: var(--text-body, #334155);
  font: inherit;
  font-size: 13.5px;
  font-weight: 650;
  cursor: pointer;
}
.pbDayTab--active {
  border-color: transparent;
  background: var(--brand-600, #227ebd);
  color: #ffffff;
}
.pbDayTabCount,
.pbClubColumnCount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 700;
}
.pbDayTab--active .pbDayTabCount {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}
.pbDayTabConflict {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #da4453;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
}

.pbInfoBanner,
.pbLockedBanner,
.pbErrorBanner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 28px 0;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 12.5px;
  line-height: 1.4;
}
.pbInfoBanner {
  border: 1px solid #cfe4f5;
  background: #eaf4fb;
  color: #1c5f8f;
}
.pbLockedBanner {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
}
.pbErrorBanner {
  border: 1px solid #fecdd3;
  background: #fff1f2;
  color: #be123c;
}
.pbInfoIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid currentColor;
  font-weight: 800;
}

.pbTopScroll {
  overflow-x: auto;
  overflow-y: hidden;
  height: 20px;
  margin: 8px 28px 0;
}
.pbBoardScroll {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 14px 28px 24px;
}
.pbBoardColumns {
  display: inline-flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 100%;
}
.pb-scroll::-webkit-scrollbar {
  width: 10px;
  height: 12px;
}
.pb-scroll::-webkit-scrollbar-thumb {
  background: rgba(15, 23, 42, 0.2);
  border: 3px solid transparent;
  border-radius: 999px;
  background-clip: content-box;
}
.pb-col::-webkit-scrollbar {
  width: 8px;
}
.pb-col::-webkit-scrollbar-thumb {
  background: rgba(15, 23, 42, 0.14);
  border-radius: 999px;
}

.pbClubColumn {
  flex: 0 0 326px;
  width: 326px;
}
.pbClubColumnInner {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: 14px;
  background: var(--surface-card, #ffffff);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}
.pbClubColumnHeader {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 13px 14px 12px;
  border-bottom: 1px solid var(--border-subtle, #e5e7eb);
  background: var(--surface-card, #ffffff);
  box-shadow: none;
}
.pbClubColumnTitleRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.pbClubColumnTitleMain {
  min-width: 0;
}
.pbClubColumnName {
  color: var(--text-strong, #0f172a);
  font-size: 15px;
  font-weight: 750;
  line-height: 1.25;
}
.pbClubColumnTime {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  color: #64748b;
  font-size: 13px;
}
.pbClubColumnTime span {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.pbClubColumnActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}
.pbColumnIconButton,
.cpIconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: 7px;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
}
.pbClubStatsPanel {
  margin-top: 11px;
  padding: 10px 11px;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: 10px;
  background: #f8fafc;
}
.pbClubStatsGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}
.pbClubStat {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.pbClubStat em {
  color: #94a3b8;
  font-size: 10.5px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.pbClubStat b {
  color: #0f172a;
  font-size: 14px;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
}
.pbClubPendingRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 9px;
}
.pbPendingChip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid #f2dfa8;
  border-radius: 999px;
  background: #fdf6e3;
  color: #9a6a00;
  font-size: 11.5px;
  font-weight: 650;
}
.pbOverCapacityNote {
  margin-top: 8px;
  padding: 8px 9px;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  background: #fff1f2;
  color: #be123c;
  font-size: 12px;
}
.pbClubColumnFooterActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}
.pbColumnFillButton,
.pbColumnConfirmButton,
.pbCardActionButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 10px;
  border-radius: 7px;
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.pbColumnFillButton {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
}
.pbColumnConfirmButton {
  border: 1px solid #9dd3b0;
  background: #e7f3ec;
  color: #1f7a45;
}
.pbColumnConfirmButton:disabled,
.pbColumnFillButton:disabled,
.pbCardActionButton:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.pbClubColumnBody {
  max-height: 620px;
  overflow-y: auto;
  padding: 12px;
  background: #ffffff;
}
.pbColumnEmpty,
.pbEmptyState {
  color: #64748b;
  font-size: 13px;
}
.pbEmptyState {
  margin: 16px 28px;
  padding: 50px;
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  background: #ffffff;
  text-align: center;
}

.cpBookingsCard {
  padding: 10px 11px;
  border-radius: 11px;
  border-color: rgba(15, 23, 42, 0.08);
  box-shadow: none;
}
.cpBookingsCard + .cpBookingsCard {
  margin-top: 10px;
}
.cpBookingsCard--conflict {
  border-color: #fda4af;
  background: #fff1f2;
}
.cpBookingsCard--selectedClub {
  border-color: #bfdbfe;
  background: #eff6ff;
}
.cpBookingsCard--selectedWaiting {
  border-color: #fde68a;
  background: #fffbeb;
}
.cpBookingsCard--confirmedClub {
  border-color: #bbf7d0;
  background: #f0fdf4;
}
.cpBookingsCard--confirmedWaiting {
  border-color: #fde68a;
  background: #fffbeb;
}
.cpBookingsStudentName {
  color: #0f172a;
  font-size: 13.5px;
  font-weight: 700;
}
.cpBookingsMeta {
  margin-top: 5px;
  color: #64748b;
  font-size: 11.5px;
  line-height: 1.4;
}
.cpBookingsSide {
  gap: 5px;
}
.cpBookingsQuickActions {
  margin-top: 9px;
  gap: 7px;
}
.cpBookingsActions {
  justify-content: flex-end;
  gap: 7px;
  margin-top: 10px;
  padding-top: 9px;
}
.pbBadge {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.2;
}
.pbBadge--success {
  background: #dcfce7;
  color: #166534;
}
.pbBadge--info {
  background: #e0f2fe;
  color: #075985;
}
.pbBadge--warning {
  background: #fef3c7;
  color: #92400e;
}
.pbBadge--danger {
  background: #ffe4e6;
  color: #be123c;
}
.pbBadge--muted {
  background: #e2e8f0;
  color: #475569;
}
.pbBadge--priority {
  background: #e0f2fe;
  color: #0369a1;
}
.pbCardActionButton {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
}
.pbCardActionButton--primary {
  border-color: var(--brand-600, #227ebd);
  background: var(--brand-600, #227ebd);
  color: #ffffff;
}
.pbCardActionButton--warning {
  border-color: #f2dfa8;
  background: #fdf6e3;
  color: #9a6a00;
}
.pbCardActionButton--danger {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}
.pbCardActionButton--muted {
  border-color: #cbd5e1;
  background: #ffffff;
  color: #475569;
}
.pbLockedInline {
  margin-top: 8px;
  padding: 8px 9px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
}

@media (max-width: 768px) {
  .pbPageHeader,
  .pbControlBar,
  .pbDayTabs,
  .pbBoardScroll {
    padding-left: 16px;
    padding-right: 16px;
  }
  .pbInfoBanner,
  .pbLockedBanner,
  .pbErrorBanner,
  .pbTopScroll,
  .pbEmptyState {
    margin-left: 16px;
    margin-right: 16px;
  }
  .pbClubColumn {
    flex-basis: 300px;
    width: 300px;
  }
  .pbControlHint {
    flex-basis: 100%;
    margin-left: 0;
  }
}

.pbConfirmDayButton span,
.pbConfirmProgrammeButton span {
  position: relative;
  width: 14px;
  height: 14px;
  overflow: hidden;
  color: transparent;
  font-size: 0;
}

.pbConfirmDayButton span::before,
.pbConfirmProgrammeButton span::before {
  content: '';
  position: absolute;
  left: 3px;
  top: 1px;
  width: 6px;
  height: 10px;
  border: solid currentColor;
  border-width: 0 2px 2px 0;
  color: inherit;
  transform: rotate(45deg);
}

.pbConfirmDayButton:not(:disabled) span::before {
  color: #1f7a45;
}

.pbConfirmProgrammeButton:not(:disabled) span::before {
  color: #ffffff;
}

/* Activity programmes — refreshed school list shell. */
.clubProgrammesRoute {
  width: 100%;
  margin-top: 0 !important;
}

.cpDsPage {
  display: block;
  min-width: 0;
  min-height: calc(100vh - 68px);
  padding: 0 0 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpDsMain {
  gap: 18px;
}

.cpDsHeader {
  box-sizing: border-box;
  display: flex;
  width: calc(100% + 48px);
  min-height: 78px;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  margin: -20px 0 18px -24px;
  padding: 14px 72px 14px 28px;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0;
  background: var(--surface-card, #fff);
  box-shadow: none;
}

.cpDsHeaderTitle {
  min-width: 220px;
  flex: 0 0 auto;
}

.cpDsHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: -0.02em;
}

.cpDsHeader p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.35;
}

.cpDsToolbar {
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 9px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.cpDsSearch {
  width: 230px;
  min-width: 180px;
  flex: 0 1 230px;
}

.cpDsSearch > span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.cpDsSearch input {
  height: var(--control-h-md, 40px);
  border-radius: var(--radius-md, 8px);
  color: var(--text-strong, #0f172a);
  font-size: var(--text-md, 14px);
}

.cpDsSearch input::placeholder {
  color: var(--text-subtle, #94a3b8);
}

.cpDsBtn,
.cpDsIconTextBtn {
  min-height: 40px;
  height: 40px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
}

.cpDsBtnPrimary {
  margin-left: auto;
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  box-shadow: none;
}

.cpDsBtnPrimary:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}

.cpDsIconTextBtn:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.cpDsButtonBadge {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
}

.cpDsContentCard {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.cpDsActiveFilters {
  min-height: 44px;
  padding: 8px 12px;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0;
  background: var(--surface-card, #fff);
}

.cpDsActiveFilters > button span:last-child {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--blue-700, #155d8c);
  font-size: 15px;
  line-height: 1;
}

.cpDsActiveFilters > button:hover span:last-child {
  background: rgba(21, 93, 140, 0.1);
}

.cpDsSelectionBar {
  min-height: 48px;
  padding: 8px 12px;
  border: 0;
  border-bottom: 1px solid var(--blue-100, #d4e8f6);
  border-radius: 0;
  background: var(--blue-50, #eef6fc);
  box-shadow: none;
}

.cpDsSelectionBar .cpDsBtn {
  min-height: 32px;
  height: 32px;
  padding: 0 11px;
  font-size: 12.5px;
}

.cpDsTableCard {
  overflow: hidden;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.cpDsTable td {
  height: 56px;
}

.cpDsTable tbody tr:last-child td {
  border-bottom: 0;
}

.cpDsOpenCell {
  width: 40px;
  padding-right: 10px !important;
  padding-left: 6px !important;
  text-align: center !important;
}

.cpDsOpenCell span {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: var(--text-subtle, #94a3b8);
  font-size: 22px;
  line-height: 1;
  opacity: 0;
  transform: translateX(-3px);
  transition: opacity 120ms ease, transform 120ms ease, background 120ms ease;
}

.cpDsTable tbody tr:hover .cpDsOpenCell span,
.cpDsTable tbody tr.isPreview .cpDsOpenCell span {
  opacity: 1;
  transform: translateX(0);
}

.cpDsTable tbody tr:hover .cpDsOpenCell span {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--blue-700, #155d8c);
}

.cpDsFooter {
  min-height: 58px;
  margin: 0;
  padding: 12px 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  justify-content: flex-end;
  background: var(--surface-card, #fff);
}

.cpDsPaginationSummary {
  margin-right: auto;
}

.cpDsColumnsControl,
.cpDsFilterControl {
  z-index: auto;
}

.cpDsColumnsScrim,
.cpDsFilterScrim {
  z-index: 1290;
}

.cpDsColumnsMenu {
  z-index: 1300;
  width: 270px;
}

.cpDsColumnsMenu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cpDsColumnsMenu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font: inherit;
  font-size: 12px;
  font-weight: 750;
  text-transform: none;
  cursor: pointer;
}

.cpDsFilterDrawer {
  z-index: 1300;
  width: min(420px, 100vw);
  max-width: none;
}

.cpDsFilterDrawer > footer button.isApply:hover,
.cpDsFilterDrawer > footer button.isApply:focus-visible {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}

.eClubProgrammeForm {
  width: min(760px, calc(100vw - 48px));
  padding: 0;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.eCpfCard {
  width: 100%;
  max-width: none;
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
}

.eCpfHeader,
.eCpfFooter {
  background: var(--surface-card, #fff);
  border-color: var(--border-subtle, #e2e8f0);
}

.eCpfTitle {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-weight: 800;
}

.eCpfLabel {
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
}

.eCpfInputWrap {
  border-color: var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
}

.eCpfInputWrap:focus-within {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.eCpfFooter .btn {
  min-height: 40px;
  padding: 0 15px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
  font-weight: 700;
}

.eCpfFooter .btn-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.eCpfFooter .btn-primary:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}

@media (max-width: 1120px) {
  .cpDsHeader {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .cpDsToolbar {
    width: 100%;
    flex-basis: 100%;
  }
}

@media (max-width: 720px) {
  .cpDsPage {
    padding: 0 0 20px;
  }

  .cpDsHeader {
    width: calc(100% + 24px);
    margin: -20px 0 14px -12px;
    padding: 14px 16px;
  }

  .cpDsHeader,
  .cpDsToolbar,
  .cpDsFooter {
    align-items: stretch;
    flex-direction: column;
  }

  .cpDsHeaderTitle,
  .cpDsSearch,
  .cpDsFilterControl,
  .cpDsColumnsControl,
  .cpDsBtnPrimary {
    width: 100%;
    min-width: 0;
  }

  .cpDsBtnPrimary {
    margin-left: 0;
  }

  .cpDsPaginationSummary {
    margin-right: 0;
    text-align: center;
  }

  .cpDsFilterDrawer {
    width: 100%;
  }
}

/* Activity programme create / edit page. */
.cpEditorPage {
  min-height: calc(100vh - 68px);
  padding: 0 0 40px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpEditorPageHeader {
  box-sizing: border-box;
  display: flex;
  width: calc(100% + 48px);
  min-height: 84px;
  align-items: center;
  gap: 18px;
  margin: -20px 0 24px -24px;
  padding: 14px 72px 14px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.cpEditorPageHeader > button {
  display: inline-flex;
  min-height: 38px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font: 700 13px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.cpEditorPageHeader > button:hover {
  color: var(--blue-700, #155d8c);
  text-decoration: underline;
}

.cpEditorPageHeader > button > span {
  font-size: 22px;
  font-weight: 500;
  line-height: 1;
}

.cpEditorPageHeader > i {
  width: 1px;
  height: 42px;
  flex: 0 0 1px;
  background: var(--border-subtle, #e2e8f0);
}

.cpEditorPageHeader > div {
  min-width: 0;
}

.cpEditorPageHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: -0.02em;
}

.cpEditorPageHeader p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.cpEditorStatus {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  margin-left: auto;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.cpEditorStatus.is-active {
  background: #eaf7ed;
  color: #217a3a;
}

.cpEditorStatus.is-archived {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.cpEditorPageBody {
  width: min(1040px, 100%);
  margin: 0;
}

.cpEditorForm {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 16px;
}

.cpEditorAlert {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 13px 15px;
  border: 1px solid #b9d8eb;
  border-radius: 10px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 13px;
}

.cpEditorAlert strong {
  font-size: 13px;
  font-weight: 800;
}

.cpEditorAlert.isDanger {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.cpEditorSection {
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.cpEditorSection > header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 15px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.cpEditorSection > header > span {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
  font-weight: 800;
}

.cpEditorSection h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 17px;
  font-weight: 800;
  line-height: 1.25;
}

.cpEditorSection header p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
}

.cpEditorGrid,
.cpEditorAudience {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  padding: 22px;
}

.cpEditorField {
  min-width: 0;
}

.cpEditorFieldWide {
  grid-column: 1 / -1;
}

.cpEditorField > label,
.cpEditorLabelRow > label {
  display: block;
  margin: 0 0 7px;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 750;
  line-height: 1.35;
}

.cpEditorField > label > span,
.cpEditorLabelRow > label > span {
  color: #be123c;
}

.cpEditorField input:not([type='checkbox']):not([type='radio']),
.cpEditorField textarea,
.cpEditorField select,
.cpEditorField .form-control {
  box-sizing: border-box;
  width: 100%;
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1) !important;
  border-radius: var(--radius-md, 8px) !important;
  outline: 0;
  background: var(--surface-card, #fff) !important;
  box-shadow: none !important;
  color: var(--text-strong, #0f172a) !important;
  font: 400 14px var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpEditorField textarea {
  min-height: 96px;
  padding-top: 10px;
  padding-bottom: 10px;
  resize: vertical;
}

.cpEditorField input::placeholder,
.cpEditorField textarea::placeholder {
  color: var(--text-subtle, #94a3b8);
}

.cpEditorField input:focus,
.cpEditorField textarea:focus,
.cpEditorField select:focus,
.cpEditorField .form-control:focus {
  border-color: var(--border-brand, #6fb1df) !important;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18)) !important;
}

.cpEditorField .isInvalid,
.cpEditorField .is-invalid {
  border-color: #e11d48 !important;
}

.cpEditorError {
  margin-top: 7px;
  color: #be123c;
  font-size: 12px;
  font-weight: 650;
}

.cpEditorHint {
  margin: 8px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.cpEditorChoiceCards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.cpEditorChoiceCardsThree {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cpEditorChoiceCard {
  display: flex;
  min-height: 78px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  padding: 12px 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  text-align: left;
  cursor: pointer;
}

.cpEditorChoiceCard strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 750;
}

.cpEditorChoiceCard span {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.35;
}

.cpEditorChoiceCard:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
}

.cpEditorChoiceCard.isSelected {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  box-shadow: inset 3px 0 0 var(--action-primary, #227ebd);
}

.cpEditorChoiceCard.isSelected strong {
  color: var(--blue-700, #155d8c);
}

.cpEditorChoiceCard:disabled,
.cpEditorChip:disabled,
.cpEditorSwitchRow:disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.cpEditorChips {
  display: flex;
  min-height: 36px;
  align-items: center;
  gap: 8px;
}

.cpEditorChipsWrap {
  flex-wrap: wrap;
}

.cpEditorChip {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font: 650 12px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.cpEditorChip:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.cpEditorChip.isSelected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpEditorLabelRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.cpEditorTextAction {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font: 700 12px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.cpEditorTextAction:disabled {
  color: var(--text-subtle, #94a3b8);
  cursor: not-allowed;
}

.cpEditorAudience.isDisabled {
  background: var(--slate-25, #fafbfc);
}

.cpEditorSwitchRow {
  display: flex;
  width: 100%;
  min-height: 64px;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--slate-25, #fafbfc);
  color: var(--text-body, #334155);
  text-align: left;
  cursor: pointer;
}

.cpEditorSwitch {
  position: relative;
  width: 38px;
  height: 22px;
  flex: 0 0 38px;
  border-radius: 999px;
  background: var(--border-default, #cbd5e1);
  transition: background 140ms ease;
}

.cpEditorSwitch i {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.24);
  transition: transform 140ms ease;
}

.cpEditorSwitchRow.isOn {
  border-color: #b9d8eb;
  background: var(--blue-50, #eef6fc);
}

.cpEditorSwitchRow.isOn .cpEditorSwitch {
  background: var(--action-primary, #227ebd);
}

.cpEditorSwitchRow.isOn .cpEditorSwitch i {
  transform: translateX(16px);
}

.cpEditorSwitchRow > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.cpEditorSwitchRow strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 750;
}

.cpEditorSwitchRow small {
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.cpEditorField .eCpfField,
.cpEditorField .eCpfTwoCols {
  margin: 0;
}

.cpEditorField .eCpfTwoCols {
  gap: 14px;
}

.cpEditorField .eCpfLabelSmall {
  margin-bottom: 7px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.cpEditorField .eCpfError {
  max-width: none;
  margin-top: 7px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #be123c;
  font-size: 12px;
  font-weight: 650;
}

.cpEditorDateTimePicker {
  width: 100%;
}

.cpEditorDateTimePicker .sit-dp__label {
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 750;
  line-height: 1.35;
}

.cpEditorDateTimePicker .sit-dp__trigger {
  box-sizing: border-box;
  min-height: 42px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: 400 14px var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpEditorDateTimePicker .sit-dp__trigger:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
}

.cpEditorDateTimePicker .sit-dp__pop--centered {
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  overflow: auto;
}

.cpEditorActions {
  position: sticky;
  z-index: 10;
  bottom: 0;
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 13px 18px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 -8px 28px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(8px);
}

.cpEditorActions > span {
  margin-right: auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-weight: 650;
}

.cpEditorActions > span.isDirty {
  color: var(--amber-700, #a85c07);
}

.cpEditorButton {
  display: inline-flex;
  min-width: 100px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 8px);
  font: 700 13px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.cpEditorButton.isSecondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.cpEditorButton.isPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpEditorButton.isPrimary:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}

.cpEditorButton:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  cursor: not-allowed;
}

@media (max-width: 820px) {
  .cpEditorPageHeader {
    width: calc(100% + 24px);
    align-items: flex-start;
    flex-wrap: wrap;
    margin: -20px 0 18px -12px;
    padding: 14px 16px;
  }

  .cpEditorPageHeader > div {
    flex: 1 1 calc(100% - 190px);
  }

  .cpEditorStatus {
    margin-left: 0;
  }

  .cpEditorGrid,
  .cpEditorAudience {
    grid-template-columns: 1fr;
    padding: 18px;
  }

  .cpEditorFieldWide {
    grid-column: auto;
  }

  .cpEditorChoiceCards,
  .cpEditorChoiceCardsThree,
  .cpEditorField .eCpfTwoCols {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .cpEditorPageHeader > i {
    display: none;
  }

  .cpEditorPageHeader > button,
  .cpEditorPageHeader > div {
    flex: 1 1 100%;
  }

  .cpEditorSection > header {
    padding: 16px;
  }

  .cpEditorActions {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .cpEditorActions > span {
    flex: 1 1 100%;
  }

  .cpEditorButton {
    flex: 1 1 0;
  }
}

/* Manage clubs — current design-system alignment. */
.pcProgrammeClubsPage {
  min-height: calc(100vh - 68px);
  overflow: visible;
  padding: 0 0 40px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.pcProgrammeClubsHeader {
  box-sizing: border-box;
  width: calc(100% + 48px);
  min-height: 106px;
  margin: -20px 0 0 -24px;
  padding: 17px 72px 18px 28px;
  border-color: var(--border-subtle, #e2e8f0);
}

.pcProgrammeClubsTitle {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 23px;
  line-height: 1.18;
  letter-spacing: -0.01em;
}

.pcProgrammeClubsSubtitle {
  margin-top: 4px;
  color: var(--text-muted, #64748b);
  font-size: 13.5px;
}

.pcBackLink {
  margin-bottom: 8px;
  color: var(--text-link, #1a6da3);
  font-size: 13px;
  font-weight: 700;
}

.pcBackLink:hover {
  color: var(--blue-700, #155d8c);
  text-decoration: underline;
}

.pcProgrammeClubsBody {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 18px 24px 60px 0;
}

.pcToolbar,
.pcSelectionBar,
.pcCard {
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 12px;
}

.pcToolbar {
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
}

.pcToolbar--inline {
  min-height: 68px;
  flex-wrap: wrap;
  gap: 8px;
  padding: 13px 14px;
}

.pcToolbarTitle {
  color: var(--text-strong, #0f172a);
  font-size: 15px;
}

.pcToolbarCountChip,
.pcButtonBadge {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.pcSearchBox {
  box-sizing: border-box;
  height: 40px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
}

.pcSearchBox:focus-within {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.pcSearchBox--inline {
  max-width: 420px;
}

.pcSearchClear {
  display: inline-flex;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font: inherit;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
}

.pcSearchClear:hover {
  background: var(--border-subtle, #e2e8f0);
  color: var(--text-strong, #0f172a);
}

.pcButton {
  min-height: 40px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
  font-weight: 700;
}

.pcButton--primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

.pcButton--primary:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}

.pcButton--secondary {
  border-color: var(--border-default, #cbd5e1);
  color: var(--text-body, #334155);
}

.pcButton--secondary:hover:not(:disabled),
.pcButton--secondary.isActive {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pcBadge--warning {
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.pcManageFilterControl {
  height: 40px;
  align-self: auto;
}

.pcManageFilterControl .cpDsFilterScrim {
  z-index: 1390;
}

.pcManageFilterDrawer {
  z-index: 1400;
}

.pcManageFilterControl > .pcButton {
  height: 40px;
}

.pcManageFilterDrawer .cpDsFilterFields {
  gap: 26px;
}

.pcManageFilterDrawer .cpDsFilterChips {
  flex-wrap: wrap;
}

.pcColumnsMenuWrap {
  z-index: auto;
}

.pcColumnsMenuWrap.isOpen {
  z-index: 1300;
}

.pcColumnsScrim {
  position: fixed;
  z-index: 1290;
  inset: 0;
  padding: 0;
  border: 0;
  background: transparent;
}

.pcColumnsMenu {
  z-index: 1300;
  top: calc(100% + 8px);
  width: 270px;
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 10px;
}

.pcColumnsMenuWrap.isOpen > .pcButton {
  position: relative;
  z-index: 1300;
}

.pcColumnsMenuWrap.isOpen > .pcColumnsMenu {
  position: absolute;
  z-index: 1300;
}

.pcManageActiveFilters {
  display: flex;
  min-height: 42px;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  padding: 8px 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
}

.pcManageActiveFilters > button:not(.pcManageClearFilters) {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 8px;
  padding: 4px 9px 4px 11px;
  border: 1px solid #b9d8eb;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font: 650 12px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.pcManageActiveFilters > button:not(.pcManageClearFilters) > span:last-child {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--text-muted, #64748b);
  font-size: 15px;
  line-height: 1;
}

.pcManageActiveFilters > button:not(.pcManageClearFilters):hover {
  border-color: var(--action-primary, #227ebd);
}

.pcManageClearFilters {
  padding: 4px 7px;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font: 700 12px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.pcCard--flush {
  overflow: visible;
  border: 0;
  background: transparent;
}

.pcCard--flush .cpDataTableShell {
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
}

.pcDataTable th {
  height: 42px;
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
  color: var(--text-muted, #64748b);
  font-size: 11px;
}

.pcDataTable td {
  box-sizing: border-box;
  height: 56px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-color: var(--border-subtle, #e2e8f0);
}

.pcDataTableRow:hover,
.pcDataTableRow--selected {
  background: var(--surface-sunken, #f1f5f9);
}

.pcCheckbox {
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.pcStatusDisplay {
  display: inline-flex;
}

.pcStatusDisplay.isSaving {
  opacity: 0.7;
}

.pcRowActionsButton {
  opacity: 0;
  transform: translateX(3px);
  transition: opacity 120ms ease, transform 120ms ease, border-color 120ms ease, background 120ms ease;
}

.pcDataTableRow:hover .pcRowActionsButton,
.pcRowActionsButton.isActive,
.pcRowActionsButton:focus-visible {
  opacity: 1;
  transform: translateX(0);
}

.pcRowActionsButton:hover,
.pcRowActionsButton.isActive {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pcRowActionMenu {
  position: fixed;
  z-index: 2147483000;
  width: 228px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.pcRowActionMenu > button {
  display: flex;
  width: 100%;
  min-height: 36px;
  align-items: center;
  gap: 10px;
  padding: 7px 9px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-body, #334155);
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  text-align: left;
  cursor: pointer;
}

.pcRowActionMenu > button:hover:not(:disabled) {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.pcRowActionMenu > button.isDanger {
  color: #be123c;
}

.pcRowActionMenu > button.isDanger:hover:not(:disabled) {
  background: #fff1f2;
}

.pcRowActionMenu > button:disabled {
  color: var(--text-subtle, #94a3b8);
  cursor: not-allowed;
}

.pcRowActionMenuDivider {
  margin: 5px 3px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.pcPagination--pages {
  min-height: 42px;
  margin-top: 0;
}

.pcPaginationSummary {
  margin-right: auto;
}

@media (max-width: 900px) {
  .pcProgrammeClubsHeader {
    width: calc(100% + 24px);
    margin: -20px 0 0 -12px;
    padding: 15px 16px 17px;
  }

  .pcProgrammeClubsBody {
    padding: 14px 12px 48px 0;
  }

  .pcToolbarTitleWrap {
    flex-basis: 100%;
  }

  .pcSearchBox--inline {
    max-width: none;
  }
}

@media (max-width: 620px) {
  .pcProgrammeClubsHeaderMain {
    align-items: stretch;
    flex-direction: column;
  }

  .pcProgrammeClubsHeaderMain > .pcButton {
    align-self: flex-start;
  }

  .pcToolbar--inline {
    align-items: stretch;
  }

  .pcSearchBox--inline {
    flex-basis: 100%;
  }

  .pcManageFilterControl,
  .pcColumnsMenuWrap {
    flex: 1 1 0;
  }

  .pcManageFilterControl > .pcButton,
  .pcColumnsMenuWrap > .pcButton {
    width: 100%;
  }

  .pcSelectionBar,
  .pcSelectionActions,
  .pcPagination {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .pcPaginationSummary {
    flex: 1 1 100%;
  }
}

.pcRemoveClubsModal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 14px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);
}

.pcRemoveClubsModal .modal-header {
  padding: 17px 20px;
  border-color: var(--border-subtle, #e2e8f0);
}

.pcRemoveClubsModal .modal-body {
  padding: 18px 20px 16px;
}

.pcRemoveClubsContent {
  display: flex;
  align-items: flex-start;
  gap: 13px;
}

.pcRemoveClubsIcon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #fff1f2;
  color: #be123c;
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.pcRemoveClubsContent p {
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 13.5px;
  line-height: 1.5;
}

.pcRemoveClubsContent .pcRemoveClubsNote {
  margin-top: 8px;
  color: var(--amber-700, #a85c07);
}

.pcRemoveClubsContent .pcRemoveClubsWarning {
  margin-top: 8px;
  color: var(--text-muted, #64748b);
}

.pcRemoveClubsActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.pcRemoveClubsActions .sit-btn {
  min-width: 96px;
  min-height: 38px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
  font-weight: 700;
}

.pcRemoveClubsConfirm,
.pcRemoveClubsConfirm:hover:not(:disabled),
.pcRemoveClubsConfirm:focus-visible {
  border-color: #be123c;
  background: #be123c;
  color: #fff;
}

/* Programme booking form fields — ProgrammeFields.dc.html */
.cpProgrammeFieldsPage {
  min-height: calc(100vh - 68px);
  padding: 0 0 40px;
  overflow: visible;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpProgrammeFieldsPageHeader {
  box-sizing: border-box;
  width: calc(100% + 48px);
  min-height: 106px;
  margin: -20px 0 0 -24px;
  padding: 17px 72px 17px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.cpProgrammeFieldsBack {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0 0 9px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-600, #1a6da3);
  font: 700 13px var(--font-body, 'Public Sans', system-ui, sans-serif);
  cursor: pointer;
}

.cpProgrammeFieldsBack svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.cpProgrammeFieldsBack:hover,
.cpProgrammeFieldsBack:focus-visible {
  color: var(--blue-700, #155d8c);
  text-decoration: underline;
}

.cpProgrammeFieldsHeading {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.cpProgrammeFieldsHeading h1 {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 23px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeFieldsStatus {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 800;
  line-height: 1;
}

.cpProgrammeFieldsStatus.isDraft {
  border: 1px solid var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.cpProgrammeFieldsStatus.isActive {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.cpProgrammeFieldsContext {
  display: inline-flex;
  align-items: center;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 600;
}

.cpProgrammeFieldsContext::before {
  margin-right: 8px;
  color: var(--text-subtle, #94a3b8);
  content: '·';
}

.cpProgrammeFieldsPageBody {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 18px 24px 60px 0;
}

.cpProgrammeFieldsLoadError {
  width: min(720px, 100%);
  padding: 16px 18px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fff7f7;
  color: #991b1b;
  font-size: 13.5px;
  line-height: 1.45;
}

.cpProgrammeFieldsEditor {
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
}

.cpProgrammeFieldsSummaryBar {
  display: flex;
  min-height: 60px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px 10px 16px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
}

.cpProgrammeFieldsMetrics,
.cpProgrammeFieldsSummaryActions {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.cpProgrammeFieldsMetrics > span:not(.cpProgrammeFieldsSource) {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  gap: 4px;
  padding: 4px 9px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  font-weight: 650;
  white-space: nowrap;
}

.cpProgrammeFieldsMetrics strong {
  color: var(--text-strong, #0f172a);
  font-weight: 800;
}

.cpProgrammeFieldsSource {
  display: inline-block;
  max-width: 320px;
  overflow: hidden;
  padding-left: 4px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeFieldsSource strong {
  color: var(--text-body, #334155);
}

.cpProgrammeFieldsSummaryActions {
  flex: 0 0 auto;
  justify-content: flex-end;
}

.cpProgrammeFieldsUnsaved {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  padding: 4px 9px;
  border: 1px solid var(--amber-100, #ffe9c2);
  border-radius: 999px;
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
  font-size: 11.5px;
  font-weight: 800;
  white-space: nowrap;
}

.cpProgrammeFieldsButton {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 13px;
  border: 1px solid transparent;
  border-radius: 8px;
  font: 750 12.5px var(--font-body, 'Public Sans', system-ui, sans-serif);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 140ms ease, background 140ms ease, color 140ms ease, box-shadow 140ms ease;
}

.cpProgrammeFieldsButton svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.cpProgrammeFieldsButton.isSecondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.cpProgrammeFieldsButton.isSecondary:hover:not(:disabled),
.cpProgrammeFieldsButton.isSecondary:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.cpProgrammeFieldsButton.isPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpProgrammeFieldsButton.isPrimary:hover:not(:disabled),
.cpProgrammeFieldsButton.isPrimary:focus-visible {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
}

.cpProgrammeFieldsButton:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  cursor: not-allowed;
  box-shadow: none;
}

.cpProgrammeFieldsError {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 13px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fff7f7;
  color: #991b1b;
  font-size: 13px;
  line-height: 1.45;
}

.cpProgrammeFieldsError > span {
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fee2e2;
  font-size: 12px;
  font-weight: 900;
}

.cpProgrammeFieldsError p {
  margin: 0;
}

.cpProgrammeFieldsBuilder {
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
}

.cpProgrammeFieldsBuilder .SendTimeFormEditor {
  min-width: 0;
  margin: 0;
}

.cpProgrammeFieldsBuilder .SendTimeFormEditor__header {
  margin: 0 0 12px;
  padding: 8px 10px;
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.cpProgrammeFieldsBuilder .SendTimeFormEditor__templateSelect {
  min-width: 230px;
  max-width: 360px;
  border-color: var(--border-subtle, #e2e8f0);
  background-color: #fff;
}

.cpProgrammeFieldsBuilder .FormBuilderV2:not(.FormBuilderV2--compact) {
  height: min(700px, calc(100vh - 292px));
  min-height: 520px;
}

.cpProgrammeFieldsSetup {
  box-sizing: border-box;
  width: min(1040px, 100%);
  margin: 0;
  padding: 24px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
}

.cpProgrammeFieldsSetupHeading,
.cpProgrammeFieldsTemplateHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.cpProgrammeFieldsEyebrow {
  display: block;
  margin-bottom: 5px;
  color: var(--blue-700, #155d8c);
  font-size: 10.5px;
  font-weight: 850;
  letter-spacing: 0.065em;
  text-transform: uppercase;
}

.cpProgrammeFieldsSetupHeading h2,
.cpProgrammeFieldsTemplateHeader h3 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-weight: 800;
}

.cpProgrammeFieldsSetupHeading h2 {
  font-size: 22px;
  line-height: 1.25;
}

.cpProgrammeFieldsTemplateHeader h3 {
  font-size: 16px;
  line-height: 1.3;
}

.cpProgrammeFieldsSetupHeading p,
.cpProgrammeFieldsTemplateHeader p {
  margin: 5px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.45;
}

.cpProgrammeFieldsBlankCard {
  display: flex;
  width: 100%;
  min-height: 88px;
  align-items: center;
  gap: 14px;
  margin: 22px 0 25px;
  padding: 14px 16px;
  border: 1px dashed var(--border-default, #cbd5e1);
  border-radius: 11px;
  background: var(--slate-25, #fafbfc);
  color: var(--text-body, #334155);
  text-align: left;
  cursor: pointer;
  transition: border-color 140ms ease, background 140ms ease, box-shadow 140ms ease;
}

.cpProgrammeFieldsBlankCard:hover,
.cpProgrammeFieldsBlankCard:focus-visible {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.1);
}

.cpProgrammeFieldsBlankIcon,
.cpProgrammeFieldsTemplateIcon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--blue-50, #eef6fc);
  color: var(--action-primary, #227ebd);
}

.cpProgrammeFieldsBlankIcon svg,
.cpProgrammeFieldsTemplateIcon svg,
.cpProgrammeFieldsCardArrow {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.cpProgrammeFieldsBlankCard > span:nth-child(2) {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  gap: 4px;
}

.cpProgrammeFieldsBlankCard strong {
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 800;
}

.cpProgrammeFieldsBlankCard small {
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  line-height: 1.4;
}

.cpProgrammeFieldsCardArrow {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: var(--text-subtle, #94a3b8);
}

.cpProgrammeFieldsTemplateHeader {
  align-items: flex-end;
  padding-top: 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.cpProgrammeFieldsTemplateSearch {
  position: relative;
  display: flex;
  width: min(320px, 100%);
  min-height: 38px;
  align-items: center;
  margin: 0;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-subtle, #94a3b8);
}

.cpProgrammeFieldsTemplateSearch:focus-within {
  border-color: var(--action-primary, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.1);
}

.cpProgrammeFieldsTemplateSearch > svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  margin-left: 11px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.cpProgrammeFieldsTemplateSearch input {
  width: 100%;
  min-width: 0;
  height: 36px;
  padding: 0 34px 0 8px;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #0f172a);
  font: 500 13px var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpProgrammeFieldsTemplateSearch > button {
  position: absolute;
  top: 50%;
  right: 7px;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 19px;
  line-height: 1;
  transform: translateY(-50%);
  cursor: pointer;
}

.cpProgrammeFieldsTemplateSearch > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.cpProgrammeFieldsTemplateGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.cpProgrammeFieldsTemplateCard {
  display: flex;
  min-height: 178px;
  flex-direction: column;
  align-items: stretch;
  padding: 15px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 11px;
  background: #fff;
  color: var(--text-body, #334155);
  text-align: left;
  cursor: pointer;
  transition: border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease;
}

.cpProgrammeFieldsTemplateCard:hover:not(:disabled),
.cpProgrammeFieldsTemplateCard:focus-visible {
  border-color: var(--action-primary, #227ebd);
  box-shadow: 0 7px 20px rgba(15, 23, 42, 0.09);
  transform: translateY(-1px);
}

.cpProgrammeFieldsTemplateCard:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.cpProgrammeFieldsTemplateCardTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.cpProgrammeFieldsDefaultTag {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 10.5px;
  font-weight: 800;
}

.cpProgrammeFieldsTemplateCard > strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeFieldsTemplateCard > small {
  display: -webkit-box;
  min-height: 35px;
  margin-top: 4px;
  overflow: hidden;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.cpProgrammeFieldsTemplateMeta {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: auto;
  padding-top: 12px;
}

.cpProgrammeFieldsTemplateMeta span {
  display: inline-flex;
  min-height: 23px;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 700;
}

.cpProgrammeFieldsNoTemplates {
  margin-top: 16px;
  padding: 25px 18px;
  border: 1px dashed var(--border-default, #cbd5e1);
  border-radius: 10px;
  background: var(--slate-25, #fafbfc);
  color: var(--text-muted, #64748b);
  font-size: 13px;
  text-align: center;
}

.cpProgrammeFieldsReadOnly {
  padding: 16px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: #fff;
}

.cpProgrammeFieldsLockedBanner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--amber-100, #ffe9c2);
  border-radius: 9px;
  background: var(--amber-50, #fff6e6);
}

.cpProgrammeFieldsLockedBanner > span {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--amber-100, #ffe9c2);
  color: var(--amber-700, #a85c07);
}

.cpProgrammeFieldsLockedBanner svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.cpProgrammeFieldsLockedBanner strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 800;
}

.cpProgrammeFieldsLockedBanner p {
  margin: 3px 0 0;
  color: var(--amber-700, #a85c07);
  font-size: 12.5px;
  line-height: 1.45;
}

.cpProgrammeFieldsReadOnlyList {
  margin-top: 14px;
}

@media (max-width: 1180px) {
  .cpProgrammeFieldsSummaryBar {
    align-items: flex-start;
    flex-direction: column;
  }

  .cpProgrammeFieldsSummaryActions {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 850px) {
  .cpProgrammeFieldsBuilder .FormBuilderV2:not(.FormBuilderV2--compact) {
    height: auto;
    min-height: 0;
  }

  .cpProgrammeFieldsBuilder .SendTimeFormEditor__header,
  .cpProgrammeFieldsBuilder .SendTimeFormEditor__titleActions {
    align-items: stretch;
    flex-direction: column;
  }

  .cpProgrammeFieldsBuilder .SendTimeFormEditor__actions {
    justify-content: flex-start;
  }

  .cpProgrammeFieldsBuilder .SendTimeFormEditor__templateSelect {
    width: 100%;
    max-width: none;
  }
}

@media (max-width: 720px) {
  .cpProgrammeFieldsPageHeader {
    width: calc(100% + 24px);
    margin-left: -12px;
    padding-right: 20px;
    padding-left: 16px;
  }

  .cpProgrammeFieldsPageBody {
    padding-right: 12px;
  }

  .cpProgrammeFieldsSetup {
    padding: 18px;
  }

  .cpProgrammeFieldsSetupHeading,
  .cpProgrammeFieldsTemplateHeader {
    align-items: stretch;
    flex-direction: column;
  }

  .cpProgrammeFieldsTemplateSearch {
    width: 100%;
  }

  .cpProgrammeFieldsTemplateGrid {
    grid-template-columns: 1fr;
  }

  .cpProgrammeFieldsSource {
    max-width: 100%;
    flex-basis: 100%;
    padding: 3px 0 0;
  }
}

@media (max-width: 560px) {
  .cpProgrammeFieldsHeading h1 {
    max-width: 100%;
    flex-basis: 100%;
  }

  .cpProgrammeFieldsContext::before {
    display: none;
  }

  .cpProgrammeFieldsSummaryActions,
  .cpProgrammeFieldsSummaryActions .cpProgrammeFieldsButton {
    width: 100%;
  }

  .cpProgrammeFieldsSummaryActions .cpProgrammeFieldsUnsaved {
    width: auto;
  }

  .cpProgrammeFieldsMetrics {
    align-items: flex-start;
  }

  .cpProgrammeFieldsBuilder {
    padding: 8px;
  }
}

/* Booking manager — ProgrammeBookings.dc.html alignment. */
.pbProgrammeBookingsPage {
  box-sizing: border-box;
  width: calc(100% + 48px);
  min-height: calc(100vh - 68px);
  margin: -20px 0 0 -24px;
  padding: 0 0 44px;
  overflow: visible;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.pbProgrammeBookingsPage .pbPageHeader {
  box-sizing: border-box;
  min-height: 112px;
  align-items: center;
  padding: 17px 72px 17px 28px;
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.pbPageHeaderMain {
  min-width: 0;
}

.pbProgrammeBookingsPage .pbBackLink {
  gap: 5px;
  margin-bottom: 8px;
  color: var(--blue-600, #1a6da3);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 700;
}

.pbProgrammeBookingsPage .pbBackLink svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.pbProgrammeBookingsPage .pbBackLink:hover,
.pbProgrammeBookingsPage .pbBackLink:focus-visible {
  color: var(--blue-700, #155d8c);
  text-decoration: underline;
}

.pbProgrammeBookingsPage .pbPageTitleRow {
  min-width: 0;
  gap: 8px;
}

.pbProgrammeBookingsPage .pbPageTitleRow h1 {
  min-width: 0;
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 23px;
  line-height: 1.2;
  letter-spacing: -0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pbProgrammeBookingsPage .pbHeaderStatus,
.pbHeaderMode {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  gap: 6px;
  padding: 3px 9px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.pbProgrammeBookingsPage .pbHeaderStatus > span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.pbProgrammeBookingsPage .pbHeaderStatus.isActive {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.pbProgrammeBookingsPage .pbHeaderStatus.isDraft {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.pbProgrammeBookingsPage .pbHeaderStatus.isCompleted {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.pbHeaderMode {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
}

.pbHeaderMode svg {
  width: 13px;
  height: 13px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.pbProgrammeBookingsPage .pbPageMeta {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.4;
}

.pbPageHeaderActions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  align-self: center;
}

.pbProgrammeBookingsPage .pbHeaderPrimaryButton {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 750;
  transition: border-color 140ms ease, background 140ms ease, color 140ms ease;
}

.pbProgrammeBookingsPage .pbHeaderPrimaryButton svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.pbProgrammeBookingsPage .pbHeaderPrimaryButton:hover:not(:disabled),
.pbProgrammeBookingsPage .pbHeaderPrimaryButton:focus-visible {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
}

.pbProgrammeBookingsPage .pbHeaderPrimaryButton:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
}

.pbProgrammeBookingsPage .pbBoardPage {
  min-height: calc(100vh - 180px);
  background: var(--surface-page, #f8fafc);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.pbProgrammeBookingsPage .pbControlBar {
  top: 0;
  padding: 11px 72px 11px 28px;
  border-color: var(--border-subtle, #e2e8f0);
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.04);
  backdrop-filter: blur(8px);
}

.pbProgrammeBookingsPage .pbControlBarInner {
  min-height: 36px;
  gap: 8px;
}

.pbProgrammeBookingsPage .cpBookingsPendingGroup {
  gap: 7px;
}

.pbProgrammeBookingsPage .cpBookingsPendingBadge {
  min-height: 30px;
  padding: 4px 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--slate-25, #fafbfc);
  color: var(--text-body, #334155);
  font-size: 11.5px;
  font-weight: 650;
}

.pbProgrammeBookingsPage .cpBookingsPendingBadge--strong {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.pbProgrammeBookingsPage .cpBookingsPendingBadge b {
  color: currentColor;
  font-size: 12px;
  font-weight: 850;
}

.pbBoardUpdating {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 10.5px;
  font-weight: 800;
}

.pbProgrammeBookingsPage .pbControlDivider {
  background: var(--border-subtle, #e2e8f0);
}

.pbProgrammeBookingsPage .pbControlLabel {
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 850;
  letter-spacing: 0.055em;
}

.pbProgrammeBookingsPage .pbMenuButton,
.pbProgrammeBookingsPage .pbConfirmDayButton,
.pbProgrammeBookingsPage .pbConfirmProgrammeButton {
  min-height: 34px;
  height: 34px;
  border-radius: 8px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12px;
  font-weight: 750;
}

.pbProgrammeBookingsPage .pbMenuButton {
  gap: 7px;
  border-color: var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-body, #334155);
}

.pbProgrammeBookingsPage .pbMenuButton svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.pbProgrammeBookingsPage .pbMenuButton:hover:not(:disabled),
.pbProgrammeBookingsPage .pbMenuButton:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pbProgrammeBookingsPage .pbMenuButton:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  opacity: 1;
}

.pbProgrammeBookingsPage .pbMenuDropdown {
  z-index: 80;
  top: calc(100% + 7px);
  min-width: 220px;
  padding: 6px;
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);
}

.pbProgrammeBookingsPage .pbMenuItem {
  min-height: 36px;
  padding: 8px 10px;
  border-radius: 7px;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 650;
}

.pbProgrammeBookingsPage .pbMenuItem:hover:not(:disabled) {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.pbProgrammeBookingsPage .pbConfirmDayButton {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.pbProgrammeBookingsPage .pbConfirmDayButton:hover:not(:disabled),
.pbProgrammeBookingsPage .pbConfirmDayButton:focus-visible {
  border-color: #86efac;
  background: #dcfce7;
  color: #166534;
}

.pbProgrammeBookingsPage .pbConfirmProgrammeButton {
  border: 1px solid var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.pbProgrammeBookingsPage .pbConfirmProgrammeButton:hover:not(:disabled),
.pbProgrammeBookingsPage .pbConfirmProgrammeButton:focus-visible {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
}

.pbProgrammeBookingsPage .pbConfirmDayButton:disabled,
.pbProgrammeBookingsPage .pbConfirmProgrammeButton:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
}

.pbProgrammeBookingsPage .pbControlHint {
  color: var(--text-subtle, #94a3b8);
  font-size: 11.5px;
  line-height: 1.35;
}

.pbProgrammeBookingsPage .pbDayTabs {
  gap: 7px;
  padding: 14px 72px 5px 28px;
}

.pbProgrammeBookingsPage .pbDayTab {
  min-height: 38px;
  height: 38px;
  padding: 0 13px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: #fff;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 750;
}

.pbProgrammeBookingsPage .pbDayTab:hover:not(.pbDayTab--active),
.pbProgrammeBookingsPage .pbDayTab:focus-visible:not(.pbDayTab--active) {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pbProgrammeBookingsPage .pbDayTab--active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.pbProgrammeBookingsPage .pbDayTabCount,
.pbProgrammeBookingsPage .pbClubColumnCount {
  min-width: 20px;
  height: 20px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 800;
}

.pbProgrammeBookingsPage .pbDayTab--active .pbDayTabCount {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.pbProgrammeBookingsPage .pbInfoBanner,
.pbProgrammeBookingsPage .pbLockedBanner,
.pbProgrammeBookingsPage .pbErrorBanner {
  margin-right: 72px;
  margin-left: 28px;
  border-radius: 9px;
  font-size: 12px;
}

.pbProgrammeBookingsPage .pbInfoBanner {
  border-color: #cfe4f5;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pbProgrammeBookingsPage .pbTopScroll {
  height: 16px;
  margin-right: 72px;
  margin-left: 28px;
}

.pbProgrammeBookingsPage .pbBoardScroll {
  padding: 12px 72px 28px 28px;
}

.pbProgrammeBookingsPage .pbBoardColumns {
  gap: 12px;
}

.pbProgrammeBookingsPage .pbClubColumn {
  width: 326px;
  flex-basis: 326px;
}

.pbProgrammeBookingsPage .pbClubColumnInner {
  overflow: visible;
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.pbProgrammeBookingsPage .pbClubColumnHeader {
  padding: 13px;
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 12px 12px 0 0;
}

.pbProgrammeBookingsPage .pbClubColumnName {
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 800;
}

.pbProgrammeBookingsPage .pbClubColumnTime {
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}

.pbProgrammeBookingsPage .pbClubColumnTime svg,
.pbProgrammeBookingsPage .pbColumnIconButton svg,
.pbProgrammeBookingsPage .cpIconBtn svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.pbProgrammeBookingsPage .pbColumnIconButton,
.pbProgrammeBookingsPage .cpIconBtn {
  border-color: var(--border-subtle, #e2e8f0);
  background: #fff;
  color: var(--text-muted, #64748b);
}

.pbProgrammeBookingsPage .pbColumnIconButton:hover:not(:disabled),
.pbProgrammeBookingsPage .cpIconBtn:hover:not(:disabled),
.pbProgrammeBookingsPage .pbColumnIconButton:focus-visible,
.pbProgrammeBookingsPage .cpIconBtn:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pbProgrammeBookingsPage .pbClubStatsPanel {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.pbProgrammeBookingsPage .pbClubStat em {
  color: var(--text-subtle, #94a3b8);
  font-size: 9.5px;
  font-weight: 800;
}

.pbProgrammeBookingsPage .pbClubStat b {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
}

.pbProgrammeBookingsPage .pbPendingChip {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
  font-size: 10.5px;
}

.pbProgrammeBookingsPage .pbColumnFillButton,
.pbProgrammeBookingsPage .pbColumnConfirmButton,
.pbProgrammeBookingsPage .pbCardActionButton {
  min-height: 31px;
  border-radius: 7px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 11.5px;
  font-weight: 750;
}

.pbProgrammeBookingsPage .pbColumnFillButton:hover:not(:disabled),
.pbProgrammeBookingsPage .pbColumnFillButton:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pbProgrammeBookingsPage .pbColumnConfirmButton:hover:not(:disabled),
.pbProgrammeBookingsPage .pbColumnConfirmButton:focus-visible {
  border-color: #86efac;
  background: #dcfce7;
  color: #166534;
}

.pbProgrammeBookingsPage .pbClubColumnBody {
  max-height: min(620px, calc(100vh - 365px));
  min-height: 240px;
  padding: 10px;
  border-radius: 0 0 12px 12px;
}

.pbProgrammeBookingsPage .cpBookingsCard {
  padding: 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: #fff;
}

.pbProgrammeBookingsPage .cpBookingsCard--conflict {
  border-color: #fda4af;
  background: #fff7f7;
}

.pbProgrammeBookingsPage .cpBookingsCard--selectedClub {
  border-color: #93c5fd;
  background: #eff6ff;
}

.pbProgrammeBookingsPage .cpBookingsCard--selectedWaiting,
.pbProgrammeBookingsPage .cpBookingsCard--confirmedWaiting {
  border-color: #fde68a;
  background: #fffbeb;
}

.pbProgrammeBookingsPage .cpBookingsCard--confirmedClub {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.pbProgrammeBookingsPage .cpBookingsStudentName {
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
  font-weight: 800;
}

.pbProgrammeBookingsPage .cpBookingsMeta {
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
}

.pbProgrammeBookingsPage .pbBadge {
  min-height: 20px;
  padding: 2px 7px;
  font-size: 10px;
  font-weight: 800;
}

.pbProgrammeBookingsPage .pbCardActionButton--primary:hover:not(:disabled),
.pbProgrammeBookingsPage .pbCardActionButton--primary:focus-visible {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
}

.pbProgrammeBookingsPage .pbEmptyState {
  margin-right: 72px;
  margin-left: 28px;
  padding: 42px 24px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: 12px;
  background: #fff;
  color: var(--text-muted, #64748b);
}

.pbProgrammeBookingsError {
  box-sizing: border-box;
  width: min(720px, calc(100% - 56px));
  margin: 18px 28px;
  padding: 18px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fff7f7;
  color: #991b1b;
}

.pbProgrammeBookingsError strong {
  display: block;
  font-size: 14px;
  font-weight: 800;
}

.pbProgrammeBookingsError p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.45;
}

@media (max-width: 1280px) {
  .pbProgrammeBookingsPage .pbControlHint {
    width: 100%;
    margin-left: 0;
  }
}

@media (max-width: 980px) {
  .pbProgrammeBookingsPage .pbPageHeader {
    align-items: flex-start;
    flex-direction: column;
  }

  .pbPageHeaderActions {
    align-self: flex-start;
  }

  .pbProgrammeBookingsPage .pbControlBarInner {
    align-items: flex-start;
  }

  .pbProgrammeBookingsPage .pbControlDivider {
    display: none;
  }

  .pbProgrammeBookingsPage .pbControlLabel {
    width: 100%;
    margin-top: 3px;
  }
}

@media (max-width: 720px) {
  .pbProgrammeBookingsPage {
    width: calc(100% + 24px);
    margin-left: -12px;
  }

  .pbProgrammeBookingsPage .pbPageHeader,
  .pbProgrammeBookingsPage .pbControlBar,
  .pbProgrammeBookingsPage .pbDayTabs,
  .pbProgrammeBookingsPage .pbBoardScroll {
    padding-right: 16px;
    padding-left: 16px;
  }

  .pbProgrammeBookingsPage .pbInfoBanner,
  .pbProgrammeBookingsPage .pbLockedBanner,
  .pbProgrammeBookingsPage .pbErrorBanner,
  .pbProgrammeBookingsPage .pbTopScroll,
  .pbProgrammeBookingsPage .pbEmptyState {
    margin-right: 16px;
    margin-left: 16px;
  }

  .pbProgrammeBookingsPage .pbPageTitleRow h1 {
    max-width: 100%;
    flex-basis: 100%;
  }

  .pbProgrammeBookingsPage .pbHeaderPrimaryButton {
    width: 100%;
  }

  .pbProgrammeBookingsPage .pbClubColumn {
    width: min(300px, calc(100vw - 54px));
    flex-basis: min(300px, calc(100vw - 54px));
  }

  .pbProgrammeBookingsPage .pbClubColumnBody {
    max-height: none;
  }
}

@media (max-width: 520px) {
  .pbProgrammeBookingsPage .cpBookingsPendingGroup {
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
  }

  .pbProgrammeBookingsPage .pbMenuWrap,
  .pbProgrammeBookingsPage .pbMenuButton,
  .pbProgrammeBookingsPage .pbConfirmDayButton,
  .pbProgrammeBookingsPage .pbConfirmProgrammeButton {
    width: 100%;
  }

  .pbProgrammeBookingsPage .pbMenuDropdown {
    right: auto;
    left: 0;
    width: 100%;
  }
}

.pbBookingModal .modal-content {
  max-height: calc(100vh - 48px);
  overflow: hidden;
  border: 0;
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.pbBookingModal .modal-header {
  min-height: 62px;
  align-items: center;
  padding: 16px 20px;
  border-color: var(--border-subtle, #e2e8f0);
}

.pbBookingModal .modal-title {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.3;
}

.pbBookingModal .modal-header .close {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  color: var(--text-muted, #64748b);
  opacity: 1;
}

.pbBookingModal .modal-header .close:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.pbBookingModal .modal-body {
  min-height: 0;
  padding: 18px 20px 20px;
  overflow-y: auto;
  color: var(--text-body, #334155);
  font-weight: 400;
}

.pbBookingModal .modal-body > .p-2 {
  padding: 0 !important;
}

.pbBookingModal .modal-footer {
  gap: 8px;
  padding: 14px 20px;
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.pbBookingModal .btn,
.pbBookingModalPrimary {
  min-height: 38px;
  margin: 0;
  padding: 0 14px;
  border-radius: 8px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 750;
  box-shadow: none;
}

.pbBookingModal .btn-outline-secondary,
.pbBookingModal .btn-secondary {
  border-color: var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-body, #334155);
}

.pbBookingModal .btn-outline-secondary:hover:not(:disabled),
.pbBookingModal .btn-secondary:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.pbBookingModal .btn-primary,
.pbBookingModal .pbBookingModalPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.pbBookingModal .btn-primary:hover:not(:disabled),
.pbBookingModal .pbBookingModalPrimary:hover:not(:disabled) {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
}

.pbBookingModal .btn:disabled {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  opacity: 1;
}

.pbBookingModal .badge {
  min-height: 21px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 800;
}

.pbBookingModal .alert {
  padding: 11px 13px;
  border-radius: 9px;
  font-size: 12.5px;
  line-height: 1.45;
}

.pbBookingModal .cpClubListsHero,
.pbBookingModal .cpAnswersHero {
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 11px;
  background: var(--slate-25, #fafbfc);
}

.pbBookingModal .cpClubListsHeroTitle,
.pbBookingModal .cpAnswersHeroTitle {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 17px;
  font-weight: 800;
}

.pbBookingModal .cpClubListsHeroSubtitle,
.pbBookingModal .cpAnswersHeroText {
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
}

.pbBookingModal .cpClubListBlock,
.pbBookingModal .cpAnswerCard {
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  box-shadow: none;
}

.pbBookingModal .cpClubListTitle,
.pbBookingModal .cpAnswerHeading {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 800;
}

.pbBookingModal .cpClubListName {
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
}

.pbBookingModal .cpClubListMeta,
.pbBookingModal .cpAnswerHint {
  color: var(--text-muted, #64748b);
  font-size: 11px;
}

@media (max-width: 720px) {
  .pbBookingModal .modal-content {
    max-height: calc(100vh - 24px);
  }

  .pbBookingModal .modal-header,
  .pbBookingModal .modal-body,
  .pbBookingModal .modal-footer {
    padding-right: 16px;
    padding-left: 16px;
  }
}

/* Activity programme confirmations and status dialogs */
.cpProgrammeDialog.modal-dialog {
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.cpProgrammeDialog .modal-content {
  max-height: calc(100vh - 48px) !important;
  border: 0 !important;
  border-radius: 14px !important;
  background: var(--surface-card, #fff) !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24) !important;
}

.cpProgrammeDialog .modal-header {
  min-height: 62px;
  padding: 16px 20px !important;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0) !important;
  background: var(--surface-card, #fff) !important;
}

.cpProgrammeDialog .modal-title {
  color: var(--text-strong, #0f172a) !important;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 18px !important;
  font-weight: 800 !important;
  line-height: 1.3 !important;
}

.cpProgrammeDialog .modal-header .close,
.cpProgrammeDialog .modal-header > button[aria-label='Close'] {
  display: inline-flex;
  width: 34px !important;
  height: 34px !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: var(--text-muted, #64748b) !important;
  line-height: 1 !important;
  opacity: 1;
}

.cpProgrammeDialog .modal-header .close:hover,
.cpProgrammeDialog .modal-header .close:focus-visible,
.cpProgrammeDialog .modal-header > button[aria-label='Close']:hover,
.cpProgrammeDialog .modal-header > button[aria-label='Close']:focus-visible {
  background: var(--surface-sunken, #f1f5f9) !important;
  color: var(--text-strong, #0f172a) !important;
  outline: none;
}

.cpProgrammeDialog .modal-body.cpProgrammeDialogBody {
  min-height: 0;
  padding: 18px 20px 0 !important;
  overflow-y: auto;
  color: var(--text-body, #334155) !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}

.cpProgrammeDialogContent {
  display: grid;
  gap: 16px;
}

.cpProgrammeDialogLead {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--slate-25, #fafbfc);
}

.cpProgrammeDialogLead.isWarning {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
}

.cpProgrammeDialogLead.isDanger {
  border-color: #fecdd3;
  background: #fff1f2;
}

.cpProgrammeDialogLead.isSuccess {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.cpProgrammeDialogLead.isInfo {
  border-color: #bfdbfe;
  background: var(--blue-50, #eef6fc);
}

.cpProgrammeDialogIcon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.cpProgrammeDialogLead.isWarning .cpProgrammeDialogIcon {
  background: var(--amber-100, #ffe9c2);
  color: var(--amber-700, #a85c07);
}

.cpProgrammeDialogLead.isDanger .cpProgrammeDialogIcon {
  background: #ffe4e6;
  color: #be123c;
}

.cpProgrammeDialogLead.isSuccess .cpProgrammeDialogIcon {
  background: #dcfce7;
  color: #15803d;
}

.cpProgrammeDialogLead.isInfo .cpProgrammeDialogIcon {
  background: #dbeafe;
  color: var(--blue-700, #155d8c);
}

.cpProgrammeDialogIcon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cpProgrammeDialogLead > div {
  min-width: 0;
}

.cpProgrammeDialogLead strong,
.cpProgrammeDialogNotice > strong,
.cpProgrammeDialogSectionHeader > strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-weight: 750;
}

.cpProgrammeDialogLead strong {
  margin-bottom: 3px;
  font-size: 13.5px;
}

.cpProgrammeDialogLead p,
.cpProgrammeDialogNotice p,
.cpProgrammeStatusList p {
  margin: 0;
}

.cpProgrammeDialogLead p {
  color: var(--text-body, #334155);
}

.cpProgrammeDialogNotice {
  padding: 13px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--slate-25, #fafbfc);
}

.cpProgrammeDialogNotice > strong {
  margin-bottom: 5px;
  font-size: 12.5px;
}

.cpProgrammeDialogNotice p {
  color: var(--text-muted, #64748b);
}

.cpProgrammeDialogNotice p + p {
  margin-top: 7px;
  padding-top: 7px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.cpProgrammeDialogSection {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
}

.cpProgrammeDialogSectionHeader {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.cpProgrammeDialogSectionHeader > strong {
  font-size: 12.5px;
}

.cpProgrammeDialogSectionHeader > span {
  display: inline-flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 11px;
  font-weight: 800;
}

.cpProgrammeAffectedList {
  max-height: 176px;
  overflow-y: auto;
}

.cpProgrammeAffectedRow {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 12px;
}

.cpProgrammeAffectedRow + .cpProgrammeAffectedRow {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.cpProgrammeAffectedRow > div {
  display: grid;
  min-width: 0;
  gap: 1px;
}

.cpProgrammeAffectedRow > div > strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeAffectedRow > div > span {
  overflow: hidden;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpProgrammeAffectedTag {
  display: inline-flex;
  min-height: 24px;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 8px;
  border: 1px solid var(--amber-100, #ffe9c2);
  border-radius: 999px;
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
  font-size: 10.5px;
  font-weight: 800;
}

.cpProgrammeStatusList {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
}

.cpProgrammeStatusList > div {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 10px 12px;
}

.cpProgrammeStatusList > div + div {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.cpProgrammeStatusList > div > span {
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #dcfce7;
  color: #15803d;
  font-size: 11px;
  font-weight: 900;
}

.cpProgrammeStatusList p {
  padding-top: 1px;
  color: var(--text-body, #334155);
}

.cpProgrammeDialogActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 -20px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.cpProgrammeDialogButton {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 750;
  line-height: 1;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.cpProgrammeDialogButton.isSecondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.cpProgrammeDialogButton.isSecondary:hover,
.cpProgrammeDialogButton.isSecondary:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  outline: none;
}

.cpProgrammeDialogButton.isPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.cpProgrammeDialogButton.isPrimary:hover,
.cpProgrammeDialogButton.isPrimary:focus-visible {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
  outline: none;
}

.cpProgrammeDialogButton.isDanger {
  border-color: #be123c;
  background: #be123c;
  color: #fff;
}

.cpProgrammeDialogButton.isDanger:hover,
.cpProgrammeDialogButton.isDanger:focus-visible {
  border-color: #9f1239;
  background: #9f1239;
  color: #fff;
  outline: none;
}

@media (max-width: 600px) {
  .cpProgrammeDialog .modal-content {
    max-height: calc(100vh - 24px) !important;
  }

  .cpProgrammeDialog .modal-header {
    min-height: 58px;
    padding: 13px 16px !important;
  }

  .cpProgrammeDialog .modal-body.cpProgrammeDialogBody {
    padding: 14px 16px 0 !important;
  }

  .cpProgrammeDialogActions {
    margin-right: -16px;
    margin-left: -16px;
    padding: 12px 16px;
  }

  .cpProgrammeDialogActions .cpProgrammeDialogButton {
    flex: 1 1 0;
  }

  .cpProgrammeAffectedRow {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/ClubProgrammes/ClubProgrammes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,mCAAmC;EACnC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,oCAAoC;EACpC,+BAA+B;;EAE/B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;EAElB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,iBAAiB;AACnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,+GAA+G;EAC/G,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;8BAE8B;;AAE9B;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,8EAA8E;EAC9E,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,8BAA8B;EAC9B,uBAAuB;EACvB,wCAAwC;EACxC,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;EAKE,+CAA+C;EAC/C,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;;;;;;;EAOE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,sDAAsD;EACtD,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sDAAsD;EACtD,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;;IAIE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,OAAO;IACP,qCAAqC;EACvC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,sDAAsD;EACtD,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,wEAAwE;AAC1E;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,+CAA+C;EAC/C,mFAAmF;AACrF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,+BAA+B;EAC/B,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+CAA+C;EAC/C,oCAAoC;EACpC,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,sCAAsC;EACtC,+BAA+B;EAC/B,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;EAC1C,oBAAoB;EACpB,sEAAsE;AACxE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;;EAGE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA,sCAAsC;AACtC;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iDAAiD;EACjD,kBAAkB;EAClB,qCAAqC;EACrC,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,2DAA2D;AAC3D;EACE,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;;EAIE,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;;EAIE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;EAKE,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;EAIE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE;;;;IAIE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,OAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,sEAAsE;EACtE,+BAA+B;EAC/B,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB;;;8DAG4D;AAC9D;;AAEA;EACE,aAAa;EACb,mEAAmE;AACrE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,sEAAsE;EACtE,iCAAiC;EACjC,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;AAChB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,sDAAsD;EACtD,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;;;IAKE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,2EAA2E;AAC7E;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,UAAU;EACV,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,+CAA+C;EAC/C,UAAU;EACV,gDAAgD;EAChD,2BAA2B;EAC3B,6CAA6C;EAC7C,qEAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;;;EAIE,qDAAqD;EACrD,8EAA8E;AAChF;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,wDAAwD;AAC1D;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gDAAgD;EAChD,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;EAC5C,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,qEAAqE;AACvE;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,oDAAoD;AACpD;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;;EAGE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,oGAAoG;AACtG;;AAEA;;;EAGE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;;;IAGE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,uEAAuE;EACvE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;;EAEE,4CAA4C;EAC5C,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,2DAA2D;AAC3D;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,mEAAmE;EACnE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,MAAM;EACN,4BAA4B;EAC5B,2CAA2C;EAC3C,qCAAqC;EACrC,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;EACnE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,4CAA4C;EAC5C,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,2CAA2C;EAC3C,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;;;EAIE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;;;;IAIE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;;;IAKE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,OAAO;IACP,WAAW;EACb;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;EAC5C,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;EAEE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,wDAAwD;AACxD;EACE,mEAAmE;AACrE;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,8BAA8B;EAC9B,gDAAgD;EAChD,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iEAAiE;EACjE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;EAC7C,yEAAyE;EACzE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;EAIE,qDAAqD;EACrD,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".eClubProgrammeForm {\n  padding: 10px;\n}\n\n/* card */\n.eCpfCard {\n  max-width: 720px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);\n  overflow: visible;\n}\n\n/* header */\n\n.eCpfHeader {\n  padding: 16px 18px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0));\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.eCpfTitleRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.eCpfTitle {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.25;\n  margin-bottom: 4px;\n}\n\n.eCpfSubtitle {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 13px;\n}\n\n.eCpfMeta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.eCpfRequiredPill {\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  background: rgba(0, 0, 0, 0.02);\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-weight: 600;\n}\n\n.eCpfRequiredNote {\n  white-space: nowrap;\n}\n\n.eCpfAsterisk {\n  color: #c62828;\n  font-weight: 700;\n}\n\n/* body */\n.eCpfBody {\n  padding: 14px 18px;\n}\n\n.eCpfField {\n  margin-top: 2px;\n}\n\n.eCpfLabel {\n  display: block;\n  font-weight: 700;\n  margin-bottom: 5px;\n  color: rgba(0, 0, 0, 0.82);\n}\n\n/* input */\n.eCpfInputWrap {\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  background: #fff;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.eCpfInputWrap:focus-within {\n  border-color: rgba(0, 0, 0, 0.38);\n  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.06);\n}\n\n.eCpfInputWrap.is-invalid {\n  border-color: rgba(198, 40, 40, 0.65);\n  box-shadow: 0 0 0 4px rgba(198, 40, 40, 0.1);\n}\n\n.eCpfInput {\n  width: 100%;\n  border: none;\n  outline: none;\n  background: transparent;\n  padding: 11px 12px;\n  font-size: 14px;\n}\n\n.eCpfInput::placeholder {\n  color: rgba(0, 0, 0, 0.35);\n}\n\n/* hint + error */\n.eCpfHint {\n  margin-top: 5px;\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n/* alerts */\n.eCpfAlert {\n  border-radius: 12px;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.eCpfAlertTitle {\n  font-weight: 800;\n  margin-bottom: 4px;\n}\n\n.eCpfAlertText {\n  color: rgba(0, 0, 0, 0.68);\n  font-size: 13px;\n}\n\n.eCpfAlertDanger {\n  background: rgba(198, 40, 40, 0.08);\n  border-color: rgba(198, 40, 40, 0.2);\n}\n\n/* footer */\n.eCpfGrid2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 14px;\n}\n\n.eCpfFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 10px 18px;\n  background: rgba(0, 0, 0, 0.015);\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.eCpfColSpan2 {\n  grid-column: 1 / span 2;\n}\n\n.eCpfDate {\n  width: 100%;\n}\n\n@media (max-width: 720px) {\n  .eCpfGrid2 {\n    grid-template-columns: 1fr;\n  }\n  .eCpfColSpan2 {\n    grid-column: 1 / span 1;\n  }\n}\n\n.eCpfCard {\n  margin: 0 auto;\n}\n\n.eCpfTitleLeft {\n  min-width: 0;\n}\n\n.eCpfTitleLine {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* badge */\n.eCpfStatusBadge {\n  font-size: 12px;\n  font-weight: 800;\n  padding: 4px 10px;\n  border-radius: 999px;\n  letter-spacing: 0.3px;\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  background: rgba(0, 0, 0, 0.03);\n  color: rgba(0, 0, 0, 0.7);\n}\n\n/* DRAFT */\n.eCpfStatus-draft {\n  background: rgba(96, 125, 139, 0.1);\n  border-color: rgba(96, 125, 139, 0.28);\n  color: rgba(55, 71, 79, 0.95);\n}\n\n/* ACTIVE */\n.eCpfStatus-active {\n  background: rgba(46, 125, 50, 0.12);\n  border-color: rgba(46, 125, 50, 0.28);\n  color: rgba(27, 94, 32, 0.95);\n}\n\n/* ARCHIVED */\n.eCpfStatus-archived {\n  background: rgba(94, 53, 177, 0.12);\n  border-color: rgba(94, 53, 177, 0.28);\n  color: rgba(69, 39, 160, 0.95);\n}\n\n.eCpfStatus-active {\n  background: rgba(46, 125, 50, 0.1);\n  border-color: rgba(46, 125, 50, 0.25);\n}\n.eCpfStatus-archived {\n  background: rgba(94, 53, 177, 0.1);\n  border-color: rgba(94, 53, 177, 0.25);\n}\n\n/* select styling */\n.eCpfSelect {\n  -webkit-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  padding-right: 38px;\n}\n\n.eCpfInputWrap:has(.eCpfSelect) {\n  position: relative;\n}\n\n.eCpfInputWrap:has(.eCpfSelect)::after {\n  content: '';\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  width: 0;\n  height: 0;\n  transform: translateY(-40%);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 6px solid rgba(0, 0, 0, 0.45);\n  pointer-events: none;\n}\n\n.eCpfRowHeader {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.eCpfTwoCols {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 16px;\n  align-items: start;\n}\n\n.eCpfDateWrap {\n  max-width: 320px;\n}\n\n.eCpfLabelSmall {\n  display: block;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: rgba(0, 0, 0, 0.72);\n  font-size: 13px;\n}\n\n.eCpfError {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(198, 40, 40, 0.08);\n  border: 1px solid rgba(198, 40, 40, 0.22);\n  color: rgba(198, 40, 40, 0.95);\n  font-size: 13px;\n  max-width: 320px;\n}\n\n.eCpfHeader {\n  position: relative;\n}\n\n.eCpfClose {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background: rgba(0, 0, 0, 0.02);\n\n  font-size: 22px;\n  line-height: 30px;\n  text-align: center;\n\n  color: rgba(0, 0, 0, 0.55);\n  cursor: pointer;\n}\n\n.eCpfClose:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.eCpfLabelInline {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.eCpfHintInline {\n  margin-top: 4px;\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.cpFooter {\n  margin-top: 0;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n}\n\n.cpDetailTabsWrap .GenericSummary {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.cpDetailTabsWrap .GenericSummary__content {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n}\n\n/* Body paddings */\n.cpFooterBody {\n  padding: 14px 16px 12px 16px;\n}\n\n/* Header */\n.cpFooterHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.cpTitle {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #1f2937; /* neutral dark */\n}\n\n.cpBadges {\n  margin-top: 6px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cpBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: rgba(0, 0, 0, 0.02);\n  color: #374151;\n}\n\n.cpBadge--muted {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n/* Status coloring (subtle) */\n.cpBadge--status {\n  background: rgba(59, 130, 246, 0.08);\n  border-color: rgba(59, 130, 246, 0.22);\n  color: #1d4ed8;\n}\n\n.cpStatus--draft {\n  background: rgba(107, 114, 128, 0.1);\n  border-color: rgba(107, 114, 128, 0.22);\n  color: #374151;\n}\n\n.cpStatus--published {\n  background: rgba(16, 185, 129, 0.1);\n  border-color: rgba(16, 185, 129, 0.22);\n  color: #047857;\n}\n\n.cpBadge--danger {\n  color: #721c24;\n  background: #f8d7da;\n  border-color: #f5c6cb;\n}\n\n.cpBadge--warn {\n  color: #856404;\n  background: #fff3cd;\n  border-color: #ffeeba;\n}\n\n.cpBadge--info {\n  color: #0c5460;\n  background: #d1ecf1;\n  border-color: #bee5eb;\n}\n\n.cpBadge--ok {\n  color: #155724;\n  background: #d4edda;\n  border-color: #c3e6cb;\n}\n\n/* Layout grid */\n.cpFooterGrid {\n  display: grid;\n  grid-template-columns: 1fr 220px;\n  gap: 12px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n@media (max-width: 900px) {\n  .cpFooterGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cpFooterGrid--clubs {\n  grid-template-columns: 1fr 1fr;\n  align-items: stretch;\n}\n\n@media (max-width: 900px) {\n  .cpFooterGrid--clubs {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cpBlock {\n  background: rgba(0, 0, 0, 0.015);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.cpLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b7280;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.cpValue {\n  font-size: 13px;\n  color: #111827;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cpMono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n  font-size: 12.5px;\n  color: #111827;\n}\n\n.cpArrow {\n  color: #9ca3af;\n  font-weight: 700;\n}\n\n.cpBig {\n  font-size: 18px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.cpSubtle {\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.cpHint {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px dashed rgba(0, 0, 0, 0.08);\n  font-size: 12.5px;\n  color: #6b7280;\n}\n\n.cpMiniCard {\n  background: rgba(0, 0, 0, 0.015);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  padding: 10px 12px;\n  min-width: 160px;\n}\n\n.cpMiniCard--wide {\n  flex: 1 1 320px;\n  min-width: 260px;\n}\n\n.cpMiniLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.cpMiniValue {\n  font-size: 22px;\n  font-weight: 800;\n  color: #111827;\n  line-height: 1.1;\n  margin-top: 4px;\n}\n\n.cpMiniText {\n  margin-top: 6px;\n  font-size: 13.5px;\n  color: #374151;\n}\n\n.cpReadOnlyNote {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(107, 114, 128, 0.08);\n  border: 1px solid rgba(107, 114, 128, 0.18);\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.cpFooterBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #fafafa;\n  border-radius: 10px;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  margin-bottom: 8px;\n}\n\n.cpFooterLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cpFooterRight {\n  flex: 0 0 auto;\n}\n\n.cpMuted {\n  color: #6c757d;\n}\n\n/* Small controls (inputs/select-like divs) */\n.cpInputSm {\n  height: 32px;\n  padding: 4px 8px;\n  font-size: 13px;\n}\n\n/* \"Fake select\" control (div styled like input) */\n.cpControlSm {\n  height: 32px;\n  padding: 4px 8px;\n  font-size: 13px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Single-line ellipsis */\n.cpEllipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Add-modal table row hover + selection */\n.cpRowClickable {\n  cursor: pointer;\n}\n\n.cpRowClickable:hover {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.cpRowSelected {\n  background: rgba(13, 110, 253, 0.06);\n}\n\n.cpRowSelected:hover {\n  background: rgba(13, 110, 253, 0.09);\n}\n\n/* === Activity Programme Modals layout === */\n.cpModalShell {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1 1 auto;\n}\n\n/* Top area (Filters toggle + optional meta text) */\n.cpToolbar {\n  padding-bottom: 8px;\n}\n\n.cpToolbarRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* Right-aligned small meta text inside toolbar row */\n.cpToolbarMeta {\n  margin-left: auto;\n  color: #6c757d;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.cpMenu .btn-link {\n  color: #1f2937;\n  text-decoration: none;\n}\n\n.cpMenu .btn-link:hover {\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 6px;\n}\n\n.cpDataTable {\n  width: 100%;\n  table-layout: fixed;\n  margin-bottom: 0;\n  background: #fff;\n}\n\n.cpDataTable thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8fafc;\n  border-bottom: 1px solid #e6e9ee;\n  color: #495057;\n  font-weight: 600;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.cpDataTable td {\n  vertical-align: middle;\n  border-top: 1px solid #eef1f4;\n}\n\n.cpDataTable tbody tr:hover {\n  background: #fafbfc;\n}\n\n.cpDataTable tbody tr.cpRowSelected {\n  background: #eef6ff;\n}\n\n.cpDataTable tbody tr.cpRowSelected:hover {\n  background: #e8f2ff;\n}\n\n.cpFilterLabel {\n  font-size: 12px;\n  line-height: 1.2;\n  color: #6c757d;\n  margin-bottom: 4px;\n  padding-left: 2px;\n}\n\n.cpProgrammeFieldCard {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  margin-top: 10px;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 14px 0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.cpFieldsHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.cpFieldsHeaderMain {\n  min-width: 0;\n}\n\n.cpFieldsTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cpFieldsSubtitle {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.cpFieldsHeaderActions {\n  flex: 0 0 auto;\n}\n\n.cpFieldsEmptyState {\n  margin-top: 6px;\n  padding: 18px 16px;\n  border: 1px dashed rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.015);\n}\n\n.cpFieldsEmptyTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: #374151;\n}\n\n.cpFieldsEmptyText {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.cpProgrammeFieldCardBody {\n  padding: 0 14px;\n}\n\n.cpProgrammeFieldCardTitle {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.35;\n  color: #111827;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.cpProgrammeFieldCardBadges {\n  margin-top: 8px;\n}\n\n.cpFieldsManageHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n.cpFieldsManageHeaderMain {\n  min-width: 0;\n}\n\n.cpFieldsManageTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cpFieldsManageTitle {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #111827;\n}\n\n.cpFieldsManageSubtitle {\n  margin-top: 6px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n\n.cpFieldsManageHeaderActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex: 0 0 auto;\n}\n\n.cpFieldsManageSearch {\n  margin-bottom: 14px;\n}\n\n.cpFieldsManageRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 12px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.cpFieldsManageRowMain {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.cpFieldsManageRowTitle {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.3;\n  color: #111827;\n  word-break: break-word;\n}\n\n.cpFieldsManageRowDrag {\n  cursor: grab;\n  padding: 2px 6px;\n  color: #9ca3af;\n  user-select: none;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.cpBadgeButton {\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n}\n\n.cpBadgeButton:disabled {\n  cursor: default;\n  opacity: 0.75;\n}\n\n/* =========================\n   Activity Programme Bookings Board\n   ========================= */\n\n.cpBookingsCard {\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 12px;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.cpBookingsCard + .cpBookingsCard {\n  margin-top: 10px;\n}\n\n.cpBookingsCard:hover {\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);\n}\n\n.cpBookingsCard--conflict {\n  border-color: rgba(220, 53, 69, 0.35);\n  background: #fffafb;\n}\n\n.cpBookingsCard--selectedClub {\n  background: rgba(23, 162, 184, 0.07);\n  border-color: rgba(23, 162, 184, 0.18);\n}\n\n.cpBookingsCard--selectedWaiting {\n  background: rgba(255, 193, 7, 0.14);\n  border-color: rgba(255, 193, 7, 0.24);\n}\n\n.cpBookingsCard--confirmedClub {\n  background: rgba(40, 167, 69, 0.08);\n  border-color: rgba(40, 167, 69, 0.2);\n}\n\n.cpBookingsCard--confirmedWaiting {\n  background: rgba(255, 193, 7, 0.16);\n  border-color: rgba(255, 193, 7, 0.26);\n}\n\n.cpBookingsCardTop {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.cpBookingsCardMain {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.cpBookingsStudentName {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cpBookingsMeta {\n  margin-top: 6px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #6b7280;\n}\n\n.cpBookingsMetaStrong {\n  font-weight: 700;\n  color: #374151;\n}\n\n.cpBookingsSide {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.cpBookingsActions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(15, 23, 42, 0.06);\n}\n\n.cpBookingsConflictNote {\n  margin-top: 10px;\n  padding: 9px 10px;\n  border-radius: 10px;\n  background: rgba(220, 53, 69, 0.08);\n  border: 1px solid rgba(220, 53, 69, 0.16);\n  color: #c24141;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.cpBookingsMutedNote {\n  margin-top: 10px;\n  font-size: 12.5px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n\n.cpBookingsModalCard {\n  margin-bottom: 10px;\n}\n\n.cpBookingsStats {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.cpBookingsStatsRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 12.5px;\n  color: #6b7280;\n}\n\n.cpBookingsStatsRow + .cpBookingsStatsRow {\n  margin-top: 6px;\n}\n\n.cpBookingsActions--modal {\n  margin-top: 12px;\n}\n\n.cpClubColumnHeader {\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(6px);\n  padding: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);\n}\n\n.cpClubColumnTitle {\n  font-size: 15px;\n  line-height: 1.3;\n  font-weight: 700;\n  color: #334155;\n  margin: 0;\n}\n\n.cpClubColumnSubtitle {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.cpClubListsSummary {\n  margin-bottom: 14px;\n  padding: 12px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.cpClubListsSummaryRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  font-size: 13px;\n  color: #4b5563;\n}\n\n.cpClubListsSummaryRow + .cpClubListsSummaryRow {\n  margin-top: 8px;\n}\n\n.cpClubListsGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n@media (max-width: 900px) {\n  .cpClubListsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cpClubListBlock {\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  background: #fff;\n  padding: 12px;\n}\n\n.cpClubListTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 10px;\n}\n\n.cpClubListItems {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cpClubListItem {\n  border-radius: 10px;\n  padding: 10px 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #fafafa;\n}\n\n.cpClubListItem--club {\n  background: rgba(40, 167, 69, 0.08);\n  border-color: rgba(40, 167, 69, 0.18);\n}\n\n.cpClubListItem--selectedClub {\n  background: rgba(23, 162, 184, 0.08);\n  border-color: rgba(23, 162, 184, 0.18);\n}\n\n.cpClubListItem--waiting {\n  background: rgba(255, 193, 7, 0.14);\n  border-color: rgba(255, 193, 7, 0.28);\n}\n\n.cpClubListItem--selectedWaiting {\n  background: rgba(255, 193, 7, 0.08);\n  border-color: rgba(255, 193, 7, 0.2);\n}\n\n.cpClubListName {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.cpClubListMeta {\n  margin-top: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.cpClubListEmpty {\n  font-size: 13px;\n  color: #6b7280;\n  padding: 8px 0;\n}\n\n.cpClubListsFooterActions {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cpClubListsHero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 14px 16px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 14px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.025), rgba(0, 0, 0, 0.01));\n  margin-bottom: 14px;\n}\n\n.cpClubListsHeroMain {\n  min-width: 0;\n  flex: 1 1 320px;\n}\n\n.cpClubListsHeroTitle {\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: #111827;\n}\n\n.cpClubListsHeroSubtitle {\n  margin-top: 6px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #6b7280;\n}\n\n.cpClubListsHeroStats {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cpClubListsHeroStat {\n  min-width: 92px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.07);\n  text-align: center;\n}\n\n.cpClubListsHeroStatLabel {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #6b7280;\n}\n\n.cpClubListsHeroStatValue {\n  margin-top: 4px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.cpClubListsKpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n@media (max-width: 900px) {\n  .cpClubListsKpis {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.cpClubListsKpi {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #fff;\n}\n\n.cpClubListsKpiLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4b5563;\n}\n\n.cpClubListsKpiValue {\n  font-size: 18px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.cpClubListsKpi--club {\n  background: rgba(40, 167, 69, 0.06);\n  border-color: rgba(40, 167, 69, 0.18);\n}\n\n.cpClubListsKpi--selectedClub {\n  background: rgba(23, 162, 184, 0.06);\n  border-color: rgba(23, 162, 184, 0.18);\n}\n\n.cpClubListsKpi--waiting {\n  background: rgba(255, 193, 7, 0.12);\n  border-color: rgba(255, 193, 7, 0.26);\n}\n\n.cpClubListsKpi--selectedWaiting {\n  background: rgba(255, 193, 7, 0.07);\n  border-color: rgba(255, 193, 7, 0.18);\n}\n\n.cpClubListBlock {\n  border-radius: 14px;\n  padding: 14px;\n}\n\n.cpClubListTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 800;\n  color: #111827;\n  margin-bottom: 12px;\n}\n\n.cpClubListItems {\n  gap: 10px;\n}\n\n.cpClubListItem {\n  border-radius: 12px;\n  padding: 11px 12px;\n  background: #fff;\n}\n\n.cpClubListName {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.cpClubListMeta {\n  margin-top: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.cpClubListMeta span {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.cpClubListsFooterActions {\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cpBookingsTopActions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n  background: #fafafa;\n}\n\n.cpBookingsPendingGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cpBookingsPendingBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 13px;\n  color: #6b7280;\n  background: rgba(0, 0, 0, 0.04);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.cpBookingsPendingBadge--strong {\n  color: #1f2937;\n  font-weight: 700;\n  background: rgba(40, 167, 69, 0.08);\n  border-color: rgba(40, 167, 69, 0.18);\n}\n\n.cpBookingsTopButtons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cpBookingsQuickActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.cpIconBtn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  background: #fff;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.cpIconBtn:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.04);\n  color: #374151;\n}\n\n.cpIconBtn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.cpIconBtn--danger {\n  color: #c05621;\n}\n\n.cpIconBtn--danger:hover:not(:disabled) {\n  color: #9b2c2c;\n  background: rgba(220, 53, 69, 0.06);\n  border-color: rgba(220, 53, 69, 0.2);\n}\n\n.cpAnswersHero {\n  background: linear-gradient(135deg, #f8fbff 0%, #f7fcf8 100%);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  padding: 16px 18px;\n  margin-bottom: 14px;\n}\n\n.cpAnswersHeroTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2d3d;\n  margin-bottom: 4px;\n}\n\n.cpAnswersHeroText {\n  font-size: 13px;\n  color: #6c757d;\n  line-height: 1.45;\n}\n\n.cpAnswerCard {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n\n.cpAnswerCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.cpAnswerHeading {\n  font-size: 15px;\n  font-weight: 600;\n  color: #223047;\n  line-height: 1.35;\n}\n\n.cpAnswerMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  justify-content: flex-end;\n}\n\n.cpAnswerValue {\n  background: rgba(0, 0, 0, 0.025);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  padding: 10px 12px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: #223047;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.cpAnswerHint {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.eCpfSectionCard {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 10px 12px;\n  background: #fff;\n}\n\n.eCpfSectionTitle {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.eCpfReadOnlyHint {\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  background: #f9fafb;\n}\n\n.eCpfSubLabel {\n  margin-top: 4px;\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 11.5px;\n  line-height: 1.3;\n}\n\n.cpManageDetailArea {\n  flex: 0 0 34%;\n  min-height: 240px;\n  display: flex;\n  flex-direction: column;\n}\n\n.cpDetailPlaceholder {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 180px;\n}\n\n.cpDetailHeader {\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.cpDetailHeaderMain {\n  min-width: 0;\n}\n\n.cpDetailTabsWrap {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.eCpfSectionDisabled {\n  opacity: 0.65;\n  pointer-events: none;\n}\n\n.eCpfSelect:disabled,\n.eCpfInput:disabled,\n.form-control:disabled {\n  background: #f4f6f8 !important;\n  color: #6c757d !important;\n  cursor: not-allowed !important;\n}\n\n.eCpfAlert {\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #f8fafc;\n  border: 1px solid #d9e2ec;\n}\n\n.eCpfAlertTitle {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.eCpfAlertText {\n  color: #5b6875;\n}\n\n/* Design-system Club programmes list */\n.cpDsPage {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 18px;\n  min-height: calc(100vh - 88px);\n  padding: 18px 22px 32px;\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #243244);\n  font-family: var(--font-body, inherit);\n}\n\n.cpDsPage.hasSummary {\n  grid-template-columns: minmax(0, 1fr) 508px;\n  align-items: start;\n}\n\n.cpDsMain {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.cpDsHeader,\n.cpDsToolbar,\n.cpDsSelectionBar,\n.cpDsFilters,\n.cpDsTableCard {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--surface-card, #fff);\n  border-radius: 14px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\n.cpDsHeader {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 20px;\n}\n\n.cpDsHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.cpDsHeader p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 14px;\n}\n\n.cpDsHeaderActions,\n.cpDsToolbar,\n.cpDsSelectionBar,\n.cpDsFooter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cpDsToolbar {\n  padding: 12px 14px;\n}\n\n.cpDsToolbarTitle {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.cpDsToolbarTitle strong {\n  color: var(--text-strong, #142033);\n  font-size: 15px;\n  font-weight: 750;\n}\n\n.cpDsToolbarTitle span,\n.cpDsFooter span {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.cpDsSearch {\n  position: relative;\n  flex: 0 1 320px;\n  width: min(320px, 100%);\n  margin: 0;\n  color: var(--text-subtle, #8a96a8);\n}\n\n.cpDsSearch input,\n.cpDsFilterField input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--text-strong, #142033);\n  font: inherit;\n  font-size: 13.5px;\n  outline: none;\n}\n\n.cpDsSearch input {\n  padding: 0 12px;\n}\n\n.cpDsFilterField input {\n  padding: 0 10px;\n}\n\n.cpDsSearch input:focus,\n.cpDsFilterField input:focus {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);\n}\n\n.cpDsBtn,\n.cpDsIconTextBtn,\n.cpDsIconBtn,\n.cpDsSort,\n.cpDsPageBtn,\n.cpDsPagerBtn,\n.cpDsFilterChip {\n  font: inherit;\n  cursor: pointer;\n}\n\n.cpDsBtn,\n.cpDsIconTextBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 38px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  font-size: 13.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.cpDsBtn:disabled {\n  opacity: 0.48;\n  cursor: default;\n}\n\n.cpDsBtnPrimary {\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(34, 126, 189, 0.22);\n}\n\n.cpDsBtnSecondary,\n.cpDsIconTextBtn {\n  background: #fff;\n  color: var(--text-strong, #142033);\n  border-color: var(--border-default, #cfd8e3);\n}\n\n.cpDsBtnGhost {\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  border-color: transparent;\n}\n\n.cpDsBtnDanger {\n  background: var(--red-600, #dc2626);\n  color: #fff;\n  border-color: var(--red-600, #dc2626);\n}\n\n.cpDsIconTextBtn.isActive {\n  border-color: var(--action-primary, #227ebd);\n  color: var(--blue-700, #155d8c);\n  background: var(--blue-50, #eef7fd);\n}\n\n.cpDsIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--blue-700, #164170);\n  font-weight: 800;\n}\n\n.cpDsSelectionBar {\n  padding: 10px 12px;\n}\n\n.cpDsSelectionCount {\n  margin-right: 4px;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.cpDsFilters {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(120px, 1fr)) auto;\n  gap: 12px;\n  padding: 14px;\n}\n\n.cpDsFilterField span {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.cpDsFilterFieldWide {\n  grid-column: span 2;\n}\n\n.cpDsFilterChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-height: 40px;\n  padding: 3px;\n}\n\n.cpDsFilterChip {\n  min-height: 32px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  padding: 0 11px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.cpDsFilterChip:hover {\n  border-color: var(--border-brand, #6fb1df);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpDsFilterChip.isSelected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpDsFilterActions {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.cpDsFilterControl {\n  position: relative;\n  height: 40px;\n  display: flex;\n  align-items: flex-start;\n  align-self: center;\n}\n\n.cpDsFilterControl > .cpDsIconTextBtn {\n  height: 40px;\n}\n\n.cpDsColumnsControl {\n  position: relative;\n  height: 40px;\n  display: flex;\n  align-items: flex-start;\n  align-self: center;\n}\n\n.cpDsColumnsControl > .cpDsIconTextBtn {\n  height: 40px;\n}\n\n.cpDsColumnsScrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1039;\n  border: 0;\n  background: transparent;\n  cursor: default;\n}\n\n.cpDsColumnsMenu {\n  position: absolute;\n  z-index: 1040;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 250px;\n  padding: 7px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.16);\n}\n\n.cpDsColumnsMenu header {\n  padding: 7px 9px 10px;\n  color: #69778a;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cpDsColumnsMenu label {\n  min-height: 36px;\n  margin: 0;\n  padding: 7px 9px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cpDsColumnsMenu label:hover {\n  background: #f8fafc;\n}\n\n.cpDsColumnsMenu input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: #227ebd;\n}\n\n.cpDsColumnsMenu input:disabled {\n  opacity: 0.55;\n}\n\n.cpDsColumnsMenu label:has(input:disabled) {\n  color: #69778a;\n  cursor: default;\n}\n\n.cpDsIconTextBtn svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 1.8;\n}\n\n.cpDsFilterCount {\n  min-width: 19px;\n  height: 19px;\n  padding: 0 5px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.cpDsFilterScrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1039;\n  border: 0;\n  background: rgba(15, 23, 42, 0.24);\n  cursor: default;\n}\n\n.cpDsFilterDrawer {\n  position: fixed;\n  z-index: 1040;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 392px;\n  max-width: calc(100vw - 24px);\n  border: 0;\n  border-left: 1px solid #dbe3ec;\n  background: #fff;\n  box-shadow: -12px 0 42px rgba(15, 23, 42, 0.2);\n  display: flex;\n  flex-direction: column;\n  animation: cpDsFilterDrawerIn 0.18s ease-out;\n}\n\n.cpDsFilterDrawer > header {\n  flex: 0 0 auto;\n  min-height: 64px;\n  padding: 0 20px;\n  border-bottom: 1px solid #e7edf3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cpDsFilterDrawer > header strong {\n  color: #142033;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.cpDsFilterDrawer > header button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #69778a;\n  font: inherit;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.cpDsFilterDrawer > header button:hover {\n  background: #f1f5f9;\n  color: #142033;\n}\n\n.cpDsFilterFields {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  overflow-x: visible;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.cpDsFilterFields .cpDsFilterFieldWide {\n  grid-column: auto;\n  min-width: 0;\n}\n\n.cpDsFilterFields .cpDsFilterField > span {\n  display: block;\n  margin-bottom: 7px;\n  color: #344054;\n  font-size: 12px;\n  font-weight: 750;\n  line-height: 18px;\n}\n\n.cpDsFilterFields .cpDsFilterChips {\n  min-height: 0;\n  padding: 0;\n  gap: 6px;\n}\n\n.cpDsFilterFields .cpDsFilterChip {\n  min-height: 32px;\n  padding: 0 10px;\n  border-color: #d0d5dd;\n  border-radius: 999px;\n  color: #344054;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.cpDsFilterFields .cpDsFilterChip.isSelected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpDsFilterFields .sit-dp__label {\n  margin-bottom: 7px;\n  color: #344054;\n  font-size: 12px;\n  font-weight: 750;\n  line-height: 18px;\n  text-align: left;\n}\n\n.cpDsFilterFields .sit-dp__trigger {\n  min-height: 40px;\n  border-color: #d0d5dd;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n}\n\n.cpDsFilterFields .cpDsDateRange,\n.cpDsFilterFields .cpDsDateRange .sit-dp__pop {\n  z-index: 1060;\n}\n\n.cpDsFilterFields .cpDsDateRange .sit-dp__pop {\n  position: fixed;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: hidden;\n  align-items: stretch;\n  animation: none;\n  overscroll-behavior: contain;\n}\n\n.cpDsFilterFields .cpDsDateRange .sit-dp__pop > div:last-child {\n  min-width: 0;\n  min-height: 0;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n}\n\n.cpDsFilterFields .cpDsDateRange .sit-dp__pop > div:last-child > div:first-child {\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.cpDsFilterFields .cpDsDateRange .sit-dp__pop > div:last-child > div:last-child {\n  flex: 0 0 auto;\n  padding: 0 14px 14px !important;\n  border-top: 1px solid #e7edf3;\n  background: #fff;\n  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);\n}\n\n.cpDsFilterFields .cpDsDateRange .sit-cal__foot {\n  position: static;\n  margin: 0;\n  padding-top: 12px;\n}\n\n.cpDsFilterDrawer > footer {\n  flex: 0 0 auto;\n  min-height: 68px;\n  padding: 12px 20px;\n  border-top: 1px solid #e7edf3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cpDsFilterDrawer > footer > div {\n  display: flex;\n  gap: 8px;\n}\n\n.cpDsFilterDrawer > footer button {\n  height: 38px;\n  padding: 0 14px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #344054;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cpDsFilterDrawer > footer button.isClear {\n  padding-left: 0;\n  border-color: transparent;\n  color: #69778a;\n}\n\n.cpDsFilterDrawer > footer button.isApply {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n@keyframes cpDsFilterDrawerIn {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n.cpDsActiveFilters {\n  min-height: 44px;\n  padding: 7px 10px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  background: #fff;\n}\n\n.cpDsActiveFilters > button {\n  min-height: 28px;\n  padding: 4px 9px;\n  border: 1px solid #b9d8eb;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: #eef7fd;\n  color: #155d8c;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.cpDsActiveFilters > button span:last-child {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 12px;\n}\n\n.cpDsActiveFilters > button.cpDsClearFilters {\n  margin-left: auto;\n  border-color: transparent;\n  background: transparent;\n  color: #69778a;\n  font-weight: 700;\n}\n\n.cpDsTableCard {\n  overflow: hidden;\n}\n\n.cpDsTableScroll {\n  overflow: auto;\n}\n\n.cpDsTable {\n  width: 100%;\n  min-width: 1120px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.cpDsTable th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  height: 44px;\n  background: var(--slate-25, #f8fafc);\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  color: var(--text-muted, #69778a);\n  padding: 0 12px;\n  text-align: left;\n  font-size: 11.5px;\n  font-weight: 800;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.cpDsTable td {\n  height: 58px;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n  color: var(--text-body, #243244);\n  padding: 8px 12px;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.cpDsTable tbody tr {\n  cursor: pointer;\n}\n\n.cpDsTable tbody tr:hover,\n.cpDsTable tbody tr.isSelected {\n  background: var(--blue-50, #eaf5fc);\n}\n\n.cpDsCheckCell {\n  width: 44px;\n  text-align: center !important;\n}\n\n.cpDsCheckCell input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--blue-600, #227ebd);\n}\n\n.cpDsSort {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  padding: 0;\n  font-size: inherit;\n  font-weight: inherit;\n  text-transform: inherit;\n}\n\n.cpDsSortMark {\n  color: var(--blue-700, #155d8c);\n  font-size: 10px;\n}\n\n.cpDsNameCell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 280px;\n}\n\n.cpDsProgrammeIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #164170);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.cpDsNameCell strong,\n.cpDsNameCell small {\n  display: block;\n}\n\n.cpDsNameCell strong {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.cpDsNameCell small {\n  max-width: 360px;\n  margin-top: 2px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpDsChip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: 6px;\n  background: var(--slate-100, #edf2f7);\n  color: var(--text-body, #243244);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.cpDsBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.cpDsBadge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.cpDsBadge.isSuccess {\n  background: #eaf7ed;\n  color: #217a3a;\n}\n.cpDsBadge.isWarning {\n  background: #fff4d8;\n  color: #9a6500;\n}\n.cpDsBadge.isInfo {\n  background: #eaf5fc;\n  color: #155d8c;\n}\n.cpDsBadge.isNeutral {\n  background: #edf2f7;\n  color: #536173;\n}\n\n.cpDsEmpty {\n  height: 120px !important;\n  text-align: center;\n  color: var(--text-muted, #69778a) !important;\n}\n\n.cpDsFooter {\n  justify-content: flex-end;\n  margin-top: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.cpDsPaginationSummary {\n  margin-right: 4px;\n}\n\n.cpDsPaginationEllipsis {\n  min-width: 18px;\n  text-align: center;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpDsPageBtn,\n.cpDsPagerBtn {\n  min-width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.cpDsPageBtn:hover,\n.cpDsPagerBtn:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpDsPageBtn.isActive {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpDsPagerBtn:disabled {\n  cursor: default;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpDsSummary {\n  position: sticky;\n  top: 12px;\n  max-height: calc(100vh - 96px);\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.cpDsSummary .cpFooter {\n  margin: 0;\n  max-height: calc(100vh - 96px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 1180px) {\n  .cpDsPage.hasSummary {\n    grid-template-columns: 1fr;\n  }\n\n  .cpDsSummary {\n    position: relative;\n    top: 0;\n    max-height: none;\n  }\n\n  .cpDsSummary .cpFooter {\n    max-height: none;\n  }\n\n  .cpDsFilters {\n    grid-template-columns: repeat(2, minmax(140px, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .cpDsPage {\n    padding: 12px;\n  }\n\n  .cpDsHeader,\n  .cpDsToolbar,\n  .cpDsSelectionBar,\n  .cpDsFooter {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .cpDsSearch {\n    width: 100%;\n  }\n\n  .cpDsFilters {\n    grid-template-columns: 1fr;\n  }\n\n  .cpDsFilterFieldWide {\n    grid-column: auto;\n  }\n\n  .cpDsFilterControl {\n    width: 100%;\n  }\n\n  .cpDsFilterControl > .cpDsIconTextBtn,\n  .cpDsColumnsControl > .cpDsIconTextBtn {\n    width: 100%;\n  }\n\n  .cpDsColumnsControl {\n    width: 100%;\n  }\n\n  .cpDsColumnsMenu {\n    right: auto;\n    left: 0;\n    width: min(280px, calc(100vw - 24px));\n  }\n\n  .cpDsFilterScrim {\n    background: rgba(15, 23, 42, 0.32);\n  }\n\n  .cpDsFilterDrawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    max-width: none;\n    max-height: none;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .cpDsFilterFields {\n    max-height: none;\n  }\n\n  .cpDsActiveFilters > button.cpDsClearFilters {\n    margin-left: 0;\n  }\n}\n\n/* DS programme preview drawer */\n.cpDsTable tbody tr.isPreview {\n  background: var(--blue-50, #eaf5fc);\n}\n\n.cpDsSummary {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1050;\n  width: 464px;\n  max-width: 96vw;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-card, #fff);\n  box-shadow: -10px 0 40px rgba(15, 23, 42, 0.18);\n}\n\n.cpDrawer {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-card, #fff);\n}\n\n.cpDrawerHead {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 20px 22px 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.cpDrawerLead {\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #164170);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.cpDrawerTitles {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.cpDrawerTitle {\n  font-family: var(--font-display, inherit);\n  font-size: 20px;\n  font-weight: 800;\n  color: var(--text-strong, #142033);\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.cpDrawerMeta {\n  margin-top: 3px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.cpDrawerMeta > i {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: var(--slate-300, #cbd5e1);\n  display: inline-block;\n}\n\n.cpDrawerClose {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #69778a);\n  cursor: pointer;\n}\n\n.cpDrawerClose:hover {\n  background: var(--surface-hover, #f8fafc);\n  color: var(--text-strong, #142033);\n}\n\n.cpDrawerClose svg {\n  width: 16px;\n  height: 16px;\n}\n\n.cpDrawerTabs {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 4px;\n  overflow-x: auto;\n  padding: 8px 22px 0;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.cpDrawerTabs button {\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.cpDrawerTabs button.isActive {\n  color: var(--blue-700, #164170);\n  border-bottom-color: var(--blue-600, #227ebd);\n}\n\n.cpDrawerTabDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--amber-500, #f0ad4e);\n  box-shadow: 0 0 0 2px rgba(240, 173, 78, 0.18);\n}\n\n.cpDrawerBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 22px 22px;\n  color: var(--text-body, #243244);\n  font-size: 14px;\n}\n\n.cpDrawer .cpFooterBody {\n  padding: 0;\n}\n\n.cpDrawer .cpFooterHeader {\n  margin-bottom: 14px;\n}\n\n.cpDrawer .cpFooterGrid,\n.cpDrawer .cpFooterGrid--clubs {\n  grid-template-columns: 1fr;\n}\n\n.cpDrawer .cpBlock {\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n\n@media (max-width: 720px) {\n  .cpDsSummary {\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n\n/* DS shared programme sub-pages */\n.cpPageHeader {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 20px 24px 18px;\n  margin: 18px 22px 0;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\n.cpPageHeaderMain {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.cpBackLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 10px;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #164170);\n  padding: 0;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cpBackLink span {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.cpPageTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  flex-wrap: wrap;\n}\n\n.cpPageTitleRow h1 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n  font-size: 23px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.cpPageHeaderSlot {\n  flex: 0 0 auto;\n}\n\n.cpPageMeta {\n  margin-top: 5px;\n  color: var(--text-muted, #69778a);\n  font-size: 13.5px;\n}\n\n.cpPageMeta strong {\n  color: var(--text-strong, #142033);\n  font-weight: 750;\n}\n\n.cpPageHeader p {\n  max-width: 720px;\n  margin: 8px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.cpPageHeaderActions {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cpPageBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  margin: 14px 22px 24px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\n.cpDataTableShell {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n}\n\n.cpDataTableShellScroll {\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n@media (max-width: 720px) {\n  .cpPageHeader {\n    margin: 12px 12px 0;\n    padding: 16px;\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .cpPageBody {\n    margin: 12px;\n    padding: 12px;\n  }\n}\n\n.cpToolbar {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n  padding: 12px 14px;\n}\n\n.cpToolbarRowDs {\n  min-height: 38px;\n}\n\n.cpToolbarState,\n.cpToolbarMeta {\n  font-size: 13px;\n  color: var(--text-muted, #69778a);\n}\n\n.cpDataTable {\n  width: 100%;\n  table-layout: fixed;\n  margin-bottom: 0;\n  background: var(--surface-card, #fff);\n}\n\n.cpDataTable thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  height: 44px;\n  background: var(--slate-25, #f8fafc);\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  font-weight: 800;\n  text-transform: uppercase;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.cpDataTable td {\n  height: 52px;\n  border-top: 1px solid var(--border-subtle, #edf1f5);\n  color: var(--text-body, #243244);\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.cpDataTable tbody tr:hover {\n  background: var(--blue-50, #eaf5fc);\n}\n\n.cpDataTable tbody tr.cpRowSelected {\n  background: var(--blue-50, #eaf5fc);\n}\n\n.cpInputSm,\n.cpControlSm {\n  height: 38px;\n  border-color: var(--border-default, #cfd8e3);\n  border-radius: 9px;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n}\n\n.cpInputSm:focus,\n.cpControlSm:focus-within {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);\n}\n\n.cpFilterLabel {\n  margin-bottom: 6px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  font-weight: 700;\n}\n/* Pixel-aligned DS programme preview drawer */\n.cpDsSummaryScrim {\n  position: fixed;\n  inset: 0;\n  z-index: var(--z-modal, 1040);\n  background: rgba(15, 23, 42, 0.34);\n  animation: cpDrawerFade var(--dur-base, 160ms) var(--ease-out, ease-out);\n}\n\n@keyframes cpDrawerFade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.cpDsSummary.sit-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: calc(var(--z-modal, 1040) + 1);\n  width: 464px;\n  max-width: 96vw;\n  min-width: 0;\n  max-height: none;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--surface-card, #ffffff);\n  box-shadow: -10px 0 40px rgba(15, 23, 42, 0.18);\n  animation: cpDrawerSlideRight var(--dur-slow, 260ms) cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes cpDrawerSlideRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: none;\n  }\n}\n\n.cpDsSummary.sit-drawer .cpDrawer {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--surface-card, #ffffff);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerHead {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 20px 22px 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerLead {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md, 8px);\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #164170);\n  font-size: 12px;\n  font-weight: var(--weight-bold, 700);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTitles {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTitle {\n  margin: 0;\n  font-family: var(--font-display, inherit);\n  font-size: var(--text-xl, 20px);\n  font-weight: var(--weight-bold, 700);\n  color: var(--text-strong, #142033);\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerMeta {\n  margin-top: 3px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: var(--text-muted, #69778a);\n  font-size: var(--text-xs, 12px);\n  font-weight: 500;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerMeta > i {\n  width: 3px;\n  height: 3px;\n  display: inline-block;\n  border-radius: 50%;\n  background: var(--slate-300, #cbd5e1);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerClose {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #ffffff);\n  color: var(--text-muted, #69778a);\n  cursor: pointer;\n  transition: background var(--dur-fast, 120ms), color var(--dur-fast, 120ms);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerClose:hover {\n  background: var(--surface-hover, #f8fafc);\n  color: var(--text-strong, #142033);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerClose svg {\n  width: 16px;\n  height: 16px;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  overflow-x: auto;\n  padding: 8px 22px 0;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: auto;\n  padding: 10px 14px;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  font-family: var(--font-body, inherit);\n  font-size: var(--text-md, 14px);\n  font-weight: var(--weight-semibold, 600);\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color var(--dur-base, 160ms) var(--ease-out, ease-out);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab::after {\n  content: '';\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 2px 2px 0 0;\n  background: var(--action-primary, #227ebd);\n  transform: scaleX(0);\n  transition: transform var(--dur-base, 160ms) var(--ease-out, ease-out);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab:hover {\n  color: var(--text-body, #243244);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.isActive,\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.sit-tab--active {\n  color: var(--text-strong, #142033);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.isActive::after,\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab.sit-tab--active::after {\n  transform: scaleX(1);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabs .sit-tab:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n  border-radius: var(--radius-sm, 6px);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerTabDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--amber-500, #f0ad4e);\n  box-shadow: 0 0 0 2px rgba(240, 173, 78, 0.18);\n}\n\n.cpDsSummary.sit-drawer .cpDrawerBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 22px 22px;\n  color: var(--text-body, #243244);\n  font-size: var(--text-md, 14px);\n  scrollbar-width: thin;\n  scrollbar-color: var(--slate-300, #cbd5e1) transparent;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerBody::-webkit-scrollbar {\n  width: 10px;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerBody::-webkit-scrollbar-thumb {\n  background: var(--slate-300, #cbd5e1);\n  border: 3px solid transparent;\n  border-radius: 999px;\n  background-clip: content-box;\n}\n\n.cpDsSummary.sit-drawer .cpDrawer .cpFooterBody {\n  padding: 0;\n}\n\n.cpDsSummary.sit-drawer .cpDrawer .cpFooterHeader {\n  margin-bottom: 14px;\n}\n\n.cpDsSummary.sit-drawer .cpDrawer .cpFooterGrid,\n.cpDsSummary.sit-drawer .cpDrawer .cpFooterGrid--clubs {\n  grid-template-columns: 1fr;\n}\n\n.cpDsSummary.sit-drawer .cpDrawer .cpBlock {\n  border-radius: var(--radius-md, 8px);\n  padding: 12px 14px;\n}\n\n.cpFieldsSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cpFieldsSummaryHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.cpFieldsSummaryIcon {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpFieldsSummaryIcon svg {\n  width: 21px;\n  height: 21px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.7;\n}\n\n.cpFieldsSummaryHeading {\n  min-width: 0;\n}\n\n.cpFieldsSummaryTitleRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cpFieldsSummaryTitleRow h2,\n.cpFieldsListHeader h3 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n}\n\n.cpFieldsSummaryTitleRow h2 {\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.cpFieldsSummaryHeading p,\n.cpFieldsListHeader p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.cpFieldsState {\n  min-height: 22px;\n  padding: 2px 8px;\n  border: 1px solid;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 750;\n}\n\n.cpFieldsState.isDraft {\n  border-color: #b9d8eb;\n  background: #eef7fd;\n  color: #155d8c;\n}\n\n.cpFieldsState.isLocked {\n  border-color: #d0d5dd;\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.cpFieldsSummaryStats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: #fff;\n}\n\n.cpFieldsSummaryStats > div {\n  min-width: 0;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cpFieldsSummaryStats > div + div {\n  border-left: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.cpFieldsSummaryStats strong {\n  color: var(--text-strong, #142033);\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.cpFieldsSummaryStats span {\n  overflow: hidden;\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpFieldsTemplate {\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  background: var(--slate-25, #f8fafc);\n}\n\n.cpFieldsTemplate span {\n  color: var(--text-muted, #69778a);\n  font-size: 10.5px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cpFieldsTemplate strong {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.cpFieldsLockedNotice {\n  padding: 11px 12px;\n  border: 1px solid #fedf89;\n  border-radius: 10px;\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  background: #fffaeb;\n  color: #93370d;\n}\n\n.cpFieldsLockedNotice > span {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  border: 1.5px solid currentColor;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.cpFieldsLockedNotice p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.cpFieldsListHeader {\n  padding-top: 2px;\n}\n\n.cpFieldsListHeader h3 {\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.cpFieldsSummaryList > .mt-3 {\n  margin-top: 0 !important;\n  counter-reset: cp-field;\n}\n\n.cpFieldsSummaryList .cpProgrammeFieldCard {\n  counter-increment: cp-field;\n  min-height: 0;\n  margin-top: 8px;\n  padding: 12px;\n  border-color: var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  box-shadow: none;\n}\n\n.cpFieldsSummaryList .cpProgrammeFieldCard:first-child {\n  margin-top: 0;\n}\n\n.cpFieldsSummaryList .cpProgrammeFieldCardBody {\n  position: relative;\n  padding: 0 0 0 34px;\n}\n\n.cpFieldsSummaryList .cpProgrammeFieldCardBody::before {\n  content: counter(cp-field);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eef2f6;\n  color: #475467;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.cpFieldsSummaryList .cpProgrammeFieldCardTitle {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.cpFieldsSummaryList .cpProgrammeFieldCardBadges {\n  margin-top: 7px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.cpFieldsSummaryList .cpBadge {\n  margin: 0;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 700;\n}\n\n.cpFieldsSummaryList .text-muted {\n  margin-top: 7px !important;\n  color: var(--text-muted, #69778a) !important;\n  font-size: 11.5px !important;\n  line-height: 1.4 !important;\n}\n\n.cpFieldsSummaryList .cpFieldsEmptyState {\n  margin-top: 0;\n  padding: 24px 18px;\n  border-color: #cfd8e3;\n  background: var(--slate-25, #f8fafc);\n  text-align: center;\n}\n\n.cpFieldsEditorButton {\n  width: 100%;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cpFieldsEditorButton:hover:not(:disabled) {\n  border-color: #17699e;\n  background: #17699e;\n}\n\n.cpFieldsEditorButton:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.cpFieldsEditorButton svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.cpProgrammeBooking {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cpProgrammeBookingHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.cpProgrammeBookingIcon {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpProgrammeBookingIcon svg,\n.cpProgrammeBookingArrow svg,\n.cpProgrammeBookingButton svg {\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.75;\n}\n\n.cpProgrammeBookingIcon svg {\n  width: 21px;\n  height: 21px;\n}\n\n.cpProgrammeBookingTitleRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cpProgrammeBookingTitleRow h2,\n.cpProgrammeBookingWorkflow h3 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n}\n\n.cpProgrammeBookingTitleRow h2 {\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.cpProgrammeBookingHeader p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.cpProgrammeBookingState {\n  min-height: 22px;\n  padding: 2px 8px;\n  border: 1px solid;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 750;\n}\n\n.cpProgrammeBookingState.isDraft {\n  border-color: #d0d5dd;\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.cpProgrammeBookingState.isActive {\n  border-color: #b9d8eb;\n  background: #eef7fd;\n  color: #155d8c;\n}\n\n.cpProgrammeBookingState.isCompleted {\n  border-color: #abefc6;\n  background: #ecfdf3;\n  color: #067647;\n}\n\n.cpProgrammeBookingWindow {\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 11px;\n  background: var(--slate-25, #f8fafc);\n}\n\n.cpProgrammeBookingWindowTitle {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cpProgrammeBookingWindowTitle > span {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.cpProgrammeBookingWindowTitle > strong {\n  color: var(--text-muted, #69778a);\n  font-size: 10.5px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cpProgrammeBookingDates {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 22px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n}\n\n.cpProgrammeBookingDates > div {\n  min-width: 0;\n}\n\n.cpProgrammeBookingDates > div > span {\n  display: block;\n  margin-bottom: 3px;\n  color: var(--text-muted, #69778a);\n  font-size: 10.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.cpProgrammeBookingDates > div > strong {\n  display: block;\n  color: var(--text-strong, #142033);\n  font-size: 12px;\n  font-weight: 750;\n  line-height: 1.4;\n}\n\n.cpProgrammeBookingArrow {\n  color: var(--text-subtle, #8a96a8);\n}\n\n.cpProgrammeBookingArrow svg {\n  width: 18px;\n  height: 18px;\n}\n\n.cpProgrammeBookingConfig {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 11px;\n  background: #fff;\n}\n\n.cpProgrammeBookingConfig > div {\n  min-height: 48px;\n  padding: 10px 13px;\n  display: grid;\n  grid-template-columns: minmax(120px, 0.8fr) minmax(0, 1.2fr);\n  align-items: center;\n  gap: 12px;\n}\n\n.cpProgrammeBookingConfig > div + div {\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n}\n\n.cpProgrammeBookingConfig span {\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  font-weight: 650;\n}\n\n.cpProgrammeBookingConfig strong {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n  font-weight: 750;\n  line-height: 1.35;\n  text-align: right;\n}\n\n.cpProgrammeBookingWorkflow {\n  padding-top: 2px;\n}\n\n.cpProgrammeBookingWorkflow h3 {\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.cpProgrammeBookingWorkflow > div {\n  position: relative;\n  min-height: 48px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.cpProgrammeBookingWorkflow > div:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  top: 27px;\n  bottom: 3px;\n  left: 11px;\n  width: 1px;\n  background: #dbe3ec;\n}\n\n.cpProgrammeBookingWorkflow > div > span {\n  position: relative;\n  z-index: 1;\n  flex: 0 0 auto;\n  width: 23px;\n  height: 23px;\n  border: 1px solid #b9d8eb;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eef7fd;\n  color: #155d8c;\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.cpProgrammeBookingWorkflow p {\n  margin: 1px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cpProgrammeBookingWorkflow p strong {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.cpProgrammeBookingWorkflow p small {\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  line-height: 1.35;\n}\n\n.cpProgrammeBookingButton {\n  width: 100%;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cpProgrammeBookingButton:hover {\n  border-color: #17699e;\n  background: #17699e;\n}\n\n.cpProgrammeBookingButton svg {\n  width: 17px;\n  height: 17px;\n}\n\n.cpProgrammeClubsSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.cpProgrammeClubsSummaryHeader h2 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.cpProgrammeClubsSummaryHeader p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n\n.cpProgrammeClubsNotice {\n  padding: 11px 12px;\n  border: 1px solid #fedf89;\n  border-radius: 10px;\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  background: #fffaeb;\n  color: #93370d;\n}\n\n.cpProgrammeClubsNotice > span {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  border: 1.5px solid currentColor;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.cpProgrammeClubsNotice p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.cpProgrammeClubsList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cpProgrammeClubCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 11px;\n  background: #fff;\n}\n\n.cpProgrammeClubCardTop {\n  min-height: 60px;\n  padding: 11px 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cpProgrammeClubIcon {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpProgrammeClubIcon svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.75;\n}\n\n.cpProgrammeClubIdentity {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.cpProgrammeClubIdentity h3 {\n  margin: 0;\n  overflow: hidden;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeClubIdentity p {\n  margin: 2px 0 0;\n  overflow: hidden;\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeClubState {\n  flex: 0 0 auto;\n  min-height: 22px;\n  padding: 2px 8px;\n  border: 1px solid;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 750;\n}\n\n.cpProgrammeClubState.isEnabled {\n  border-color: #abefc6;\n  background: #ecfdf3;\n  color: #067647;\n}\n\n.cpProgrammeClubState.isDisabled {\n  border-color: #d0d5dd;\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.cpProgrammeClubDetails {\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.cpProgrammeClubDetails > div {\n  min-width: 0;\n  padding: 10px 12px;\n}\n\n.cpProgrammeClubDetails > div:nth-child(even) {\n  border-left: 1px solid var(--border-subtle, #e7edf3);\n}\n\n.cpProgrammeClubDetails > div:nth-child(n + 3) {\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n}\n\n.cpProgrammeClubDetails span,\n.cpProgrammeClubDetails strong {\n  display: block;\n}\n\n.cpProgrammeClubDetails span {\n  margin-bottom: 3px;\n  color: var(--text-muted, #69778a);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.cpProgrammeClubDetails strong {\n  overflow: hidden;\n  color: var(--text-strong, #142033);\n  font-size: 11.5px;\n  font-weight: 700;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n}\n\n.cpProgrammeClubsEmpty {\n  padding: 28px 20px;\n  border: 1px dashed #cfd8e3;\n  border-radius: 11px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  background: var(--slate-25, #f8fafc);\n  text-align: center;\n}\n\n.cpProgrammeClubsEmpty strong {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n}\n\n.cpProgrammeClubsEmpty span {\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n\n.cpInvitePickerModal {\n  height: calc(100vh - 48px);\n}\n\n.cpInvitePickerModal .modal-content {\n  height: 100%;\n  max-height: none !important;\n  border-color: var(--border-subtle, #dbe3ec) !important;\n  border-radius: 16px !important;\n}\n\n.cpInvitePickerModal .modal-header {\n  flex: 0 0 auto;\n  min-height: 68px;\n  padding: 14px 20px !important;\n  background: #fff !important;\n  border-bottom-color: var(--border-subtle, #e7edf3) !important;\n}\n\n.cpInvitePickerModal .modal-body {\n  min-height: 0;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.cpInvitePickerTitle {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.cpInvitePickerTitle > span:first-child {\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n  font-size: 19px;\n  font-weight: 800;\n}\n\n.cpInvitePickerTitle > span:last-child:not(:first-child) {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 500;\n}\n\n.cpInvitePicker {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.cpInvitePickerBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  padding: 16px 20px 0;\n}\n\n.cpInvitePickerNotice,\n.cpInvitePickerError {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border: 1px solid;\n  border-radius: 9px;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.cpInvitePickerNotice {\n  border-color: #fedf89;\n  background: #fffaeb;\n  color: #93370d;\n}\n\n.cpInvitePickerError {\n  border-color: #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n}\n\n.cpInvitePickerEditor {\n  height: 100%;\n  min-height: 0;\n}\n\n.cpInvitePickerBody:has(.cpInvitePickerNotice) .cpInvitePickerEditor,\n.cpInvitePickerBody:has(.cpInvitePickerError) .cpInvitePickerEditor {\n  height: calc(100% - 64px);\n}\n\n.cpInvitePickerEditor .twoPanelEditor {\n  height: 100%;\n}\n\n.cpInvitePickerEditor .twoPanelEditor__desktopLayout,\n.cpInvitePickerEditor .twoPanelEditor__row {\n  height: 100%;\n}\n\n.cpInvitePickerEditor .twoPanelEditor--sourceFirst .twoPanelEditor__panelCol {\n  height: 100%;\n  min-height: 0;\n}\n\n.cpInvitePickerFooter {\n  flex: 0 0 auto;\n  min-height: 66px;\n  padding: 12px 20px;\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  background: #fff;\n}\n\n.cpInvitePickerFooter .sit-btn {\n  min-width: 104px;\n}\n\n.cpInvitePickerFooter .sit-btn--primary {\n  min-width: 148px;\n}\n\n.cpInvitePickerEditor .twoPanelEditor--sourceFirst .twoPanelEditorPanel__footer {\n  padding: 0;\n  border-top: 0;\n}\n\n.cpInvitePickerEditor .twoPanelEditor--sourceFirst .bPagination--modern {\n  min-height: 56px;\n  padding: 10px 14px;\n  border-width: 1px 0 0;\n  border-radius: 0;\n}\n\n.cpInvitePickerEditor .bPagination__pages button {\n  min-width: 32px;\n  height: 32px;\n  border-radius: 8px;\n}\n\n.cpInvitePickerDiscardModal .modal-footer .btn {\n  min-height: var(--control-h-md, 40px);\n  padding: 0 16px;\n  border-radius: var(--radius-md, 8px);\n  font-size: var(--text-md, 14px);\n  font-weight: var(--weight-semibold, 600);\n}\n\n.cpInvitePickerDiscardModal .modal-footer .btn-primary {\n  border-color: var(--red-600, #c4313f);\n  background: var(--red-600, #c4313f);\n}\n\n.cpInvitePickerDiscardModal .modal-footer .btn-secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--slate-0, #fff);\n  color: var(--text-body, #334155);\n}\n\n@media (max-width: 767px) {\n  .cpInvitePickerModal {\n    width: 100vw !important;\n    height: 100vh;\n    max-width: none !important;\n  }\n\n  .cpInvitePickerModal .modal-content {\n    border-radius: 0 !important;\n  }\n\n  .cpInvitePickerBody {\n    padding: 12px 14px 0;\n    overflow: auto;\n  }\n\n  .cpInvitePickerEditor {\n    min-height: 520px;\n  }\n\n  .cpInvitePickerFooter {\n    padding: 12px 14px;\n  }\n\n  .cpInvitePickerFooter .sit-btn {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .cpInvitePickerEditor .bPagination--modern {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 720px) {\n  .cpDsSummary.sit-drawer {\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n/* Activity programme drawer content */\n.cpDsSummary.sit-drawer {\n  width: 520px;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerLead {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #164170);\n}\n\n.cpDrawerStatus {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid transparent;\n}\n\n.cpDrawerStatus::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.cpDrawerStatus--draft {\n  background: var(--slate-100, #edf2f7);\n  border-color: var(--border-subtle, #dbe3ec);\n  color: var(--text-muted, #64748b);\n}\n\n.cpDrawerStatus--active {\n  background: var(--green-50, #e7f3ec);\n  border-color: #bfe6cd;\n  color: var(--green-700, #1f7a45);\n}\n\n.cpDrawerStatus--completed {\n  background: var(--blue-50, #eaf5fc);\n  border-color: #cfe6f5;\n  color: var(--blue-700, #155d8c);\n}\n\n.cpDrawerStatus--archived {\n  background: #f1effa;\n  border-color: #ddd6fe;\n  color: #5b4b9a;\n}\n\n.cpDrawerSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cpDrawerBookingWindow {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 13px 15px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--slate-25, #f8fafc);\n}\n\n.cpDrawerBookingIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: var(--blue-700, #164170);\n}\n\n.cpDrawerBookingContent {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.cpDrawerBookingLabel {\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.03em;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.cpDrawerBookingDates {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 3px;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-body, inherit);\n  font-size: 14px;\n  font-weight: 650;\n  line-height: 1.35;\n  font-variant-numeric: tabular-nums;\n  flex-wrap: wrap;\n}\n\n.cpDrawerBookingArrow {\n  display: inline-flex;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpDrawerFieldList {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--surface-card, #ffffff);\n  overflow: hidden;\n}\n\n.cpDrawerFieldRow {\n  display: grid;\n  grid-template-columns: minmax(138px, 0.78fr) minmax(0, 1fr);\n  gap: 14px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n}\n\n.cpDrawerFieldRow:last-child {\n  border-bottom: 0;\n}\n\n.cpDrawerFieldLabel {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 650;\n  line-height: 1.35;\n}\n\n.cpDrawerFieldValue {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 650;\n  line-height: 1.4;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.cpDrawerLockNote {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.cpDrawerInfoNote {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 11px;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.cpDrawerInfoNote > span:first-child {\n  display: inline-flex;\n  flex: 0 0 auto;\n}\n\n.cpDsSummary.sit-drawer .cpDrawerFoot {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 10px;\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--slate-25, #f8fafc);\n}\n\n.cpDrawerActionBtn {\n  flex: 1 1 auto;\n  height: 40px;\n  gap: 8px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13.5px;\n  font-weight: 700;\n}\n\n.cpDrawerActionBtn svg {\n  flex: 0 0 auto;\n}\n\n@media (max-width: 720px) {\n  .cpDrawerFieldRow {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n\n  .cpDsSummary.sit-drawer .cpDrawerFoot {\n    flex-direction: column;\n  }\n}\n\n/* DS add-clubs page controls */\n.cpToolbarActions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.cpAddClubsColumnsMenu {\n  z-index: 10;\n}\n\n.sit-cols {\n  position: relative;\n  display: inline-flex;\n}\n\n.sit-cols__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #243244);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease;\n}\n\n.sit-cols__btn:hover {\n  border-color: var(--border-strong, #aab7c6);\n  background: var(--surface-hover, #f5f8fb);\n}\n\n.sit-cols__btn--open {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef7fd);\n  color: var(--blue-700, #155d8c);\n}\n\n.sit-cols__badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--blue-100, #dceffc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.sit-cols__pop {\n  position: absolute;\n  top: calc(100% + 6px);\n  z-index: 1200;\n  width: 244px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.16);\n  animation: sit-cols-in 0.16s ease-out;\n}\n\n.sit-cols__pop--right {\n  right: 0;\n}\n\n@keyframes sit-cols-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.sit-cols__hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px 8px;\n}\n\n.sit-cols__title {\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.sit-cols__reset {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #227ebd);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.sit-cols__reset:hover {\n  text-decoration: underline;\n}\n\n.sit-cols__list {\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.sit-cols__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-body, #243244);\n  font: inherit;\n  font-size: 13.5px;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n}\n\n.sit-cols__item:hover {\n  background: var(--surface-hover, #f5f8fb);\n}\n\n.sit-cols__item--locked {\n  color: var(--text-subtle, #8896a8);\n  cursor: default;\n}\n\n.sit-cols__item--locked:hover {\n  background: transparent;\n}\n\n.sit-cols__lock {\n  margin-left: auto;\n  color: var(--text-subtle, #8896a8);\n}\n\n.sit-cols__cb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 17px;\n  height: 17px;\n  flex: 0 0 auto;\n  border: 1.5px solid var(--border-strong, #aab7c6);\n  border-radius: 4px;\n  background: var(--surface-card, #fff);\n  transition: background 0.16s ease, border-color 0.16s ease;\n}\n\n.sit-cols__cb svg {\n  width: 12px;\n  height: 12px;\n  fill: none;\n  stroke: #fff;\n  stroke-width: 3;\n  opacity: 0;\n}\n\n.sit-cols__item[data-on='true'] .sit-cols__cb {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n.sit-cols__item[data-on='true'] .sit-cols__cb svg {\n  opacity: 1;\n}\n\n.cpAddClubsSelectWrap {\n  position: relative;\n}\n\n.cpAddClubsSelectionBtn {\n  height: 38px;\n}\n\n.cpAddClubsSelectionBtn input {\n  pointer-events: none;\n}\n\n.cpAddClubsChevron {\n  margin-left: 2px;\n  color: var(--text-muted, #69778a);\n}\n\n.cpAddClubsSelectMenu {\n  min-width: 260px;\n}\n\n.cpAddClubsMenuItem {\n  display: block;\n  width: 100%;\n  padding: 7px 9px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-body, #243244);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 650;\n  text-align: left;\n}\n\n.cpAddClubsMenuItem:hover:not(:disabled) {\n  background: var(--surface-hover, #f5f8fb);\n}\n\n.cpAddClubsMenuItem:disabled {\n  opacity: 0.48;\n}\n\n.cpAddClubsMenuDivider {\n  height: 1px;\n  margin: 6px 0;\n  background: var(--border-subtle, #dbe3ec);\n}\n\n.cpAddClubsPrimaryBtn {\n  min-width: 178px;\n}\n\n.cpAddClubsRange {\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.cpAddClubsSelectCol {\n  width: 42px;\n  min-width: 42px;\n  max-width: 42px;\n  text-align: center;\n}\n\n.cpAddClubsTable th,\n.cpAddClubsTable td {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n\n.cpAddClubsTable .cpAddClubsSelectCol {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n\n.cpAddClubsClubName {\n  display: block;\n  overflow: hidden;\n  color: var(--text-strong, #142033);\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpAddClubsBadges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cpAddClubsLoader {\n  padding: 16px;\n}\n\n.cpAddClubsEmpty {\n  padding: 14px 12px;\n}\n\n@media (max-width: 820px) {\n  .cpToolbarRowDs {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .cpToolbarActions {\n    order: 3;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .sit-cols,\n  .sit-cols__btn {\n    width: 100%;\n  }\n\n  .sit-cols__btn {\n    justify-content: center;\n  }\n}\n\n/* Manage clubs add-clubs modal */\n.cpAddClubsModalBody {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  padding: 18px 20px !important;\n  font-weight: 400 !important;\n}\n\n.cpAddClubsModalBody > .cpModalShell {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.cpAddClubsModalIntro {\n  margin-bottom: 12px;\n  color: var(--text-muted, #69778a);\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n\n.cpManageAddClubsBtn {\n  min-width: 104px;\n}\n\n/* Manage clubs page layout */\n.cpManageClubsLayout {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);\n  gap: 14px;\n  align-items: start;\n  overflow: hidden;\n}\n\n.cpManageClubsMainPane,\n.cpManageClubsSummaryPane {\n  min-width: 0;\n  min-height: 0;\n}\n\n.cpManageClubsMainPane {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cpManageClubsMainPane .cpDataTableShell {\n  flex: 1 1 auto;\n  min-height: 260px;\n}\n\n.cpManageClubsSummaryPane {\n  max-height: 100%;\n  overflow: auto;\n}\n\n.cpManageClubsLoading {\n  min-height: 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n}\n\n@media (max-width: 1180px) {\n  .cpManageClubsLayout {\n    grid-template-columns: 1fr;\n    overflow: visible;\n  }\n\n  .cpManageClubsMainPane,\n  .cpManageClubsSummaryPane {\n    overflow: visible;\n  }\n}\n\n/* Programme clubs manage screen (ProgrammeClubs.dc.html) */\n.pc-scroll {\n  scrollbar-color: rgba(105, 119, 138, 0.45) transparent;\n}\n\n.pcProgrammeClubsPage {\n  min-height: 100vh;\n  overflow: auto;\n  background: var(--surface-page, #f4f7fb);\n  color: var(--text-body, #243244);\n  font-family: var(--font-body, Inter, Arial, sans-serif);\n}\n\n.pcProgrammeClubsHeader {\n  padding: 22px 28px 18px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--surface-card, #fff);\n}\n\n.pcBackLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 10px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--brand-600, #227ebd);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.pcProgrammeClubsHeaderMain {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.pcProgrammeClubsTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pcProgrammeClubsTitle {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, Inter, Arial, sans-serif);\n  font-size: 28px;\n  font-weight: 800;\n  line-height: 1.15;\n}\n\n.pcProgrammeClubsSubtitle {\n  margin-top: 6px;\n  color: var(--text-muted, #69778a);\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.pcProgrammeClubsBody {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  max-width: 1220px;\n  margin: 0 auto;\n  padding: 18px 24px 60px;\n}\n\n.pcToolbar,\n.pcFilterBar,\n.pcSelectionBar,\n.pcCard {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n}\n\n.pcToolbar {\n  padding: 14px 16px;\n}\n\n.pcToolbarTop,\n.pcToolbarControls,\n.pcSelectionBar,\n.pcSelectionActions,\n.pcPagination,\n.pcClubCell,\n.pcStatusToggle,\n.pcDrawerMeta,\n.pcMetricStrip,\n.pcInviteSwitchRow {\n  display: flex;\n  align-items: center;\n}\n\n.pcToolbarTop {\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.pcToolbarTitle {\n  color: var(--text-strong, #142033);\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.pcToolbarCount {\n  margin-top: 2px;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.pcToolbarControls {\n  gap: 10px;\n}\n\n.pcSearchBox {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex: 1 1 auto;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 9px;\n  background: var(--slate-50, #f5f8fb);\n}\n\n.pcSearchBox input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #142033);\n  font: inherit;\n  font-size: 13.5px;\n}\n\n.pcFilterBar {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 12px 16px;\n}\n\n.pcFilterBar label {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  color: var(--text-body, #243244);\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pcFilterBar input,\n.pcCheckbox {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--brand-600, #227ebd);\n}\n\n.pcSelectionBar {\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  background: var(--brand-25, #f5f9fd);\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 700;\n}\n\n.pcSelectionActions,\n.pcPagination {\n  gap: 8px;\n}\n\n.pcButton,\n.pcIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pcButton {\n  gap: 8px;\n  min-height: 38px;\n  padding: 0 13px;\n}\n\n.pcButton:disabled,\n.pcIconBtn:disabled {\n  cursor: default;\n  opacity: 0.48;\n}\n\n.pcButton--primary {\n  border-color: var(--brand-600, #227ebd);\n  background: var(--brand-600, #227ebd);\n  color: #fff;\n}\n\n.pcButton--secondary {\n  border-color: var(--border-default, #cfd8e3);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #243244);\n}\n\n.pcButton--ghost {\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n}\n\n.pcButton--danger {\n  border-color: var(--red-200, #f3c3c3);\n  background: var(--red-50, #fff1f1);\n  color: var(--red-700, #b42318);\n}\n\n.pcIconBtn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #69778a);\n}\n\n.pcCard--flush {\n  overflow: hidden;\n}\n\n.pcDataTable {\n  width: 100%;\n  margin: 0;\n  border-collapse: separate;\n  border-spacing: 0;\n  color: var(--text-body, #243244);\n  font-size: 13.5px;\n}\n\n.pcDataTable th {\n  height: 42px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--slate-25, #f8fafc);\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.pcDataTable td {\n  height: 58px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  vertical-align: middle;\n}\n\n.pcDataTable tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.pcDataTableRow {\n  cursor: pointer;\n}\n\n.pcDataTableRow:hover,\n.pcDataTableRow--selected {\n  background: var(--brand-25, #f5f9fd);\n}\n\n.pcTableSelectCol {\n  width: 44px;\n  min-width: 44px;\n  text-align: center !important;\n}\n\n.pcClubCell {\n  gap: 11px;\n  min-width: 0;\n}\n\n.pcClubIcon,\n.pcDrawerLead {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: var(--blue-50, #eef7fd);\n  color: var(--brand-600, #227ebd);\n}\n\n.pcClubText {\n  min-width: 0;\n}\n\n.pcClubName,\n.pcClubSport {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pcClubName {\n  color: var(--text-strong, #142033);\n  font-weight: 700;\n}\n\n.pcClubSport,\n.pcWhenCell small,\n.pcDrawerHint,\n.pcDrawerMutedNote {\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n}\n\n.pcWhenCell {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.3;\n}\n\n.pcWhenCell span,\n.pcNumberCell {\n  color: var(--text-strong, #142033);\n  font-weight: 600;\n}\n\n.pcSearchIcon,\n.pcRunIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #69778a);\n}\n\n.pcRunIcon {\n  width: 34px;\n  height: 34px;\n  flex: 0 0 auto;\n  border-radius: 9px;\n  background: var(--blue-50, #eef7fd);\n  color: var(--brand-600, #227ebd);\n}\n\n.pcTablePlainText,\n.pcTableMutedText {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.pcDsChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 22px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.pcDsChip--info {\n  background: var(--blue-50, #eef7fd);\n  color: var(--brand-600, #227ebd);\n}\n\n.pcDsChip--warning {\n  background: var(--amber-50, #fdf6e3);\n  color: var(--amber-700, #9a6a00);\n}\n\n.pcInvitesCell {\n  display: inline-flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.pcBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 22px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.pcBadge--success {\n  background: var(--green-50, #eaf8ef);\n  color: var(--green-700, #147a3d);\n}\n\n.pcBadge--neutral {\n  background: var(--slate-100, #eef2f6);\n  color: var(--text-muted, #69778a);\n}\n\n.pcBadge--dot::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: currentColor;\n}\n\n.pcStatusToggle {\n  margin: 0;\n  cursor: pointer;\n}\n\n.pcStatusToggle input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.pcDataTableEmpty,\n.pcProgrammeClubsLoading,\n.pcProgrammeClubsEmptyState {\n  padding: 30px;\n  color: var(--text-muted, #69778a);\n  font-size: 13.5px;\n  text-align: center;\n}\n\n.pcPagination {\n  justify-content: flex-end;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.pcReadonly,\n.pcErrorText {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.pcReadonly {\n  color: var(--text-muted, #69778a);\n}\n\n.pcReadonlyIcon {\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n.pcReadonlyIcon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.pcErrorText {\n  color: var(--red-700, #b42318);\n}\n\n.pcDrawerOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 160;\n  display: flex;\n  justify-content: flex-end;\n  background: rgba(15, 23, 42, 0.32);\n}\n\n.pcDrawerSheet {\n  display: flex;\n  flex-direction: column;\n  width: min(520px, 100vw);\n  height: 100vh;\n  background: var(--surface-card, #fff);\n  box-shadow: -24px 0 60px rgba(15, 23, 42, 0.2);\n}\n\n.pcDrawerHead {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 18px 20px 15px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.pcDrawerLead {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n}\n\n.pcDrawerTitles {\n  flex: 1;\n  min-width: 0;\n}\n\n.pcDrawerTitle {\n  overflow: hidden;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, Inter, Arial, sans-serif);\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pcDrawerMeta {\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-top: 7px;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n\n.pcDrawerMeta i {\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: var(--border-strong, #aab7c6);\n}\n\n.pcDrawerClose {\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 9px;\n  background: var(--slate-50, #f5f8fb);\n  color: var(--text-muted, #69778a);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pcDrawerTabs {\n  display: flex;\n  gap: 18px;\n  padding: 0 20px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.pcDrawerTabs button {\n  position: relative;\n  height: 46px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.pcDrawerTabs button.isActive {\n  color: var(--brand-600, #227ebd);\n}\n\n.pcDrawerTabs button.isActive::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  border-radius: 999px 999px 0 0;\n  background: var(--brand-600, #227ebd);\n}\n\n.pcDrawerBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 16px 20px;\n}\n\n.pcDrawerFoot {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 10px;\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--slate-25, #f8fafc);\n}\n\n.pcDrawerFoot > * {\n  flex: 1 1 auto;\n}\n.pcDrawerPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.pcRunCard,\n.pcInviteSwitchRow,\n.pcMetricStrip,\n.pcMetricGrid > div,\n.pcSegment {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--slate-25, #f8fafc);\n}\n\n.pcRunCard {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 13px 15px;\n}\n\n.pcRunLabel,\n.pcDrawerKicker,\n.pcDrawerFieldRow span,\n.pcMetricGrid small {\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.pcRunValue,\n.pcDrawerStrong {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.pcDrawerFieldList {\n  display: flex;\n  flex-direction: column;\n}\n\n.pcDrawerFieldRow {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 11px 0;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.pcDrawerFieldRow:last-child {\n  border-bottom: 0;\n}\n\n.pcDrawerFieldRow b {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 550;\n}\n\n.pcDrawerWarnNote,\n.pcDrawerInfoNote,\n.pcDrawerMutedNote {\n  padding: 11px 14px;\n  border-radius: 11px;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.pcDrawerWarnNote {\n  background: var(--amber-50, #fdf6e3);\n  color: var(--amber-700, #9a6a00);\n  font-weight: 600;\n}\n\n.pcDrawerInfoNote,\n.pcDrawerMutedNote {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--slate-50, #f5f8fb);\n}\n\n.pcSegmentGroup {\n  display: flex;\n  gap: 10px;\n}\n\n.pcSegment {\n  flex: 1;\n  padding: 12px 14px;\n  text-align: left;\n}\n\n.pcSegment--active {\n  border-color: var(--brand-400, #7db4e0);\n  background: var(--brand-25, #f5f9fd);\n}\n\n.pcSegment span,\n.pcSegment small {\n  display: block;\n}\n\n.pcSegment span {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 700;\n}\n\n.pcSegment small {\n  margin-top: 5px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n}\n\n.pcMetricStrip {\n  gap: 16px;\n  padding: 12px 15px;\n}\n\n.pcMetricGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.pcMetricGrid > div {\n  padding: 13px 15px;\n}\n\n.pcMetricGrid b {\n  display: block;\n  margin-top: 4px;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, Inter, Arial, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.pcInviteSwitchRow {\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 15px;\n  background: var(--surface-card, #fff);\n}\n\n.pcSwitch {\n  width: 38px;\n  height: 22px;\n  accent-color: var(--brand-600, #227ebd);\n}\n\n.pcIcon::before {\n  display: inline-block;\n  width: 1em;\n  text-align: center;\n}\n\n.pcIcon--back::before {\n  content: '‹';\n  font-size: 18px;\n  line-height: 0;\n}\n.pcIcon--plus::before {\n  content: '+';\n  font-size: 18px;\n  font-weight: 800;\n}\n.pcIcon--filter::before {\n  content: '≡';\n  transform: rotate(90deg);\n}\n.pcIcon--search::before {\n  content: '⌕';\n}\n.pcIcon--lock::before {\n  content: '▣';\n}\n.pcIcon--calendar::before {\n  content: '□';\n}\n.pcIcon--list::before {\n  content: '☷';\n}\n.pcIcon--mail::before {\n  content: '✉';\n}\n.pcIcon--whistle::before {\n  content: '◌';\n}\n\n@media (max-width: 760px) {\n  .pcProgrammeClubsHeaderMain,\n  .pcToolbarControls,\n  .pcFilterBar,\n  .pcSelectionBar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .pcProgrammeClubsBody {\n    padding: 14px 12px 48px;\n  }\n\n  .pcDataTable {\n    min-width: 980px;\n  }\n\n  .pcCard--flush {\n    overflow-x: auto;\n  }\n}\n\n/* Add clubs compact modal (ProgrammeClubs.dc.html) */\n.pcAddModalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 180;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.42);\n}\n\n.pcAddModalPanel {\n  display: flex;\n  flex-direction: column;\n  width: min(620px, 94vw);\n  max-height: 86vh;\n  overflow: hidden;\n  border-radius: 16px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.28);\n}\n\n.pcAddModalHead {\n  padding: 18px 22px 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.pcAddModalTitleRow,\n.pcAddModalSearch,\n.pcAddClubRow,\n.pcAddModalFoot,\n.pcAddModalActions {\n  display: flex;\n  align-items: center;\n}\n\n.pcAddModalTitleRow,\n.pcAddModalFoot {\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pcAddModalTitle {\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, Inter, Arial, sans-serif);\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.pcAddModalClose {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 9px;\n  background: var(--slate-50, #f5f8fb);\n  color: var(--text-muted, #69778a);\n  font: inherit;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pcAddModalSearch {\n  gap: 9px;\n  height: 38px;\n  margin-top: 12px;\n  padding: 0 12px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 9px;\n  background: var(--slate-50, #f5f8fb);\n}\n\n.pcAddModalSearchIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #69778a);\n}\n.pcAddModalSearch input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #142033);\n  font: inherit;\n  font-size: 13.5px;\n}\n\n.pcAddModalList {\n  flex: 1 1 auto;\n  min-height: 180px;\n  overflow-y: auto;\n  padding: 14px 22px;\n}\n\n.pcAddClubRow {\n  gap: 12px;\n  margin: 0 0 8px;\n  padding: 11px 13px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 11px;\n  background: var(--surface-card, #fff);\n  cursor: pointer;\n}\n\n.pcAddClubRow--selected {\n  border-color: var(--brand-300, #a9cdea);\n  background: var(--brand-25, #f5f9fd);\n}\n\n.pcAddClubRow input {\n  flex: 0 0 auto;\n  width: 17px;\n  height: 17px;\n  accent-color: var(--brand-600, #227ebd);\n}\n\n.pcAddClubIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: var(--blue-50, #eef7fd);\n  color: var(--brand-600, #227ebd);\n}\n\n.pcAddClubText {\n  flex: 1;\n  min-width: 0;\n}\n\n.pcAddClubName,\n.pcAddClubMeta {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pcAddClubName {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.pcAddClubMeta {\n  margin-top: 1px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n}\n\n.pcAddModalFoot {\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.pcAddModalSelected {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n\n.pcAddModalActions {\n  gap: 10px;\n}\n\n.pcAddModalEmpty,\n.pcAddModalError {\n  padding: 30px;\n  color: var(--text-muted, #69778a);\n  font-size: 13.5px;\n  text-align: center;\n}\n\n.pcAddModalError {\n  margin-bottom: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: var(--red-50, #fff1f1);\n  color: var(--red-700, #b42318);\n  text-align: left;\n}\n\n@media (max-width: 560px) {\n  .pcAddModalOverlay {\n    align-items: stretch;\n    padding: 0;\n  }\n\n  .pcAddModalPanel {\n    width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .pcAddModalFoot {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .pcAddModalActions {\n    justify-content: flex-end;\n  }\n}\n\n.pcToolbar--inline {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n}\n\n.pcToolbarTitleWrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.pcToolbarCountChip,\n.pcButtonBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--slate-100, #eef2f6);\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.pcSearchBox--inline {\n  flex: 1 1 320px;\n  max-width: 430px;\n}\n\n.pcIconAction {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  flex: 0 0 auto;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #69778a);\n  cursor: pointer;\n}\n\n.pcIconAction:hover,\n.pcIconAction--on {\n  border-color: var(--brand-300, #a9cdea);\n  color: var(--brand-600, #227ebd);\n}\n\n.pcColumnsMenuWrap {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.pcButton--columns {\n  min-width: 118px;\n}\n\n.pcColumnsMenu {\n  position: absolute;\n  top: calc(100% + 2px);\n  right: 0;\n  z-index: 35;\n  min-width: 248px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);\n}\n\n.pcColumnsMenuHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.pcColumnsMenuHead button {\n  border: 0;\n  background: transparent;\n  color: var(--brand-600, #227ebd);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.pcColumnsMenuItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 34px;\n  padding: 7px 8px;\n  border-radius: 6px;\n  color: var(--text-body, #243244);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pcColumnsMenuItem:hover {\n  background: var(--slate-50, #f5f8fb);\n}\n\n.pcColumnsMenuItem--locked {\n  color: var(--text-subtle, #94a3b8);\n  cursor: default;\n}\n\n.pcColumnsMenuItem input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--brand-600, #227ebd);\n}\n\n.pcPagination--pages {\n  margin-top: 14px;\n}\n\n.pcPaginationSummary {\n  margin-right: 4px;\n}\n\n.pcPaginationEllipsis {\n  min-width: 18px;\n  text-align: center;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.pcPageBtn {\n  min-width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #243244);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pcPageBtn:hover {\n  border-color: var(--brand-300, #a9cdea);\n  color: var(--brand-700, #155d8c);\n}\n\n.pcPageBtn--active {\n  border-color: var(--brand-600, #227ebd);\n  background: var(--brand-600, #227ebd);\n  color: #fff;\n}\n\n.pcDrawerDisableButton {\n  min-width: 132px;\n  height: 38px;\n  border-radius: 9px;\n  border-color: var(--border-default, #cfd8e3);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #243244);\n}\n\n@media (max-width: 900px) {\n  .pcToolbar--inline {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .pcToolbarTitleWrap {\n    width: 100%;\n  }\n\n  .pcSearchBox--inline {\n    max-width: none;\n  }\n}\n\n.pcDrawerButton {\n  --_h: var(--control-h-md, 38px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: var(--_h);\n  padding: 0 16px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 8px);\n  font-family: var(--font-body, 'Public Sans', Inter, Arial, sans-serif);\n  font-size: var(--text-md, 14px);\n  font-weight: var(--weight-semibold, 600);\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  transition: background var(--dur-base, 160ms) var(--ease-out, ease-out),\n    border-color var(--dur-base, 160ms) var(--ease-out, ease-out),\n    color var(--dur-base, 160ms) var(--ease-out, ease-out), box-shadow var(--dur-base, 160ms) var(--ease-out, ease-out),\n    transform var(--dur-fast, 100ms) var(--ease-out, ease-out);\n}\n\n.pcDrawerButton:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.22));\n}\n\n.pcDrawerButton:active {\n  transform: translateY(0.5px);\n}\n\n.pcDrawerButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.pcDrawerButtonIcon {\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n.pcDrawerButtonIcon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.pcDrawerButton--primary {\n  background: var(--action-primary, #227ebd);\n  color: var(--text-on-brand, #fff);\n}\n\n.pcDrawerButton--primary:hover {\n  background: var(--action-primary-hover, #1d6fa8);\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);\n}\n\n.pcDrawerButton--primary:active {\n  background: var(--action-primary-active, #155d8c);\n  box-shadow: none;\n}\n\n.pcDrawerButton--secondary {\n  background: var(--slate-0, #fff);\n  color: var(--text-body, #243244);\n  border-color: var(--border-default, #cfd8e3);\n}\n\n.pcDrawerButton--secondary:hover {\n  background: var(--surface-hover, #eef2f6);\n  border-color: var(--border-strong, #aab7c6);\n}\n\n.pcDrawerButton--secondary:active {\n  background: var(--surface-active, #e2e8f0);\n}\n.pcBookingFormTab {\n  gap: 16px;\n}\n\n.pcBookingFormTab .pcSegment {\n  appearance: none;\n  display: block;\n  border: 1.5px solid var(--border-default, #cfd8e3);\n  background: var(--surface-card, #fff);\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n}\n\n.pcBookingFormTab .pcSegment:disabled {\n  cursor: default;\n}\n\n.pcBookingFormTab .pcSegment--active {\n  border-color: var(--brand-400, #7db4e0);\n  background: var(--brand-25, #f5f9fd);\n}\n\n.pcSegmentHead {\n  display: flex !important;\n  align-items: center;\n  gap: 8px;\n}\n\n.pcSegmentHead i {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border-default, #cfd8e3);\n  border-radius: 50%;\n  flex: 0 0 16px;\n}\n\n.pcSegment--active .pcSegmentHead i {\n  border-color: var(--brand-600, #227ebd);\n}\n\n.pcSegment--active .pcSegmentHead i::after {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--brand-600, #227ebd);\n  content: '';\n}\n\n.pcSegmentHead b {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.pcBookingFormTab .pcSegment small {\n  margin-left: 24px;\n  line-height: 1.4;\n}\n\n.pcBookingFormHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: -7px;\n}\n\n.pcBookingFormHeader > div {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.pcGhostMiniButton,\n.pcMiniButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: var(--control-h-sm, 30px);\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 8px);\n  padding: 0 12px;\n  font-family: var(--font-body, 'Public Sans', Inter, Arial, sans-serif);\n  font-size: var(--text-sm, 12.5px);\n  font-weight: var(--weight-semibold, 600);\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.pcGhostMiniButton,\n.pcMiniButton--ghost {\n  background: transparent;\n  color: var(--text-body, #243244);\n}\n\n.pcGhostMiniButton:hover,\n.pcMiniButton--ghost:hover {\n  background: var(--surface-hover, #eef2f6);\n}\n\n.pcMiniButton--secondary {\n  border-color: var(--border-default, #cfd8e3);\n  background: var(--slate-0, #fff);\n  color: var(--text-body, #243244);\n}\n\n.pcMiniButton--secondary:hover {\n  border-color: var(--border-strong, #aab7c6);\n  background: var(--surface-hover, #eef2f6);\n}\n\n.pcBookingMetrics {\n  display: flex;\n  align-items: center;\n  margin-bottom: -4px;\n}\n\n.pcBookingMetrics span {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.35;\n}\n\n.pcBookingMetrics b {\n  color: var(--text-strong, #142033);\n  font-weight: 800;\n}\n\n.pcFormElementList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pcFormQuestionRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 42px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n}\n\n.pcFormQuestionIndex {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 7px;\n  flex: 0 0 26px;\n  background: var(--slate-100, #eef2f6);\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.pcFormQuestionRow > .pcFormQuestionTitle {\n  flex: 1 1 auto;\n  min-width: 0;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.pcFormQuestionRow em,\n.pcFormQuestionRow i {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  min-height: 22px;\n  border-radius: 999px;\n  padding: 3px 8px;\n  font-size: 11.5px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.pcFormQuestionRow em {\n  background: var(--blue-50, #eaf4fb);\n  color: var(--brand-700, #1b668f);\n}\n\n.pcFormQuestionRow i {\n  background: var(--amber-50, #fdf6e3);\n  color: var(--amber-700, #9a6a00);\n}\n\n.pcFormPageBreak {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 2px 0;\n}\n\n.pcFormPageBreak span {\n  flex: 1 1 auto;\n  border-top: 2px dashed var(--border-default, #cfd8e3);\n}\n\n.pcFormPageBreak b,\n.pcFormContentRow {\n  color: var(--text-subtle, #8a97a8);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.pcFormContentRow {\n  padding-top: 4px;\n}\n\n.pcFormEmptyState {\n  padding: 26px 20px;\n  text-align: center;\n  border: 1px dashed var(--border-default, #cfd8e3);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n}\n\n.pcFormEmptyIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 11px;\n  border-radius: 12px;\n  background: var(--slate-100, #e9eef5);\n  color: var(--text-subtle, #8a97a8);\n}\n\n.pcFormEmptyTitle {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.pcFormEmptyText {\n  max-width: 320px;\n  margin: 4px auto 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.pcFormEmptyActions {\n  display: flex;\n  justify-content: center;\n  gap: 9px;\n  margin-top: 14px;\n}\n\n/* Programme bookings allocation board - design system */\n.pbPageHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 20px 28px 16px;\n  background: var(--surface-card, #ffffff);\n  border-bottom: 1px solid var(--border-subtle, #e5e7eb);\n}\n\n.pbBackLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 10px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--brand-600, #227ebd);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pbPageTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pbPageTitleRow h1 {\n  margin: 0;\n  font-family: var(--font-display, inherit);\n  font-size: 23px;\n  font-weight: 800;\n  line-height: 1.18;\n  color: var(--text-strong, #0f172a);\n}\n\n.pbHeaderStatus {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #e7f3ec;\n  color: #1f7a45;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pbPageMeta {\n  margin-top: 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 13.5px;\n}\n\n.pbHeaderPrimaryButton,\n.pbConfirmProgrammeButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 34px;\n  padding: 0 14px;\n  border: 0;\n  border-radius: 8px;\n  background: var(--brand-600, #227ebd);\n  color: #ffffff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pbHeaderPrimaryButton:disabled,\n.pbConfirmProgrammeButton:disabled {\n  background: #e2e8f0;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.pbBoardPage {\n  min-height: 100vh;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n}\n\n.pbControlBar {\n  position: sticky;\n  top: 0;\n  z-index: 30;\n  padding: 12px 28px;\n  background: var(--surface-card, #ffffff);\n  border-bottom: 1px solid var(--border-subtle, #e5e7eb);\n}\n\n.pbControlBarInner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pbControlDivider {\n  width: 1px;\n  height: 24px;\n  background: var(--border-subtle, #e5e7eb);\n}\n\n.pbControlLabel {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.pbControlHint {\n  margin-left: auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n}\n\n.pbHelpButton {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #cfe4f5;\n  border-radius: 50%;\n  background: #eaf4fb;\n  color: var(--brand-600, #227ebd);\n  font-size: 13px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.pbConfirmDayButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 13px;\n  border: 1px solid #9dd3b0;\n  border-radius: 8px;\n  background: #e7f3ec;\n  color: #1f7a45;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.pbConfirmDayButton:disabled {\n  border-color: #e2e8f0;\n  background: #f8fafc;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.pbMenuWrap {\n  position: relative;\n  display: inline-block;\n}\n.pbMenuButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #ffffff);\n  color: var(--text-body, #334155);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.pbMenuButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.pbMenuDropdown {\n  position: absolute;\n  top: 38px;\n  right: 0;\n  z-index: 50;\n  min-width: 220px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);\n}\n.pbMenuItem {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  text-align: left;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n.pbMenuItem:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n.pbMenuItem:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pbDayTabs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 14px 28px 4px;\n}\n.pbDayTab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 38px;\n  padding: 0 15px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 10px;\n  background: #ffffff;\n  color: var(--text-body, #334155);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 650;\n  cursor: pointer;\n}\n.pbDayTab--active {\n  border-color: transparent;\n  background: var(--brand-600, #227ebd);\n  color: #ffffff;\n}\n.pbDayTabCount,\n.pbClubColumnCount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  color: #64748b;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n.pbDayTab--active .pbDayTabCount {\n  background: rgba(255, 255, 255, 0.22);\n  color: #fff;\n}\n.pbDayTabConflict {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #da4453;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.pbInfoBanner,\n.pbLockedBanner,\n.pbErrorBanner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 8px 28px 0;\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n.pbInfoBanner {\n  border: 1px solid #cfe4f5;\n  background: #eaf4fb;\n  color: #1c5f8f;\n}\n.pbLockedBanner {\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n}\n.pbErrorBanner {\n  border: 1px solid #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n.pbInfoIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid currentColor;\n  font-weight: 800;\n}\n\n.pbTopScroll {\n  overflow-x: auto;\n  overflow-y: hidden;\n  height: 20px;\n  margin: 8px 28px 0;\n}\n.pbBoardScroll {\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 14px 28px 24px;\n}\n.pbBoardColumns {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 100%;\n}\n.pb-scroll::-webkit-scrollbar {\n  width: 10px;\n  height: 12px;\n}\n.pb-scroll::-webkit-scrollbar-thumb {\n  background: rgba(15, 23, 42, 0.2);\n  border: 3px solid transparent;\n  border-radius: 999px;\n  background-clip: content-box;\n}\n.pb-col::-webkit-scrollbar {\n  width: 8px;\n}\n.pb-col::-webkit-scrollbar-thumb {\n  background: rgba(15, 23, 42, 0.14);\n  border-radius: 999px;\n}\n\n.pbClubColumn {\n  flex: 0 0 326px;\n  width: 326px;\n}\n.pbClubColumnInner {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: 14px;\n  background: var(--surface-card, #ffffff);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n.pbClubColumnHeader {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 13px 14px 12px;\n  border-bottom: 1px solid var(--border-subtle, #e5e7eb);\n  background: var(--surface-card, #ffffff);\n  box-shadow: none;\n}\n.pbClubColumnTitleRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n.pbClubColumnTitleMain {\n  min-width: 0;\n}\n.pbClubColumnName {\n  color: var(--text-strong, #0f172a);\n  font-size: 15px;\n  font-weight: 750;\n  line-height: 1.25;\n}\n.pbClubColumnTime {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  color: #64748b;\n  font-size: 13px;\n}\n.pbClubColumnTime span {\n  color: #94a3b8;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.pbClubColumnActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.pbColumnIconButton,\n.cpIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: 7px;\n  background: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n}\n.pbClubStatsPanel {\n  margin-top: 11px;\n  padding: 10px 11px;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: 10px;\n  background: #f8fafc;\n}\n.pbClubStatsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n.pbClubStat {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.pbClubStat em {\n  color: #94a3b8;\n  font-size: 10.5px;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n.pbClubStat b {\n  color: #0f172a;\n  font-size: 14px;\n  font-weight: 750;\n  font-variant-numeric: tabular-nums;\n}\n.pbClubPendingRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-top: 9px;\n}\n.pbPendingChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid #f2dfa8;\n  border-radius: 999px;\n  background: #fdf6e3;\n  color: #9a6a00;\n  font-size: 11.5px;\n  font-weight: 650;\n}\n.pbOverCapacityNote {\n  margin-top: 8px;\n  padding: 8px 9px;\n  border: 1px solid #fecdd3;\n  border-radius: 8px;\n  background: #fff1f2;\n  color: #be123c;\n  font-size: 12px;\n}\n.pbClubColumnFooterActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 10px;\n}\n.pbColumnFillButton,\n.pbColumnConfirmButton,\n.pbCardActionButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 30px;\n  padding: 0 10px;\n  border-radius: 7px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n.pbColumnFillButton {\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  color: #334155;\n}\n.pbColumnConfirmButton {\n  border: 1px solid #9dd3b0;\n  background: #e7f3ec;\n  color: #1f7a45;\n}\n.pbColumnConfirmButton:disabled,\n.pbColumnFillButton:disabled,\n.pbCardActionButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.pbClubColumnBody {\n  max-height: 620px;\n  overflow-y: auto;\n  padding: 12px;\n  background: #ffffff;\n}\n.pbColumnEmpty,\n.pbEmptyState {\n  color: #64748b;\n  font-size: 13px;\n}\n.pbEmptyState {\n  margin: 16px 28px;\n  padding: 50px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 14px;\n  background: #ffffff;\n  text-align: center;\n}\n\n.cpBookingsCard {\n  padding: 10px 11px;\n  border-radius: 11px;\n  border-color: rgba(15, 23, 42, 0.08);\n  box-shadow: none;\n}\n.cpBookingsCard + .cpBookingsCard {\n  margin-top: 10px;\n}\n.cpBookingsCard--conflict {\n  border-color: #fda4af;\n  background: #fff1f2;\n}\n.cpBookingsCard--selectedClub {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n}\n.cpBookingsCard--selectedWaiting {\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n.cpBookingsCard--confirmedClub {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n.cpBookingsCard--confirmedWaiting {\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n.cpBookingsStudentName {\n  color: #0f172a;\n  font-size: 13.5px;\n  font-weight: 700;\n}\n.cpBookingsMeta {\n  margin-top: 5px;\n  color: #64748b;\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n.cpBookingsSide {\n  gap: 5px;\n}\n.cpBookingsQuickActions {\n  margin-top: 9px;\n  gap: 7px;\n}\n.cpBookingsActions {\n  justify-content: flex-end;\n  gap: 7px;\n  margin-top: 10px;\n  padding-top: 9px;\n}\n.pbBadge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 20px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n.pbBadge--success {\n  background: #dcfce7;\n  color: #166534;\n}\n.pbBadge--info {\n  background: #e0f2fe;\n  color: #075985;\n}\n.pbBadge--warning {\n  background: #fef3c7;\n  color: #92400e;\n}\n.pbBadge--danger {\n  background: #ffe4e6;\n  color: #be123c;\n}\n.pbBadge--muted {\n  background: #e2e8f0;\n  color: #475569;\n}\n.pbBadge--priority {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n.pbCardActionButton {\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  color: #334155;\n}\n.pbCardActionButton--primary {\n  border-color: var(--brand-600, #227ebd);\n  background: var(--brand-600, #227ebd);\n  color: #ffffff;\n}\n.pbCardActionButton--warning {\n  border-color: #f2dfa8;\n  background: #fdf6e3;\n  color: #9a6a00;\n}\n.pbCardActionButton--danger {\n  border-color: #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n.pbCardActionButton--muted {\n  border-color: #cbd5e1;\n  background: #ffffff;\n  color: #475569;\n}\n.pbLockedInline {\n  margin-top: 8px;\n  padding: 8px 9px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 12px;\n}\n\n@media (max-width: 768px) {\n  .pbPageHeader,\n  .pbControlBar,\n  .pbDayTabs,\n  .pbBoardScroll {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .pbInfoBanner,\n  .pbLockedBanner,\n  .pbErrorBanner,\n  .pbTopScroll,\n  .pbEmptyState {\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n  .pbClubColumn {\n    flex-basis: 300px;\n    width: 300px;\n  }\n  .pbControlHint {\n    flex-basis: 100%;\n    margin-left: 0;\n  }\n}\n\n.pbConfirmDayButton span,\n.pbConfirmProgrammeButton span {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  overflow: hidden;\n  color: transparent;\n  font-size: 0;\n}\n\n.pbConfirmDayButton span::before,\n.pbConfirmProgrammeButton span::before {\n  content: '';\n  position: absolute;\n  left: 3px;\n  top: 1px;\n  width: 6px;\n  height: 10px;\n  border: solid currentColor;\n  border-width: 0 2px 2px 0;\n  color: inherit;\n  transform: rotate(45deg);\n}\n\n.pbConfirmDayButton:not(:disabled) span::before {\n  color: #1f7a45;\n}\n\n.pbConfirmProgrammeButton:not(:disabled) span::before {\n  color: #ffffff;\n}\n\n/* Activity programmes — refreshed school list shell. */\n.clubProgrammesRoute {\n  width: 100%;\n  margin-top: 0 !important;\n}\n\n.cpDsPage {\n  display: block;\n  min-width: 0;\n  min-height: calc(100vh - 68px);\n  padding: 0 0 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpDsMain {\n  gap: 18px;\n}\n\n.cpDsHeader {\n  box-sizing: border-box;\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 78px;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 24px;\n  margin: -20px 0 18px -24px;\n  padding: 14px 72px 14px 28px;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n}\n\n.cpDsHeaderTitle {\n  min-width: 220px;\n  flex: 0 0 auto;\n}\n\n.cpDsHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: -0.02em;\n}\n\n.cpDsHeader p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.cpDsToolbar {\n  min-width: 0;\n  flex: 1 1 auto;\n  align-items: center;\n  gap: 9px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.cpDsSearch {\n  width: 230px;\n  min-width: 180px;\n  flex: 0 1 230px;\n}\n\n.cpDsSearch > span {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.cpDsSearch input {\n  height: var(--control-h-md, 40px);\n  border-radius: var(--radius-md, 8px);\n  color: var(--text-strong, #0f172a);\n  font-size: var(--text-md, 14px);\n}\n\n.cpDsSearch input::placeholder {\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpDsBtn,\n.cpDsIconTextBtn {\n  min-height: 40px;\n  height: 40px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n}\n\n.cpDsBtnPrimary {\n  margin-left: auto;\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  box-shadow: none;\n}\n\n.cpDsBtnPrimary:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n\n.cpDsIconTextBtn:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpDsButtonBadge {\n  display: inline-flex;\n  min-width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.cpDsContentCard {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n}\n\n.cpDsActiveFilters {\n  min-height: 44px;\n  padding: 8px 12px;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n}\n\n.cpDsActiveFilters > button span:last-child {\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: var(--blue-700, #155d8c);\n  font-size: 15px;\n  line-height: 1;\n}\n\n.cpDsActiveFilters > button:hover span:last-child {\n  background: rgba(21, 93, 140, 0.1);\n}\n\n.cpDsSelectionBar {\n  min-height: 48px;\n  padding: 8px 12px;\n  border: 0;\n  border-bottom: 1px solid var(--blue-100, #d4e8f6);\n  border-radius: 0;\n  background: var(--blue-50, #eef6fc);\n  box-shadow: none;\n}\n\n.cpDsSelectionBar .cpDsBtn {\n  min-height: 32px;\n  height: 32px;\n  padding: 0 11px;\n  font-size: 12.5px;\n}\n\n.cpDsTableCard {\n  overflow: hidden;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.cpDsTable td {\n  height: 56px;\n}\n\n.cpDsTable tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.cpDsOpenCell {\n  width: 40px;\n  padding-right: 10px !important;\n  padding-left: 6px !important;\n  text-align: center !important;\n}\n\n.cpDsOpenCell span {\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 7px;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 22px;\n  line-height: 1;\n  opacity: 0;\n  transform: translateX(-3px);\n  transition: opacity 120ms ease, transform 120ms ease, background 120ms ease;\n}\n\n.cpDsTable tbody tr:hover .cpDsOpenCell span,\n.cpDsTable tbody tr.isPreview .cpDsOpenCell span {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.cpDsTable tbody tr:hover .cpDsOpenCell span {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpDsFooter {\n  min-height: 58px;\n  margin: 0;\n  padding: 12px 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  justify-content: flex-end;\n  background: var(--surface-card, #fff);\n}\n\n.cpDsPaginationSummary {\n  margin-right: auto;\n}\n\n.cpDsColumnsControl,\n.cpDsFilterControl {\n  z-index: auto;\n}\n\n.cpDsColumnsScrim,\n.cpDsFilterScrim {\n  z-index: 1290;\n}\n\n.cpDsColumnsMenu {\n  z-index: 1300;\n  width: 270px;\n}\n\n.cpDsColumnsMenu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cpDsColumnsMenu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 750;\n  text-transform: none;\n  cursor: pointer;\n}\n\n.cpDsFilterDrawer {\n  z-index: 1300;\n  width: min(420px, 100vw);\n  max-width: none;\n}\n\n.cpDsFilterDrawer > footer button.isApply:hover,\n.cpDsFilterDrawer > footer button.isApply:focus-visible {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n\n.eClubProgrammeForm {\n  width: min(760px, calc(100vw - 48px));\n  padding: 0;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.eCpfCard {\n  width: 100%;\n  max-width: none;\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n}\n\n.eCpfHeader,\n.eCpfFooter {\n  background: var(--surface-card, #fff);\n  border-color: var(--border-subtle, #e2e8f0);\n}\n\n.eCpfTitle {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-weight: 800;\n}\n\n.eCpfLabel {\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.eCpfInputWrap {\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n}\n\n.eCpfInputWrap:focus-within {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.eCpfFooter .btn {\n  min-height: 40px;\n  padding: 0 15px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.eCpfFooter .btn-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.eCpfFooter .btn-primary:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n\n@media (max-width: 1120px) {\n  .cpDsHeader {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .cpDsToolbar {\n    width: 100%;\n    flex-basis: 100%;\n  }\n}\n\n@media (max-width: 720px) {\n  .cpDsPage {\n    padding: 0 0 20px;\n  }\n\n  .cpDsHeader {\n    width: calc(100% + 24px);\n    margin: -20px 0 14px -12px;\n    padding: 14px 16px;\n  }\n\n  .cpDsHeader,\n  .cpDsToolbar,\n  .cpDsFooter {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .cpDsHeaderTitle,\n  .cpDsSearch,\n  .cpDsFilterControl,\n  .cpDsColumnsControl,\n  .cpDsBtnPrimary {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .cpDsBtnPrimary {\n    margin-left: 0;\n  }\n\n  .cpDsPaginationSummary {\n    margin-right: 0;\n    text-align: center;\n  }\n\n  .cpDsFilterDrawer {\n    width: 100%;\n  }\n}\n\n/* Activity programme create / edit page. */\n.cpEditorPage {\n  min-height: calc(100vh - 68px);\n  padding: 0 0 40px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpEditorPageHeader {\n  box-sizing: border-box;\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 84px;\n  align-items: center;\n  gap: 18px;\n  margin: -20px 0 24px -24px;\n  padding: 14px 72px 14px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.cpEditorPageHeader > button {\n  display: inline-flex;\n  min-height: 38px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font: 700 13px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.cpEditorPageHeader > button:hover {\n  color: var(--blue-700, #155d8c);\n  text-decoration: underline;\n}\n\n.cpEditorPageHeader > button > span {\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.cpEditorPageHeader > i {\n  width: 1px;\n  height: 42px;\n  flex: 0 0 1px;\n  background: var(--border-subtle, #e2e8f0);\n}\n\n.cpEditorPageHeader > div {\n  min-width: 0;\n}\n\n.cpEditorPageHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: -0.02em;\n}\n\n.cpEditorPageHeader p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.cpEditorStatus {\n  display: inline-flex;\n  min-height: 26px;\n  align-items: center;\n  margin-left: auto;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.cpEditorStatus.is-active {\n  background: #eaf7ed;\n  color: #217a3a;\n}\n\n.cpEditorStatus.is-archived {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.cpEditorPageBody {\n  width: min(1040px, 100%);\n  margin: 0;\n}\n\n.cpEditorForm {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cpEditorAlert {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 13px 15px;\n  border: 1px solid #b9d8eb;\n  border-radius: 10px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n}\n\n.cpEditorAlert strong {\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.cpEditorAlert.isDanger {\n  border-color: #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.cpEditorSection {\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n}\n\n.cpEditorSection > header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 18px 22px 15px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.cpEditorSection > header > span {\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.cpEditorSection h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 17px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.cpEditorSection header p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n}\n\n.cpEditorGrid,\n.cpEditorAudience {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n  padding: 22px;\n}\n\n.cpEditorField {\n  min-width: 0;\n}\n\n.cpEditorFieldWide {\n  grid-column: 1 / -1;\n}\n\n.cpEditorField > label,\n.cpEditorLabelRow > label {\n  display: block;\n  margin: 0 0 7px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 750;\n  line-height: 1.35;\n}\n\n.cpEditorField > label > span,\n.cpEditorLabelRow > label > span {\n  color: #be123c;\n}\n\n.cpEditorField input:not([type='checkbox']):not([type='radio']),\n.cpEditorField textarea,\n.cpEditorField select,\n.cpEditorField .form-control {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 42px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1) !important;\n  border-radius: var(--radius-md, 8px) !important;\n  outline: 0;\n  background: var(--surface-card, #fff) !important;\n  box-shadow: none !important;\n  color: var(--text-strong, #0f172a) !important;\n  font: 400 14px var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpEditorField textarea {\n  min-height: 96px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  resize: vertical;\n}\n\n.cpEditorField input::placeholder,\n.cpEditorField textarea::placeholder {\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpEditorField input:focus,\n.cpEditorField textarea:focus,\n.cpEditorField select:focus,\n.cpEditorField .form-control:focus {\n  border-color: var(--border-brand, #6fb1df) !important;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18)) !important;\n}\n\n.cpEditorField .isInvalid,\n.cpEditorField .is-invalid {\n  border-color: #e11d48 !important;\n}\n\n.cpEditorError {\n  margin-top: 7px;\n  color: #be123c;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.cpEditorHint {\n  margin: 8px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.cpEditorChoiceCards {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.cpEditorChoiceCardsThree {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.cpEditorChoiceCard {\n  display: flex;\n  min-height: 78px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 4px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  text-align: left;\n  cursor: pointer;\n}\n\n.cpEditorChoiceCard strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.cpEditorChoiceCard span {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.cpEditorChoiceCard:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n}\n\n.cpEditorChoiceCard.isSelected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: inset 3px 0 0 var(--action-primary, #227ebd);\n}\n\n.cpEditorChoiceCard.isSelected strong {\n  color: var(--blue-700, #155d8c);\n}\n\n.cpEditorChoiceCard:disabled,\n.cpEditorChip:disabled,\n.cpEditorSwitchRow:disabled {\n  cursor: not-allowed;\n  opacity: 0.62;\n}\n\n.cpEditorChips {\n  display: flex;\n  min-height: 36px;\n  align-items: center;\n  gap: 8px;\n}\n\n.cpEditorChipsWrap {\n  flex-wrap: wrap;\n}\n\n.cpEditorChip {\n  display: inline-flex;\n  min-height: 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font: 650 12px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.cpEditorChip:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpEditorChip.isSelected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpEditorLabelRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cpEditorTextAction {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font: 700 12px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.cpEditorTextAction:disabled {\n  color: var(--text-subtle, #94a3b8);\n  cursor: not-allowed;\n}\n\n.cpEditorAudience.isDisabled {\n  background: var(--slate-25, #fafbfc);\n}\n\n.cpEditorSwitchRow {\n  display: flex;\n  width: 100%;\n  min-height: 64px;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 13px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--slate-25, #fafbfc);\n  color: var(--text-body, #334155);\n  text-align: left;\n  cursor: pointer;\n}\n\n.cpEditorSwitch {\n  position: relative;\n  width: 38px;\n  height: 22px;\n  flex: 0 0 38px;\n  border-radius: 999px;\n  background: var(--border-default, #cbd5e1);\n  transition: background 140ms ease;\n}\n\n.cpEditorSwitch i {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.24);\n  transition: transform 140ms ease;\n}\n\n.cpEditorSwitchRow.isOn {\n  border-color: #b9d8eb;\n  background: var(--blue-50, #eef6fc);\n}\n\n.cpEditorSwitchRow.isOn .cpEditorSwitch {\n  background: var(--action-primary, #227ebd);\n}\n\n.cpEditorSwitchRow.isOn .cpEditorSwitch i {\n  transform: translateX(16px);\n}\n\n.cpEditorSwitchRow > span:last-child {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cpEditorSwitchRow strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.cpEditorSwitchRow small {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.cpEditorField .eCpfField,\n.cpEditorField .eCpfTwoCols {\n  margin: 0;\n}\n\n.cpEditorField .eCpfTwoCols {\n  gap: 14px;\n}\n\n.cpEditorField .eCpfLabelSmall {\n  margin-bottom: 7px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.cpEditorField .eCpfError {\n  max-width: none;\n  margin-top: 7px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: #be123c;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.cpEditorDateTimePicker {\n  width: 100%;\n}\n\n.cpEditorDateTimePicker .sit-dp__label {\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 750;\n  line-height: 1.35;\n}\n\n.cpEditorDateTimePicker .sit-dp__trigger {\n  box-sizing: border-box;\n  min-height: 42px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: 400 14px var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpEditorDateTimePicker .sit-dp__trigger:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n}\n\n.cpEditorDateTimePicker .sit-dp__pop--centered {\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n}\n\n.cpEditorActions {\n  position: sticky;\n  z-index: 10;\n  bottom: 0;\n  display: flex;\n  min-height: 68px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 13px 18px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.97);\n  box-shadow: 0 -8px 28px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(8px);\n}\n\n.cpEditorActions > span {\n  margin-right: auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.cpEditorActions > span.isDirty {\n  color: var(--amber-700, #a85c07);\n}\n\n.cpEditorButton {\n  display: inline-flex;\n  min-width: 100px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 15px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 8px);\n  font: 700 13px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.cpEditorButton.isSecondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.cpEditorButton.isPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpEditorButton.isPrimary:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n\n.cpEditorButton:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  cursor: not-allowed;\n}\n\n@media (max-width: 820px) {\n  .cpEditorPageHeader {\n    width: calc(100% + 24px);\n    align-items: flex-start;\n    flex-wrap: wrap;\n    margin: -20px 0 18px -12px;\n    padding: 14px 16px;\n  }\n\n  .cpEditorPageHeader > div {\n    flex: 1 1 calc(100% - 190px);\n  }\n\n  .cpEditorStatus {\n    margin-left: 0;\n  }\n\n  .cpEditorGrid,\n  .cpEditorAudience {\n    grid-template-columns: 1fr;\n    padding: 18px;\n  }\n\n  .cpEditorFieldWide {\n    grid-column: auto;\n  }\n\n  .cpEditorChoiceCards,\n  .cpEditorChoiceCardsThree,\n  .cpEditorField .eCpfTwoCols {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .cpEditorPageHeader > i {\n    display: none;\n  }\n\n  .cpEditorPageHeader > button,\n  .cpEditorPageHeader > div {\n    flex: 1 1 100%;\n  }\n\n  .cpEditorSection > header {\n    padding: 16px;\n  }\n\n  .cpEditorActions {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .cpEditorActions > span {\n    flex: 1 1 100%;\n  }\n\n  .cpEditorButton {\n    flex: 1 1 0;\n  }\n}\n\n/* Manage clubs — current design-system alignment. */\n.pcProgrammeClubsPage {\n  min-height: calc(100vh - 68px);\n  overflow: visible;\n  padding: 0 0 40px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.pcProgrammeClubsHeader {\n  box-sizing: border-box;\n  width: calc(100% + 48px);\n  min-height: 106px;\n  margin: -20px 0 0 -24px;\n  padding: 17px 72px 18px 28px;\n  border-color: var(--border-subtle, #e2e8f0);\n}\n\n.pcProgrammeClubsTitle {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 23px;\n  line-height: 1.18;\n  letter-spacing: -0.01em;\n}\n\n.pcProgrammeClubsSubtitle {\n  margin-top: 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 13.5px;\n}\n\n.pcBackLink {\n  margin-bottom: 8px;\n  color: var(--text-link, #1a6da3);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pcBackLink:hover {\n  color: var(--blue-700, #155d8c);\n  text-decoration: underline;\n}\n\n.pcProgrammeClubsBody {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 18px 24px 60px 0;\n}\n\n.pcToolbar,\n.pcSelectionBar,\n.pcCard {\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n}\n\n.pcToolbar {\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);\n}\n\n.pcToolbar--inline {\n  min-height: 68px;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 13px 14px;\n}\n\n.pcToolbarTitle {\n  color: var(--text-strong, #0f172a);\n  font-size: 15px;\n}\n\n.pcToolbarCountChip,\n.pcButtonBadge {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.pcSearchBox {\n  box-sizing: border-box;\n  height: 40px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n}\n\n.pcSearchBox:focus-within {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.pcSearchBox--inline {\n  max-width: 420px;\n}\n\n.pcSearchClear {\n  display: inline-flex;\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font: inherit;\n  font-size: 17px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pcSearchClear:hover {\n  background: var(--border-subtle, #e2e8f0);\n  color: var(--text-strong, #0f172a);\n}\n\n.pcButton {\n  min-height: 40px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pcButton--primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n.pcButton--primary:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n\n.pcButton--secondary {\n  border-color: var(--border-default, #cbd5e1);\n  color: var(--text-body, #334155);\n}\n\n.pcButton--secondary:hover:not(:disabled),\n.pcButton--secondary.isActive {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pcBadge--warning {\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.pcManageFilterControl {\n  height: 40px;\n  align-self: auto;\n}\n\n.pcManageFilterControl .cpDsFilterScrim {\n  z-index: 1390;\n}\n\n.pcManageFilterDrawer {\n  z-index: 1400;\n}\n\n.pcManageFilterControl > .pcButton {\n  height: 40px;\n}\n\n.pcManageFilterDrawer .cpDsFilterFields {\n  gap: 26px;\n}\n\n.pcManageFilterDrawer .cpDsFilterChips {\n  flex-wrap: wrap;\n}\n\n.pcColumnsMenuWrap {\n  z-index: auto;\n}\n\n.pcColumnsMenuWrap.isOpen {\n  z-index: 1300;\n}\n\n.pcColumnsScrim {\n  position: fixed;\n  z-index: 1290;\n  inset: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n\n.pcColumnsMenu {\n  z-index: 1300;\n  top: calc(100% + 8px);\n  width: 270px;\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n}\n\n.pcColumnsMenuWrap.isOpen > .pcButton {\n  position: relative;\n  z-index: 1300;\n}\n\n.pcColumnsMenuWrap.isOpen > .pcColumnsMenu {\n  position: absolute;\n  z-index: 1300;\n}\n\n.pcManageActiveFilters {\n  display: flex;\n  min-height: 42px;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 7px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n}\n\n.pcManageActiveFilters > button:not(.pcManageClearFilters) {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 9px 4px 11px;\n  border: 1px solid #b9d8eb;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font: 650 12px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.pcManageActiveFilters > button:not(.pcManageClearFilters) > span:last-child {\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: var(--text-muted, #64748b);\n  font-size: 15px;\n  line-height: 1;\n}\n\n.pcManageActiveFilters > button:not(.pcManageClearFilters):hover {\n  border-color: var(--action-primary, #227ebd);\n}\n\n.pcManageClearFilters {\n  padding: 4px 7px;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font: 700 12px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.pcCard--flush {\n  overflow: visible;\n  border: 0;\n  background: transparent;\n}\n\n.pcCard--flush .cpDataTableShell {\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);\n}\n\n.pcDataTable th {\n  height: 42px;\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n}\n\n.pcDataTable td {\n  box-sizing: border-box;\n  height: 56px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  border-color: var(--border-subtle, #e2e8f0);\n}\n\n.pcDataTableRow:hover,\n.pcDataTableRow--selected {\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.pcCheckbox {\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.pcStatusDisplay {\n  display: inline-flex;\n}\n\n.pcStatusDisplay.isSaving {\n  opacity: 0.7;\n}\n\n.pcRowActionsButton {\n  opacity: 0;\n  transform: translateX(3px);\n  transition: opacity 120ms ease, transform 120ms ease, border-color 120ms ease, background 120ms ease;\n}\n\n.pcDataTableRow:hover .pcRowActionsButton,\n.pcRowActionsButton.isActive,\n.pcRowActionsButton:focus-visible {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.pcRowActionsButton:hover,\n.pcRowActionsButton.isActive {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pcRowActionMenu {\n  position: fixed;\n  z-index: 2147483000;\n  width: 228px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.pcRowActionMenu > button {\n  display: flex;\n  width: 100%;\n  min-height: 36px;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 9px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  text-align: left;\n  cursor: pointer;\n}\n\n.pcRowActionMenu > button:hover:not(:disabled) {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.pcRowActionMenu > button.isDanger {\n  color: #be123c;\n}\n\n.pcRowActionMenu > button.isDanger:hover:not(:disabled) {\n  background: #fff1f2;\n}\n\n.pcRowActionMenu > button:disabled {\n  color: var(--text-subtle, #94a3b8);\n  cursor: not-allowed;\n}\n\n.pcRowActionMenuDivider {\n  margin: 5px 3px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.pcPagination--pages {\n  min-height: 42px;\n  margin-top: 0;\n}\n\n.pcPaginationSummary {\n  margin-right: auto;\n}\n\n@media (max-width: 900px) {\n  .pcProgrammeClubsHeader {\n    width: calc(100% + 24px);\n    margin: -20px 0 0 -12px;\n    padding: 15px 16px 17px;\n  }\n\n  .pcProgrammeClubsBody {\n    padding: 14px 12px 48px 0;\n  }\n\n  .pcToolbarTitleWrap {\n    flex-basis: 100%;\n  }\n\n  .pcSearchBox--inline {\n    max-width: none;\n  }\n}\n\n@media (max-width: 620px) {\n  .pcProgrammeClubsHeaderMain {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .pcProgrammeClubsHeaderMain > .pcButton {\n    align-self: flex-start;\n  }\n\n  .pcToolbar--inline {\n    align-items: stretch;\n  }\n\n  .pcSearchBox--inline {\n    flex-basis: 100%;\n  }\n\n  .pcManageFilterControl,\n  .pcColumnsMenuWrap {\n    flex: 1 1 0;\n  }\n\n  .pcManageFilterControl > .pcButton,\n  .pcColumnsMenuWrap > .pcButton {\n    width: 100%;\n  }\n\n  .pcSelectionBar,\n  .pcSelectionActions,\n  .pcPagination {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .pcPaginationSummary {\n    flex: 1 1 100%;\n  }\n}\n\n.pcRemoveClubsModal .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: 14px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);\n}\n\n.pcRemoveClubsModal .modal-header {\n  padding: 17px 20px;\n  border-color: var(--border-subtle, #e2e8f0);\n}\n\n.pcRemoveClubsModal .modal-body {\n  padding: 18px 20px 16px;\n}\n\n.pcRemoveClubsContent {\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n}\n\n.pcRemoveClubsIcon {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #fff1f2;\n  color: #be123c;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.pcRemoveClubsContent p {\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 13.5px;\n  line-height: 1.5;\n}\n\n.pcRemoveClubsContent .pcRemoveClubsNote {\n  margin-top: 8px;\n  color: var(--amber-700, #a85c07);\n}\n\n.pcRemoveClubsContent .pcRemoveClubsWarning {\n  margin-top: 8px;\n  color: var(--text-muted, #64748b);\n}\n\n.pcRemoveClubsActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.pcRemoveClubsActions .sit-btn {\n  min-width: 96px;\n  min-height: 38px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pcRemoveClubsConfirm,\n.pcRemoveClubsConfirm:hover:not(:disabled),\n.pcRemoveClubsConfirm:focus-visible {\n  border-color: #be123c;\n  background: #be123c;\n  color: #fff;\n}\n\n/* Programme booking form fields — ProgrammeFields.dc.html */\n.cpProgrammeFieldsPage {\n  min-height: calc(100vh - 68px);\n  padding: 0 0 40px;\n  overflow: visible;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpProgrammeFieldsPageHeader {\n  box-sizing: border-box;\n  width: calc(100% + 48px);\n  min-height: 106px;\n  margin: -20px 0 0 -24px;\n  padding: 17px 72px 17px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.cpProgrammeFieldsBack {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0 0 9px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-600, #1a6da3);\n  font: 700 13px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  cursor: pointer;\n}\n\n.cpProgrammeFieldsBack svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n\n.cpProgrammeFieldsBack:hover,\n.cpProgrammeFieldsBack:focus-visible {\n  color: var(--blue-700, #155d8c);\n  text-decoration: underline;\n}\n\n.cpProgrammeFieldsHeading {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cpProgrammeFieldsHeading h1 {\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 23px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeFieldsStatus {\n  display: inline-flex;\n  min-height: 24px;\n  align-items: center;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.cpProgrammeFieldsStatus.isDraft {\n  border: 1px solid var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.cpProgrammeFieldsStatus.isActive {\n  border: 1px solid #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.cpProgrammeFieldsContext {\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.cpProgrammeFieldsContext::before {\n  margin-right: 8px;\n  color: var(--text-subtle, #94a3b8);\n  content: '·';\n}\n\n.cpProgrammeFieldsPageBody {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 18px 24px 60px 0;\n}\n\n.cpProgrammeFieldsLoadError {\n  width: min(720px, 100%);\n  padding: 16px 18px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fff7f7;\n  color: #991b1b;\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n\n.cpProgrammeFieldsEditor {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cpProgrammeFieldsSummaryBar {\n  display: flex;\n  min-height: 60px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 12px 10px 16px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);\n}\n\n.cpProgrammeFieldsMetrics,\n.cpProgrammeFieldsSummaryActions {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cpProgrammeFieldsMetrics > span:not(.cpProgrammeFieldsSource) {\n  display: inline-flex;\n  min-height: 27px;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.cpProgrammeFieldsMetrics strong {\n  color: var(--text-strong, #0f172a);\n  font-weight: 800;\n}\n\n.cpProgrammeFieldsSource {\n  display: inline-block;\n  max-width: 320px;\n  overflow: hidden;\n  padding-left: 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeFieldsSource strong {\n  color: var(--text-body, #334155);\n}\n\n.cpProgrammeFieldsSummaryActions {\n  flex: 0 0 auto;\n  justify-content: flex-end;\n}\n\n.cpProgrammeFieldsUnsaved {\n  display: inline-flex;\n  min-height: 27px;\n  align-items: center;\n  padding: 4px 9px;\n  border: 1px solid var(--amber-100, #ffe9c2);\n  border-radius: 999px;\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n  font-size: 11.5px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.cpProgrammeFieldsButton {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 13px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font: 750 12.5px var(--font-body, 'Public Sans', system-ui, sans-serif);\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: border-color 140ms ease, background 140ms ease, color 140ms ease, box-shadow 140ms ease;\n}\n\n.cpProgrammeFieldsButton svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.cpProgrammeFieldsButton.isSecondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.cpProgrammeFieldsButton.isSecondary:hover:not(:disabled),\n.cpProgrammeFieldsButton.isSecondary:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.cpProgrammeFieldsButton.isPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpProgrammeFieldsButton.isPrimary:hover:not(:disabled),\n.cpProgrammeFieldsButton.isPrimary:focus-visible {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n}\n\n.cpProgrammeFieldsButton:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.cpProgrammeFieldsError {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 11px 13px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fff7f7;\n  color: #991b1b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.cpProgrammeFieldsError > span {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #fee2e2;\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.cpProgrammeFieldsError p {\n  margin: 0;\n}\n\n.cpProgrammeFieldsBuilder {\n  min-width: 0;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);\n}\n\n.cpProgrammeFieldsBuilder .SendTimeFormEditor {\n  min-width: 0;\n  margin: 0;\n}\n\n.cpProgrammeFieldsBuilder .SendTimeFormEditor__header {\n  margin: 0 0 12px;\n  padding: 8px 10px;\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.cpProgrammeFieldsBuilder .SendTimeFormEditor__templateSelect {\n  min-width: 230px;\n  max-width: 360px;\n  border-color: var(--border-subtle, #e2e8f0);\n  background-color: #fff;\n}\n\n.cpProgrammeFieldsBuilder .FormBuilderV2:not(.FormBuilderV2--compact) {\n  height: min(700px, calc(100vh - 292px));\n  min-height: 520px;\n}\n\n.cpProgrammeFieldsSetup {\n  box-sizing: border-box;\n  width: min(1040px, 100%);\n  margin: 0;\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);\n}\n\n.cpProgrammeFieldsSetupHeading,\n.cpProgrammeFieldsTemplateHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.cpProgrammeFieldsEyebrow {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--blue-700, #155d8c);\n  font-size: 10.5px;\n  font-weight: 850;\n  letter-spacing: 0.065em;\n  text-transform: uppercase;\n}\n\n.cpProgrammeFieldsSetupHeading h2,\n.cpProgrammeFieldsTemplateHeader h3 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-weight: 800;\n}\n\n.cpProgrammeFieldsSetupHeading h2 {\n  font-size: 22px;\n  line-height: 1.25;\n}\n\n.cpProgrammeFieldsTemplateHeader h3 {\n  font-size: 16px;\n  line-height: 1.3;\n}\n\n.cpProgrammeFieldsSetupHeading p,\n.cpProgrammeFieldsTemplateHeader p {\n  margin: 5px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.cpProgrammeFieldsBlankCard {\n  display: flex;\n  width: 100%;\n  min-height: 88px;\n  align-items: center;\n  gap: 14px;\n  margin: 22px 0 25px;\n  padding: 14px 16px;\n  border: 1px dashed var(--border-default, #cbd5e1);\n  border-radius: 11px;\n  background: var(--slate-25, #fafbfc);\n  color: var(--text-body, #334155);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 140ms ease, background 140ms ease, box-shadow 140ms ease;\n}\n\n.cpProgrammeFieldsBlankCard:hover,\n.cpProgrammeFieldsBlankCard:focus-visible {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.1);\n}\n\n.cpProgrammeFieldsBlankIcon,\n.cpProgrammeFieldsTemplateIcon {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  flex: 0 0 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--action-primary, #227ebd);\n}\n\n.cpProgrammeFieldsBlankIcon svg,\n.cpProgrammeFieldsTemplateIcon svg,\n.cpProgrammeFieldsCardArrow {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.cpProgrammeFieldsBlankCard > span:nth-child(2) {\n  display: grid;\n  min-width: 0;\n  flex: 1 1 auto;\n  gap: 4px;\n}\n\n.cpProgrammeFieldsBlankCard strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.cpProgrammeFieldsBlankCard small {\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n\n.cpProgrammeFieldsCardArrow {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpProgrammeFieldsTemplateHeader {\n  align-items: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.cpProgrammeFieldsTemplateSearch {\n  position: relative;\n  display: flex;\n  width: min(320px, 100%);\n  min-height: 38px;\n  align-items: center;\n  margin: 0;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.cpProgrammeFieldsTemplateSearch:focus-within {\n  border-color: var(--action-primary, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.1);\n}\n\n.cpProgrammeFieldsTemplateSearch > svg {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 17px;\n  margin-left: 11px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 1.8;\n}\n\n.cpProgrammeFieldsTemplateSearch input {\n  width: 100%;\n  min-width: 0;\n  height: 36px;\n  padding: 0 34px 0 8px;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #0f172a);\n  font: 500 13px var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpProgrammeFieldsTemplateSearch > button {\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 19px;\n  line-height: 1;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.cpProgrammeFieldsTemplateSearch > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.cpProgrammeFieldsTemplateGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.cpProgrammeFieldsTemplateCard {\n  display: flex;\n  min-height: 178px;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 15px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 11px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease;\n}\n\n.cpProgrammeFieldsTemplateCard:hover:not(:disabled),\n.cpProgrammeFieldsTemplateCard:focus-visible {\n  border-color: var(--action-primary, #227ebd);\n  box-shadow: 0 7px 20px rgba(15, 23, 42, 0.09);\n  transform: translateY(-1px);\n}\n\n.cpProgrammeFieldsTemplateCard:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.cpProgrammeFieldsTemplateCardTop {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.cpProgrammeFieldsDefaultTag {\n  display: inline-flex;\n  min-height: 22px;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.cpProgrammeFieldsTemplateCard > strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeFieldsTemplateCard > small {\n  display: -webkit-box;\n  min-height: 35px;\n  margin-top: 4px;\n  overflow: hidden;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.45;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.cpProgrammeFieldsTemplateMeta {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: auto;\n  padding-top: 12px;\n}\n\n.cpProgrammeFieldsTemplateMeta span {\n  display: inline-flex;\n  min-height: 23px;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 700;\n}\n\n.cpProgrammeFieldsNoTemplates {\n  margin-top: 16px;\n  padding: 25px 18px;\n  border: 1px dashed var(--border-default, #cbd5e1);\n  border-radius: 10px;\n  background: var(--slate-25, #fafbfc);\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  text-align: center;\n}\n\n.cpProgrammeFieldsReadOnly {\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.cpProgrammeFieldsLockedBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--amber-100, #ffe9c2);\n  border-radius: 9px;\n  background: var(--amber-50, #fff6e6);\n}\n\n.cpProgrammeFieldsLockedBanner > span {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 30px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--amber-100, #ffe9c2);\n  color: var(--amber-700, #a85c07);\n}\n\n.cpProgrammeFieldsLockedBanner svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.cpProgrammeFieldsLockedBanner strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.cpProgrammeFieldsLockedBanner p {\n  margin: 3px 0 0;\n  color: var(--amber-700, #a85c07);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.cpProgrammeFieldsReadOnlyList {\n  margin-top: 14px;\n}\n\n@media (max-width: 1180px) {\n  .cpProgrammeFieldsSummaryBar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .cpProgrammeFieldsSummaryActions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 850px) {\n  .cpProgrammeFieldsBuilder .FormBuilderV2:not(.FormBuilderV2--compact) {\n    height: auto;\n    min-height: 0;\n  }\n\n  .cpProgrammeFieldsBuilder .SendTimeFormEditor__header,\n  .cpProgrammeFieldsBuilder .SendTimeFormEditor__titleActions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .cpProgrammeFieldsBuilder .SendTimeFormEditor__actions {\n    justify-content: flex-start;\n  }\n\n  .cpProgrammeFieldsBuilder .SendTimeFormEditor__templateSelect {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n@media (max-width: 720px) {\n  .cpProgrammeFieldsPageHeader {\n    width: calc(100% + 24px);\n    margin-left: -12px;\n    padding-right: 20px;\n    padding-left: 16px;\n  }\n\n  .cpProgrammeFieldsPageBody {\n    padding-right: 12px;\n  }\n\n  .cpProgrammeFieldsSetup {\n    padding: 18px;\n  }\n\n  .cpProgrammeFieldsSetupHeading,\n  .cpProgrammeFieldsTemplateHeader {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .cpProgrammeFieldsTemplateSearch {\n    width: 100%;\n  }\n\n  .cpProgrammeFieldsTemplateGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .cpProgrammeFieldsSource {\n    max-width: 100%;\n    flex-basis: 100%;\n    padding: 3px 0 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .cpProgrammeFieldsHeading h1 {\n    max-width: 100%;\n    flex-basis: 100%;\n  }\n\n  .cpProgrammeFieldsContext::before {\n    display: none;\n  }\n\n  .cpProgrammeFieldsSummaryActions,\n  .cpProgrammeFieldsSummaryActions .cpProgrammeFieldsButton {\n    width: 100%;\n  }\n\n  .cpProgrammeFieldsSummaryActions .cpProgrammeFieldsUnsaved {\n    width: auto;\n  }\n\n  .cpProgrammeFieldsMetrics {\n    align-items: flex-start;\n  }\n\n  .cpProgrammeFieldsBuilder {\n    padding: 8px;\n  }\n}\n\n/* Booking manager — ProgrammeBookings.dc.html alignment. */\n.pbProgrammeBookingsPage {\n  box-sizing: border-box;\n  width: calc(100% + 48px);\n  min-height: calc(100vh - 68px);\n  margin: -20px 0 0 -24px;\n  padding: 0 0 44px;\n  overflow: visible;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.pbProgrammeBookingsPage .pbPageHeader {\n  box-sizing: border-box;\n  min-height: 112px;\n  align-items: center;\n  padding: 17px 72px 17px 28px;\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.pbPageHeaderMain {\n  min-width: 0;\n}\n\n.pbProgrammeBookingsPage .pbBackLink {\n  gap: 5px;\n  margin-bottom: 8px;\n  color: var(--blue-600, #1a6da3);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pbProgrammeBookingsPage .pbBackLink svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n\n.pbProgrammeBookingsPage .pbBackLink:hover,\n.pbProgrammeBookingsPage .pbBackLink:focus-visible {\n  color: var(--blue-700, #155d8c);\n  text-decoration: underline;\n}\n\n.pbProgrammeBookingsPage .pbPageTitleRow {\n  min-width: 0;\n  gap: 8px;\n}\n\n.pbProgrammeBookingsPage .pbPageTitleRow h1 {\n  min-width: 0;\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 23px;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pbProgrammeBookingsPage .pbHeaderStatus,\n.pbHeaderMode {\n  display: inline-flex;\n  min-height: 24px;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 9px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 800;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.pbProgrammeBookingsPage .pbHeaderStatus > span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.pbProgrammeBookingsPage .pbHeaderStatus.isActive {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.pbProgrammeBookingsPage .pbHeaderStatus.isDraft {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.pbProgrammeBookingsPage .pbHeaderStatus.isCompleted {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.pbHeaderMode {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n}\n\n.pbHeaderMode svg {\n  width: 13px;\n  height: 13px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.pbProgrammeBookingsPage .pbPageMeta {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.pbPageHeaderActions {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  align-self: center;\n}\n\n.pbProgrammeBookingsPage .pbHeaderPrimaryButton {\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 750;\n  transition: border-color 140ms ease, background 140ms ease, color 140ms ease;\n}\n\n.pbProgrammeBookingsPage .pbHeaderPrimaryButton svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.pbProgrammeBookingsPage .pbHeaderPrimaryButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbHeaderPrimaryButton:focus-visible {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n}\n\n.pbProgrammeBookingsPage .pbHeaderPrimaryButton:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n}\n\n.pbProgrammeBookingsPage .pbBoardPage {\n  min-height: calc(100vh - 180px);\n  background: var(--surface-page, #f8fafc);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.pbProgrammeBookingsPage .pbControlBar {\n  top: 0;\n  padding: 11px 72px 11px 28px;\n  border-color: var(--border-subtle, #e2e8f0);\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.04);\n  backdrop-filter: blur(8px);\n}\n\n.pbProgrammeBookingsPage .pbControlBarInner {\n  min-height: 36px;\n  gap: 8px;\n}\n\n.pbProgrammeBookingsPage .cpBookingsPendingGroup {\n  gap: 7px;\n}\n\n.pbProgrammeBookingsPage .cpBookingsPendingBadge {\n  min-height: 30px;\n  padding: 4px 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--slate-25, #fafbfc);\n  color: var(--text-body, #334155);\n  font-size: 11.5px;\n  font-weight: 650;\n}\n\n.pbProgrammeBookingsPage .cpBookingsPendingBadge--strong {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.pbProgrammeBookingsPage .cpBookingsPendingBadge b {\n  color: currentColor;\n  font-size: 12px;\n  font-weight: 850;\n}\n\n.pbBoardUpdating {\n  display: inline-flex;\n  min-height: 26px;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsPage .pbControlDivider {\n  background: var(--border-subtle, #e2e8f0);\n}\n\n.pbProgrammeBookingsPage .pbControlLabel {\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 850;\n  letter-spacing: 0.055em;\n}\n\n.pbProgrammeBookingsPage .pbMenuButton,\n.pbProgrammeBookingsPage .pbConfirmDayButton,\n.pbProgrammeBookingsPage .pbConfirmProgrammeButton {\n  min-height: 34px;\n  height: 34px;\n  border-radius: 8px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.pbProgrammeBookingsPage .pbMenuButton {\n  gap: 7px;\n  border-color: var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-body, #334155);\n}\n\n.pbProgrammeBookingsPage .pbMenuButton svg {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n\n.pbProgrammeBookingsPage .pbMenuButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbMenuButton:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pbProgrammeBookingsPage .pbMenuButton:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  opacity: 1;\n}\n\n.pbProgrammeBookingsPage .pbMenuDropdown {\n  z-index: 80;\n  top: calc(100% + 7px);\n  min-width: 220px;\n  padding: 6px;\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);\n}\n\n.pbProgrammeBookingsPage .pbMenuItem {\n  min-height: 36px;\n  padding: 8px 10px;\n  border-radius: 7px;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 650;\n}\n\n.pbProgrammeBookingsPage .pbMenuItem:hover:not(:disabled) {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.pbProgrammeBookingsPage .pbConfirmDayButton {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.pbProgrammeBookingsPage .pbConfirmDayButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbConfirmDayButton:focus-visible {\n  border-color: #86efac;\n  background: #dcfce7;\n  color: #166534;\n}\n\n.pbProgrammeBookingsPage .pbConfirmProgrammeButton {\n  border: 1px solid var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.pbProgrammeBookingsPage .pbConfirmProgrammeButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbConfirmProgrammeButton:focus-visible {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n}\n\n.pbProgrammeBookingsPage .pbConfirmDayButton:disabled,\n.pbProgrammeBookingsPage .pbConfirmProgrammeButton:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n}\n\n.pbProgrammeBookingsPage .pbControlHint {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 11.5px;\n  line-height: 1.35;\n}\n\n.pbProgrammeBookingsPage .pbDayTabs {\n  gap: 7px;\n  padding: 14px 72px 5px 28px;\n}\n\n.pbProgrammeBookingsPage .pbDayTab {\n  min-height: 38px;\n  height: 38px;\n  padding: 0 13px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.pbProgrammeBookingsPage .pbDayTab:hover:not(.pbDayTab--active),\n.pbProgrammeBookingsPage .pbDayTab:focus-visible:not(.pbDayTab--active) {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pbProgrammeBookingsPage .pbDayTab--active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.pbProgrammeBookingsPage .pbDayTabCount,\n.pbProgrammeBookingsPage .pbClubColumnCount {\n  min-width: 20px;\n  height: 20px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsPage .pbDayTab--active .pbDayTabCount {\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n.pbProgrammeBookingsPage .pbInfoBanner,\n.pbProgrammeBookingsPage .pbLockedBanner,\n.pbProgrammeBookingsPage .pbErrorBanner {\n  margin-right: 72px;\n  margin-left: 28px;\n  border-radius: 9px;\n  font-size: 12px;\n}\n\n.pbProgrammeBookingsPage .pbInfoBanner {\n  border-color: #cfe4f5;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pbProgrammeBookingsPage .pbTopScroll {\n  height: 16px;\n  margin-right: 72px;\n  margin-left: 28px;\n}\n\n.pbProgrammeBookingsPage .pbBoardScroll {\n  padding: 12px 72px 28px 28px;\n}\n\n.pbProgrammeBookingsPage .pbBoardColumns {\n  gap: 12px;\n}\n\n.pbProgrammeBookingsPage .pbClubColumn {\n  width: 326px;\n  flex-basis: 326px;\n}\n\n.pbProgrammeBookingsPage .pbClubColumnInner {\n  overflow: visible;\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);\n}\n\n.pbProgrammeBookingsPage .pbClubColumnHeader {\n  padding: 13px;\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 12px 12px 0 0;\n}\n\n.pbProgrammeBookingsPage .pbClubColumnName {\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsPage .pbClubColumnTime {\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n\n.pbProgrammeBookingsPage .pbClubColumnTime svg,\n.pbProgrammeBookingsPage .pbColumnIconButton svg,\n.pbProgrammeBookingsPage .cpIconBtn svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.pbProgrammeBookingsPage .pbColumnIconButton,\n.pbProgrammeBookingsPage .cpIconBtn {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: #fff;\n  color: var(--text-muted, #64748b);\n}\n\n.pbProgrammeBookingsPage .pbColumnIconButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .cpIconBtn:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbColumnIconButton:focus-visible,\n.pbProgrammeBookingsPage .cpIconBtn:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pbProgrammeBookingsPage .pbClubStatsPanel {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.pbProgrammeBookingsPage .pbClubStat em {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 9.5px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsPage .pbClubStat b {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n}\n\n.pbProgrammeBookingsPage .pbPendingChip {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n  font-size: 10.5px;\n}\n\n.pbProgrammeBookingsPage .pbColumnFillButton,\n.pbProgrammeBookingsPage .pbColumnConfirmButton,\n.pbProgrammeBookingsPage .pbCardActionButton {\n  min-height: 31px;\n  border-radius: 7px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 11.5px;\n  font-weight: 750;\n}\n\n.pbProgrammeBookingsPage .pbColumnFillButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbColumnFillButton:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pbProgrammeBookingsPage .pbColumnConfirmButton:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbColumnConfirmButton:focus-visible {\n  border-color: #86efac;\n  background: #dcfce7;\n  color: #166534;\n}\n\n.pbProgrammeBookingsPage .pbClubColumnBody {\n  max-height: min(620px, calc(100vh - 365px));\n  min-height: 240px;\n  padding: 10px;\n  border-radius: 0 0 12px 12px;\n}\n\n.pbProgrammeBookingsPage .cpBookingsCard {\n  padding: 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: #fff;\n}\n\n.pbProgrammeBookingsPage .cpBookingsCard--conflict {\n  border-color: #fda4af;\n  background: #fff7f7;\n}\n\n.pbProgrammeBookingsPage .cpBookingsCard--selectedClub {\n  border-color: #93c5fd;\n  background: #eff6ff;\n}\n\n.pbProgrammeBookingsPage .cpBookingsCard--selectedWaiting,\n.pbProgrammeBookingsPage .cpBookingsCard--confirmedWaiting {\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n\n.pbProgrammeBookingsPage .cpBookingsCard--confirmedClub {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.pbProgrammeBookingsPage .cpBookingsStudentName {\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsPage .cpBookingsMeta {\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n}\n\n.pbProgrammeBookingsPage .pbBadge {\n  min-height: 20px;\n  padding: 2px 7px;\n  font-size: 10px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsPage .pbCardActionButton--primary:hover:not(:disabled),\n.pbProgrammeBookingsPage .pbCardActionButton--primary:focus-visible {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n}\n\n.pbProgrammeBookingsPage .pbEmptyState {\n  margin-right: 72px;\n  margin-left: 28px;\n  padding: 42px 24px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: 12px;\n  background: #fff;\n  color: var(--text-muted, #64748b);\n}\n\n.pbProgrammeBookingsError {\n  box-sizing: border-box;\n  width: min(720px, calc(100% - 56px));\n  margin: 18px 28px;\n  padding: 18px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fff7f7;\n  color: #991b1b;\n}\n\n.pbProgrammeBookingsError strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.pbProgrammeBookingsError p {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n@media (max-width: 1280px) {\n  .pbProgrammeBookingsPage .pbControlHint {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 980px) {\n  .pbProgrammeBookingsPage .pbPageHeader {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pbPageHeaderActions {\n    align-self: flex-start;\n  }\n\n  .pbProgrammeBookingsPage .pbControlBarInner {\n    align-items: flex-start;\n  }\n\n  .pbProgrammeBookingsPage .pbControlDivider {\n    display: none;\n  }\n\n  .pbProgrammeBookingsPage .pbControlLabel {\n    width: 100%;\n    margin-top: 3px;\n  }\n}\n\n@media (max-width: 720px) {\n  .pbProgrammeBookingsPage {\n    width: calc(100% + 24px);\n    margin-left: -12px;\n  }\n\n  .pbProgrammeBookingsPage .pbPageHeader,\n  .pbProgrammeBookingsPage .pbControlBar,\n  .pbProgrammeBookingsPage .pbDayTabs,\n  .pbProgrammeBookingsPage .pbBoardScroll {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .pbProgrammeBookingsPage .pbInfoBanner,\n  .pbProgrammeBookingsPage .pbLockedBanner,\n  .pbProgrammeBookingsPage .pbErrorBanner,\n  .pbProgrammeBookingsPage .pbTopScroll,\n  .pbProgrammeBookingsPage .pbEmptyState {\n    margin-right: 16px;\n    margin-left: 16px;\n  }\n\n  .pbProgrammeBookingsPage .pbPageTitleRow h1 {\n    max-width: 100%;\n    flex-basis: 100%;\n  }\n\n  .pbProgrammeBookingsPage .pbHeaderPrimaryButton {\n    width: 100%;\n  }\n\n  .pbProgrammeBookingsPage .pbClubColumn {\n    width: min(300px, calc(100vw - 54px));\n    flex-basis: min(300px, calc(100vw - 54px));\n  }\n\n  .pbProgrammeBookingsPage .pbClubColumnBody {\n    max-height: none;\n  }\n}\n\n@media (max-width: 520px) {\n  .pbProgrammeBookingsPage .cpBookingsPendingGroup {\n    width: 100%;\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pbProgrammeBookingsPage .pbMenuWrap,\n  .pbProgrammeBookingsPage .pbMenuButton,\n  .pbProgrammeBookingsPage .pbConfirmDayButton,\n  .pbProgrammeBookingsPage .pbConfirmProgrammeButton {\n    width: 100%;\n  }\n\n  .pbProgrammeBookingsPage .pbMenuDropdown {\n    right: auto;\n    left: 0;\n    width: 100%;\n  }\n}\n\n.pbBookingModal .modal-content {\n  max-height: calc(100vh - 48px);\n  overflow: hidden;\n  border: 0;\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.pbBookingModal .modal-header {\n  min-height: 62px;\n  align-items: center;\n  padding: 16px 20px;\n  border-color: var(--border-subtle, #e2e8f0);\n}\n\n.pbBookingModal .modal-title {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.3;\n}\n\n.pbBookingModal .modal-header .close {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border-radius: 8px;\n  color: var(--text-muted, #64748b);\n  opacity: 1;\n}\n\n.pbBookingModal .modal-header .close:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.pbBookingModal .modal-body {\n  min-height: 0;\n  padding: 18px 20px 20px;\n  overflow-y: auto;\n  color: var(--text-body, #334155);\n  font-weight: 400;\n}\n\n.pbBookingModal .modal-body > .p-2 {\n  padding: 0 !important;\n}\n\n.pbBookingModal .modal-footer {\n  gap: 8px;\n  padding: 14px 20px;\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.pbBookingModal .btn,\n.pbBookingModalPrimary {\n  min-height: 38px;\n  margin: 0;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 750;\n  box-shadow: none;\n}\n\n.pbBookingModal .btn-outline-secondary,\n.pbBookingModal .btn-secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-body, #334155);\n}\n\n.pbBookingModal .btn-outline-secondary:hover:not(:disabled),\n.pbBookingModal .btn-secondary:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.pbBookingModal .btn-primary,\n.pbBookingModal .pbBookingModalPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.pbBookingModal .btn-primary:hover:not(:disabled),\n.pbBookingModal .pbBookingModalPrimary:hover:not(:disabled) {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n}\n\n.pbBookingModal .btn:disabled {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  opacity: 1;\n}\n\n.pbBookingModal .badge {\n  min-height: 21px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.pbBookingModal .alert {\n  padding: 11px 13px;\n  border-radius: 9px;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.pbBookingModal .cpClubListsHero,\n.pbBookingModal .cpAnswersHero {\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 11px;\n  background: var(--slate-25, #fafbfc);\n}\n\n.pbBookingModal .cpClubListsHeroTitle,\n.pbBookingModal .cpAnswersHeroTitle {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.pbBookingModal .cpClubListsHeroSubtitle,\n.pbBookingModal .cpAnswersHeroText {\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n}\n\n.pbBookingModal .cpClubListBlock,\n.pbBookingModal .cpAnswerCard {\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  box-shadow: none;\n}\n\n.pbBookingModal .cpClubListTitle,\n.pbBookingModal .cpAnswerHeading {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.pbBookingModal .cpClubListName {\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n}\n\n.pbBookingModal .cpClubListMeta,\n.pbBookingModal .cpAnswerHint {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n}\n\n@media (max-width: 720px) {\n  .pbBookingModal .modal-content {\n    max-height: calc(100vh - 24px);\n  }\n\n  .pbBookingModal .modal-header,\n  .pbBookingModal .modal-body,\n  .pbBookingModal .modal-footer {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n}\n\n/* Activity programme confirmations and status dialogs */\n.cpProgrammeDialog.modal-dialog {\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.cpProgrammeDialog .modal-content {\n  max-height: calc(100vh - 48px) !important;\n  border: 0 !important;\n  border-radius: 14px !important;\n  background: var(--surface-card, #fff) !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24) !important;\n}\n\n.cpProgrammeDialog .modal-header {\n  min-height: 62px;\n  padding: 16px 20px !important;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0) !important;\n  background: var(--surface-card, #fff) !important;\n}\n\n.cpProgrammeDialog .modal-title {\n  color: var(--text-strong, #0f172a) !important;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 18px !important;\n  font-weight: 800 !important;\n  line-height: 1.3 !important;\n}\n\n.cpProgrammeDialog .modal-header .close,\n.cpProgrammeDialog .modal-header > button[aria-label='Close'] {\n  display: inline-flex;\n  width: 34px !important;\n  height: 34px !important;\n  align-items: center;\n  justify-content: center;\n  padding: 0 !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  background: transparent !important;\n  color: var(--text-muted, #64748b) !important;\n  line-height: 1 !important;\n  opacity: 1;\n}\n\n.cpProgrammeDialog .modal-header .close:hover,\n.cpProgrammeDialog .modal-header .close:focus-visible,\n.cpProgrammeDialog .modal-header > button[aria-label='Close']:hover,\n.cpProgrammeDialog .modal-header > button[aria-label='Close']:focus-visible {\n  background: var(--surface-sunken, #f1f5f9) !important;\n  color: var(--text-strong, #0f172a) !important;\n  outline: none;\n}\n\n.cpProgrammeDialog .modal-body.cpProgrammeDialogBody {\n  min-height: 0;\n  padding: 18px 20px 0 !important;\n  overflow-y: auto;\n  color: var(--text-body, #334155) !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n}\n\n.cpProgrammeDialogContent {\n  display: grid;\n  gap: 16px;\n}\n\n.cpProgrammeDialogLead {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--slate-25, #fafbfc);\n}\n\n.cpProgrammeDialogLead.isWarning {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n}\n\n.cpProgrammeDialogLead.isDanger {\n  border-color: #fecdd3;\n  background: #fff1f2;\n}\n\n.cpProgrammeDialogLead.isSuccess {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.cpProgrammeDialogLead.isInfo {\n  border-color: #bfdbfe;\n  background: var(--blue-50, #eef6fc);\n}\n\n.cpProgrammeDialogIcon {\n  display: inline-flex;\n  width: 36px;\n  height: 36px;\n  flex: 0 0 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.cpProgrammeDialogLead.isWarning .cpProgrammeDialogIcon {\n  background: var(--amber-100, #ffe9c2);\n  color: var(--amber-700, #a85c07);\n}\n\n.cpProgrammeDialogLead.isDanger .cpProgrammeDialogIcon {\n  background: #ffe4e6;\n  color: #be123c;\n}\n\n.cpProgrammeDialogLead.isSuccess .cpProgrammeDialogIcon {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.cpProgrammeDialogLead.isInfo .cpProgrammeDialogIcon {\n  background: #dbeafe;\n  color: var(--blue-700, #155d8c);\n}\n\n.cpProgrammeDialogIcon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.cpProgrammeDialogLead > div {\n  min-width: 0;\n}\n\n.cpProgrammeDialogLead strong,\n.cpProgrammeDialogNotice > strong,\n.cpProgrammeDialogSectionHeader > strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-weight: 750;\n}\n\n.cpProgrammeDialogLead strong {\n  margin-bottom: 3px;\n  font-size: 13.5px;\n}\n\n.cpProgrammeDialogLead p,\n.cpProgrammeDialogNotice p,\n.cpProgrammeStatusList p {\n  margin: 0;\n}\n\n.cpProgrammeDialogLead p {\n  color: var(--text-body, #334155);\n}\n\n.cpProgrammeDialogNotice {\n  padding: 13px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--slate-25, #fafbfc);\n}\n\n.cpProgrammeDialogNotice > strong {\n  margin-bottom: 5px;\n  font-size: 12.5px;\n}\n\n.cpProgrammeDialogNotice p {\n  color: var(--text-muted, #64748b);\n}\n\n.cpProgrammeDialogNotice p + p {\n  margin-top: 7px;\n  padding-top: 7px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.cpProgrammeDialogSection {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n}\n\n.cpProgrammeDialogSectionHeader {\n  display: flex;\n  min-height: 42px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 9px 12px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.cpProgrammeDialogSectionHeader > strong {\n  font-size: 12.5px;\n}\n\n.cpProgrammeDialogSectionHeader > span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.cpProgrammeAffectedList {\n  max-height: 176px;\n  overflow-y: auto;\n}\n\n.cpProgrammeAffectedRow {\n  display: flex;\n  min-height: 52px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 9px 12px;\n}\n\n.cpProgrammeAffectedRow + .cpProgrammeAffectedRow {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.cpProgrammeAffectedRow > div {\n  display: grid;\n  min-width: 0;\n  gap: 1px;\n}\n\n.cpProgrammeAffectedRow > div > strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n  font-weight: 750;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeAffectedRow > div > span {\n  overflow: hidden;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpProgrammeAffectedTag {\n  display: inline-flex;\n  min-height: 24px;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 0 8px;\n  border: 1px solid var(--amber-100, #ffe9c2);\n  border-radius: 999px;\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.cpProgrammeStatusList {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n}\n\n.cpProgrammeStatusList > div {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 10px 12px;\n}\n\n.cpProgrammeStatusList > div + div {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.cpProgrammeStatusList > div > span {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #dcfce7;\n  color: #15803d;\n  font-size: 11px;\n  font-weight: 900;\n}\n\n.cpProgrammeStatusList p {\n  padding-top: 1px;\n  color: var(--text-body, #334155);\n}\n\n.cpProgrammeDialogActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin: 0 -20px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.cpProgrammeDialogButton {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 750;\n  line-height: 1;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n\n.cpProgrammeDialogButton.isSecondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.cpProgrammeDialogButton.isSecondary:hover,\n.cpProgrammeDialogButton.isSecondary:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  outline: none;\n}\n\n.cpProgrammeDialogButton.isPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.cpProgrammeDialogButton.isPrimary:hover,\n.cpProgrammeDialogButton.isPrimary:focus-visible {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n  outline: none;\n}\n\n.cpProgrammeDialogButton.isDanger {\n  border-color: #be123c;\n  background: #be123c;\n  color: #fff;\n}\n\n.cpProgrammeDialogButton.isDanger:hover,\n.cpProgrammeDialogButton.isDanger:focus-visible {\n  border-color: #9f1239;\n  background: #9f1239;\n  color: #fff;\n  outline: none;\n}\n\n@media (max-width: 600px) {\n  .cpProgrammeDialog .modal-content {\n    max-height: calc(100vh - 24px) !important;\n  }\n\n  .cpProgrammeDialog .modal-header {\n    min-height: 58px;\n    padding: 13px 16px !important;\n  }\n\n  .cpProgrammeDialog .modal-body.cpProgrammeDialogBody {\n    padding: 14px 16px 0 !important;\n  }\n\n  .cpProgrammeDialogActions {\n    margin-right: -16px;\n    margin-left: -16px;\n    padding: 12px 16px;\n  }\n\n  .cpProgrammeDialogActions .cpProgrammeDialogButton {\n    flex: 1 1 0;\n  }\n\n  .cpProgrammeAffectedRow {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
